function numeralFemaleEnding(condition) {
    const m10 = condition % 10;
    const m100 = condition % 100;

    if (m10 === 1 && m100 !== 11) {
        return condition + "-st";
    }

    if (m10 === 2 && m100 !== 12) {
        return condition + "-nd";
    }

    if (m10 === 3 && m100 !== 13) {
        return condition + "-d";
    }

    return condition + "-th";
}

function numeralMaleEnding(condition) {
    const m10 = condition % 10;
    const m100 = condition % 100;

    if (m10 === 1 && m100 !== 11) {
        return condition + "-st";
    }

    if (m10 === 2 && m100 !== 12) {
        return condition + "-nd";
    }

    if (m10 === 3 && m100 !== 13) {
        return condition + "-d";
    }

    return condition + "-th";
}

function numeralNeuterEnding(condition) {
    const m10 = condition % 10;
    const m100 = condition % 100;

    if (m10 === 1 && m100 !== 11) {
        return condition + "-st";
    }

    if (m10 === 2 && m100 !== 12) {
        return condition + "-nd";
    }

    if (m10 === 3 && m100 !== 13) {
        return condition + "-d";
    }

    return condition + "-th";
}

function plural(count, parameters) {
    return count === 1 ? parameters[0] : parameters[1];
}

function signed(condition) {
    if (condition === 0) {
        return '0';
    }

    const num = Number.parseFloat(condition.toFixed(2));

    if (condition > 0) {
        return '+' + num.toString();
    }

    return num.toString();
}

function europeanHandicapCondition(condition) {
    if (condition < 0) {
        return "0:" + Math.abs(condition);
    }
    else {
        return Math.abs(condition) + ":0";
    }
}

const sl_b1 = (match, outcome) => 'Winner';
const sl_c1 = (match, outcome) => 'Handicap';
const sl_d1 = (match, outcome) => 'Total';
const sl_e1 = (match, outcome) => `Race To ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])}`;
const sl_f1 = (match, outcome) => `To Score ${numeralNeuterEnding(outcome.condition)} Point`;
const sl_g1 = (match, outcome) => `${match.homeTeam} Winning Margin - ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])}`;
const sl_h1 = (match, outcome) => `${match.awayTeam} Winning Margin - ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])}`;
const sl_i1 = (match, outcome) => `${match.homeTeam} Total`;
const sl_j1 = (match, outcome) => `${match.awayTeam} Total`;
const sl_k1 = (match, outcome) => 'Result';
const sl_l1 = (match, outcome) => ' Result';
const sl_m1 = (match, outcome) => ' Handicap';
const sl_n1 = (match, outcome) => ' Total';
const sl_o1 = (match, outcome) => ' Exact Total';
const sl_p1 = (match, outcome) => `${match.homeTeam} Winning Margin`;
const sl_q1 = (match, outcome) => `${match.awayTeam} Winning Margin`;
const sl_r1 = (match, outcome) => `Race To ${outcome.condition}`;
const sl_s1 = (match, outcome) => 'Winning Margin';
const sl_t1 = (match, outcome) => 'First In Match';
const sl_u1 = (match, outcome) => 'Exact Total';
const sl_v1 = (match, outcome) => 'How many teams score?';
const sl_w1 = (match, outcome) => 'Correct Score';
const sl_x1 = (match, outcome) => `Result / Total ${outcome.condition}`;
const sl_y1 = (match, outcome) => 'Even/Odd';
const sl_z1 = (match, outcome) => `${match.homeTeam} Exact total`;
const sl_a2 = (match, outcome) => `${match.awayTeam} Exact total`;
const sl_b2 = (match, outcome) => `To Win ${outcome.condition} Point`;
const sl_c2 = (match, outcome) => `Race to ${outcome.condition} kills`;
const sl_d2 = (match, outcome) => 'First Blood';
const sl_e2 = (match, outcome) => `${match.homeTeam} to win by`;
const sl_f2 = (match, outcome) => `${match.awayTeam} to win by`;
const sl_g2 = (match, outcome) => `${match.homeTeam} To Score`;
const sl_h2 = (match, outcome) => `${match.awayTeam} To Score`;
const sl_i2 = (match, outcome) => 'Teams To Score';
const sl_j2 = (match, outcome) => `${match.homeTeam} Goals`;
const sl_k2 = (match, outcome) => `${match.awayTeam} Goals`;
const sl_l2 = (match, outcome) => 'Injury Time';
const sl_m2 = (match, outcome) => 'Total Even/Odd';
const sl_n2 = (match, outcome) => `European Handicap ${europeanHandicapCondition(outcome.condition)}`;
const sl_o2 = (match, outcome) => `Who Scores ${numeralMaleEnding(outcome.condition)} Goal?`;
const sl_p2 = (match, outcome) => `Rest (current score ${outcome.condition}:${outcome.conditionTwo})`;
const sl_q2 = (match, outcome) => 'Double Chance';
const sl_r2 = (match, outcome) => 'Двойной исход';
const sl_s2 = (match, outcome) => ' Double Chance';
const sl_t2 = (match, outcome) => `${match.homeTeam}  Total`;
const sl_u2 = (match, outcome) => `${match.awayTeam}  Total`;
const sl_v2 = (match, outcome) => 'Full Time Result';
const sl_w2 = (match, outcome) => 'Full Time Handicap';
const sl_x2 = (match, outcome) => 'To Be Corner Kicks From Each Pitch Corner';
const sl_y2 = (match, outcome) => `Total: ${match.homeTeam}`;
const sl_z2 = (match, outcome) => `Total: ${match.awayTeam}`;
const sl_a3 = (match, outcome) => 'Corners';
const sl_b3 = (match, outcome) => 'For Simulation';
const sl_c3 = (match, outcome) => 'For Taken Off T-Shirt';
const sl_d3 = (match, outcome) => 'Exact Score';
const sl_e3 = (match, outcome) => `${match.homeTeam} - ${match.awayTeam}`;
const sl_f3 = (match, outcome) => `Who Scores ${numeralMaleEnding(outcome.condition)} goal?`;
const sl_g3 = (match, outcome) => `Total Penalty Scored: ${match.awayTeam}`;
const sl_h3 = (match, outcome) => `Total Penalty Scored: ${match.homeTeam}`;
const sl_i3 = (match, outcome) => 'Total Penalty Scored';
const sl_j3 = (match, outcome) => 'Total Penalty Missed';
const sl_k3 = (match, outcome) => 'How many teams score';
const sl_l3 = (match, outcome) => 'First Player To Pot';
const sl_m3 = (match, outcome) => 'First Legally Potted Colour';
const sl_n3 = (match, outcome) => `${numeralNeuterEnding(outcome.condition)} Point`;
const sl_o3 = (match, outcome) => `To Be In ${outcome.condition} game`;
const sl_p3 = (match, outcome) => 'Breaks Total';
const sl_q3 = (match, outcome) => `Race To ${outcome.condition} ${plural(outcome.condition, ['Game', 'Games', 'Games'])}`;
const sl_r3 = (match, outcome) => 'Score';
const sl_s3 = (match, outcome) => `Result & Total ${outcome.condition}`;
const sl_t3 = (match, outcome) => 'Tie Break';
const sl_u3 = (match, outcome) => 'Tie Break Winner';
const sl_v3 = (match, outcome) => 'Tie Break Exact Total';
const sl_w3 = (match, outcome) => 'Tie-Break Score';
const sl_x3 = (match, outcome) => 'Tie-Break Total';
const sl_y3 = (match, outcome) => `${match.homeTeam} Breaks Total`;
const sl_z3 = (match, outcome) => `${match.awayTeam} Breaks Total`;
const sl_a4 = (match, outcome) => `A Player To Win ${outcome.condition} ${plural(outcome.condition, ['Game', 'Games', 'Games'])} In A Row`;
const sl_b4 = (match, outcome) => `${match.homeTeam} To Win ${outcome.condition} ${plural(outcome.condition, ['Game', 'Games', 'Games'])} In A Row`;
const sl_c4 = (match, outcome) => `${match.awayTeam} To Win ${outcome.condition} ${plural(outcome.condition, ['Game', 'Games', 'Games'])} In A Row`;
const sl_d4 = (match, outcome) => 'Breaks Result';
const sl_e4 = (match, outcome) => 'Breaks Handicap';
const sl_f4 = (match, outcome) => `Кто выиграет ${numeralNeuterEnding(outcome.condition)} очко`;

const bo_b1 = (match, outcome) => 'Handicap';
const bo_c1 = (match, outcome) => 'Game Total';
const bo_d1 = (match, outcome) => `${match.homeTeam} Total`;
const bo_e1 = (match, outcome) => `${match.awayTeam} Total`;
const bo_f1 = (match, outcome) => 'Game Total Even/Odd';
const bo_g1 = (match, outcome) => `${match.homeTeam} - ${match.awayTeam}`;
const bo_h1 = (match, outcome) => `${outcome.teamOne} - ${outcome.teamTwo}`;
const bo_i1 = (match, outcome) => `${outcome.teamOne}`;
const bo_j1 = (match, outcome) => 'Match Total';
const bo_k1 = (match, outcome) => 'First Game Handicap';
const bo_l1 = (match, outcome) => 'Second Game Handicap';
const bo_m1 = (match, outcome) => 'Third Game Handicap';
const bo_n1 = (match, outcome) => 'First Game Total';
const bo_o1 = (match, outcome) => 'Second Game Total';
const bo_p1 = (match, outcome) => 'Third Game Total';
const bo_q1 = (match, outcome) => 'Total Games In Match';
const bo_r1 = (match, outcome) => 'Match Score';
const bo_s1 = (match, outcome) => 'Match Total Even/Odd';
const bo_t1 = (match, outcome) => 'First Game Winner';
const bo_u1 = (match, outcome) => 'Second Game Winner';
const bo_v1 = (match, outcome) => 'Third Game Winner';
const bo_w1 = (match, outcome) => `${match.homeTeam} First Game Total`;
const bo_x1 = (match, outcome) => `${match.homeTeam} Second Game Total`;
const bo_y1 = (match, outcome) => `${match.homeTeam} Third Game Total`;
const bo_z1 = (match, outcome) => `${match.awayTeam} First Game Total`;
const bo_a2 = (match, outcome) => `${match.awayTeam} Second Game Total`;
const bo_b2 = (match, outcome) => `${match.awayTeam} Third Game Total`;
const bo_c2 = (match, outcome) => `${match.homeTeam} First Game Winning Margin - ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])}`;
const bo_d2 = (match, outcome) => `${match.homeTeam} Second Game Winning Margin - ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])}`;
const bo_e2 = (match, outcome) => `${match.homeTeam} Third Game Winning Margin - ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])}`;
const bo_f2 = (match, outcome) => `${match.awayTeam} First Game Winning Margin - ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])}`;
const bo_g2 = (match, outcome) => `${match.awayTeam} Second Game Winning Margin - ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])}`;
const bo_h2 = (match, outcome) => `${match.awayTeam} Third Game Winning Margin - ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])}`;
const bo_i2 = (match, outcome) => `Race To ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])} - First Game`;
const bo_j2 = (match, outcome) => `Race To ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])} - Second Game`;
const bo_k2 = (match, outcome) => `Race To ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])} - Third Game`;
const bo_l2 = (match, outcome) => `To Score ${numeralNeuterEnding(outcome.condition)} Point - First Game`;
const bo_m2 = (match, outcome) => `To Score ${numeralNeuterEnding(outcome.condition)} Point - Second Game`;
const bo_n2 = (match, outcome) => `To Score ${numeralNeuterEnding(outcome.condition)} Point - Third Game`;
const bo_o2 = (match, outcome) => `${match.homeTeam} Match Total`;
const bo_p2 = (match, outcome) => `${match.awayTeam} Match Total`;
const bo_q2 = (match, outcome) => '10 Points Miniset Winner - First Set';
const bo_r2 = (match, outcome) => '10 Points Miniset Winner - Second Set';
const bo_s2 = (match, outcome) => '10 Points Miniset Winner - Third Set';
const bo_t2 = (match, outcome) => '10 Points Miniset Handicap - First Set';
const bo_u2 = (match, outcome) => '10 Points Miniset Handicap - Second Set';
const bo_v2 = (match, outcome) => '10 Points Miniset Handicap - Third Set';
const bo_w2 = (match, outcome) => '10 Points Miniset Total - First Set';
const bo_x2 = (match, outcome) => '10 Points Miniset Total - Second Set';
const bo_y2 = (match, outcome) => '10 Points Miniset Total - Third Set';
const bo_z2 = (match, outcome) => '15 Points Miniset Winner - First Set';
const bo_a3 = (match, outcome) => '15 Points Miniset Winner - Second Set';
const bo_b3 = (match, outcome) => '15 Points Miniset Winner - Third Set';
const bo_c3 = (match, outcome) => '15 Points Miniset Handicap - First Set';
const bo_d3 = (match, outcome) => '15 Points Miniset Handicap - Second Set';
const bo_e3 = (match, outcome) => '15 Points Miniset Handicap - Third Set';
const bo_f3 = (match, outcome) => '15 Points Miniset Total - First Set';
const bo_g3 = (match, outcome) => '15 Points Miniset Total - Second Set';
const bo_h3 = (match, outcome) => '15 Points Miniset Total - Third Set';
const bo_i3 = (match, outcome) => `${match.homeTeam} First Half Total`;
const bo_j3 = (match, outcome) => 'First Half Handicap';
const bo_k3 = (match, outcome) => 'First Half Result';
const bo_l3 = (match, outcome) => `${match.awayTeam} First Half Total`;
const bo_m3 = (match, outcome) => `Team To Score The ${numeralMaleEnding(outcome.condition)} Goal`;
const bo_n3 = (match, outcome) => 'Double Chance';
const bo_o3 = (match, outcome) => 'First Half Total';
const bo_p3 = (match, outcome) => `Match Result / Total ${outcome.condition}`;
const bo_q3 = (match, outcome) => `${match.homeTeam} Winning Margin - Exactly ${outcome.condition} ${plural(outcome.condition, ['Goal', 'Goals', 'Goals'])}`;
const bo_r3 = (match, outcome) => `${match.awayTeam} Winning Margin - Exactly ${outcome.condition} ${plural(outcome.condition, ['Goal', 'Goals', 'Goals'])}`;
const bo_s3 = (match, outcome) => 'Full Time Exact Total';
const bo_t3 = (match, outcome) => 'Teams To Score';
const bo_u3 = (match, outcome) => 'Full Time Correct Score';
const bo_v3 = (match, outcome) => 'Asian Handicap';
const bo_w3 = (match, outcome) => 'First Quarter Handicap';
const bo_x3 = (match, outcome) => 'Second Quarter Handicap';
const bo_y3 = (match, outcome) => 'Third Quarter Handicap';
const bo_z3 = (match, outcome) => 'Fourth Quarter Handicap';
const bo_a4 = (match, outcome) => 'First Quarter Total';
const bo_b4 = (match, outcome) => 'Second Quarter Total';
const bo_c4 = (match, outcome) => 'Third Quarter Total';
const bo_d4 = (match, outcome) => 'Fourth Quarter Total';
const bo_e4 = (match, outcome) => 'First Quarter Result';
const bo_f4 = (match, outcome) => 'Second Quarter Result';
const bo_g4 = (match, outcome) => 'Third Quarter Result';
const bo_h4 = (match, outcome) => 'Fourth Quarter Result';
const bo_i4 = (match, outcome) => 'Game Total Odd/Even';
const bo_j4 = (match, outcome) => `${match.homeTeam} First Quarter Total`;
const bo_k4 = (match, outcome) => `${match.homeTeam} Second Quarter Total`;
const bo_l4 = (match, outcome) => `${match.homeTeam} Third Quarter Total`;
const bo_m4 = (match, outcome) => `${match.homeTeam} Fourth Quarter Total`;
const bo_n4 = (match, outcome) => `${match.awayTeam} First Quarter Total`;
const bo_o4 = (match, outcome) => `${match.awayTeam} Second Quarter Total`;
const bo_p4 = (match, outcome) => `${match.awayTeam} Third Quarter Total`;
const bo_q4 = (match, outcome) => `${match.awayTeam} Fourth Quarter Total`;
const bo_r4 = (match, outcome) => 'Second Half Result';
const bo_s4 = (match, outcome) => 'Second Half Total';
const bo_t4 = (match, outcome) => 'Second Half Handicap';
const bo_u4 = (match, outcome) => `${match.homeTeam} Second Half Total`;
const bo_v4 = (match, outcome) => `${match.awayTeam} Second Half Total`;
const bo_w4 = (match, outcome) => `Race To ${outcome.condition} ${plural(outcome.condition, ['points', 'points', 'points'])}  In The 1st Quarter`;
const bo_x4 = (match, outcome) => `Race To Score ${outcome.condition} ${plural(outcome.condition, ['points', 'points', 'points'])}  In The 2nd Quarter`;
const bo_y4 = (match, outcome) => `Race To Score ${outcome.condition} ${plural(outcome.condition, ['points', 'points', 'points'])}  In The 3rd Quarter`;
const bo_z4 = (match, outcome) => `Race To Score ${outcome.condition} ${plural(outcome.condition, ['points', 'points', 'points'])}  In The 4th Quarter`;
const bo_a5 = (match, outcome) => 'Game Exact Total';
const bo_b5 = (match, outcome) => 'First Quarter Exact Total';
const bo_c5 = (match, outcome) => 'Second Quarter Exact Total';
const bo_d5 = (match, outcome) => 'Third Quarter Exact Total';
const bo_e5 = (match, outcome) => 'Fourth Quarter Exact Total';
const bo_f5 = (match, outcome) => `${match.homeTeam} Winning Margin`;
const bo_g5 = (match, outcome) => `${match.awayTeam} Winning Margin`;
const bo_h5 = (match, outcome) => 'To Qualify Next Round';
const bo_i5 = (match, outcome) => `${match.homeTeam} To Win All Quarters`;
const bo_j5 = (match, outcome) => `${match.awayTeam} To Win All Quarters`;
const bo_k5 = (match, outcome) => `${match.homeTeam} To Win Both Halves`;
const bo_l5 = (match, outcome) => `${match.awayTeam} To Win Both Halves`;
const bo_m5 = (match, outcome) => 'Highest Scoring Half';
const bo_n5 = (match, outcome) => 'Highest Scoring Quarter';
const bo_o5 = (match, outcome) => 'Highest Scoring Quarter Total';
const bo_p5 = (match, outcome) => 'Lowest Scoring Quarter Total';
const bo_q5 = (match, outcome) => `${match.homeTeam} To Win First Quarter & Game`;
const bo_r5 = (match, outcome) => `${match.awayTeam} To Win First Quarter & Game`;
const bo_s5 = (match, outcome) => `${match.homeTeam} To Win First Half & Game`;
const bo_t5 = (match, outcome) => `${match.awayTeam} To Win First Half & Game`;
const bo_u5 = (match, outcome) => 'Will There Be Overtime?';
const bo_v5 = (match, outcome) => 'Winning Margin';
const bo_w5 = (match, outcome) => `${match.homeTeam} First Quarter Winning Margin`;
const bo_x5 = (match, outcome) => `${match.homeTeam} Second Quarter Winning Margin`;
const bo_y5 = (match, outcome) => `${match.homeTeam} Third Quarter Winning Margin`;
const bo_z5 = (match, outcome) => `${match.homeTeam} Fourth Quarter Winning Margin`;
const bo_a6 = (match, outcome) => `${match.awayTeam} First Quarter Winning Margin`;
const bo_b6 = (match, outcome) => `${match.awayTeam} Second Quarter Winning Margin`;
const bo_c6 = (match, outcome) => `${match.awayTeam} Third Quarter Winning Margin`;
const bo_d6 = (match, outcome) => `${match.awayTeam} Fourth Quarter Winning Margin`;
const bo_e6 = (match, outcome) => `${outcome.playerName} (${match.homeTeam}) Total`;
const bo_f6 = (match, outcome) => `${outcome.playerName} (${match.awayTeam}) Total`;
const bo_g6 = (match, outcome) => '3-Pointers Total';
const bo_h6 = (match, outcome) => '2-Pointers Total';
const bo_i6 = (match, outcome) => `${match.homeTeam} 3-Pointers Total`;
const bo_j6 = (match, outcome) => `${match.awayTeam} 3-Pointers Total`;
const bo_k6 = (match, outcome) => `${match.homeTeam} 2-Pointers Total`;
const bo_l6 = (match, outcome) => `${match.awayTeam} 2-Pointers Total`;
const bo_m6 = (match, outcome) => '3-Pointers Handicap';
const bo_n6 = (match, outcome) => '2-Pointers Handicap';
const bo_o6 = (match, outcome) => '3-Pointers Result';
const bo_p6 = (match, outcome) => '2-Pointers Result';
const bo_q6 = (match, outcome) => 'Lowest Scoring Quarter';
const bo_r6 = (match, outcome) => 'Match Total Assists';
const bo_s6 = (match, outcome) => `${match.homeTeam} Match Total Assists`;
const bo_t6 = (match, outcome) => `${match.awayTeam} Match Total Assists`;
const bo_u6 = (match, outcome) => 'Assists Match Handicap';
const bo_v6 = (match, outcome) => 'Assists Result';
const bo_w6 = (match, outcome) => 'First 2-Pointer In Match';
const bo_x6 = (match, outcome) => 'First 3-Pointer In Match';
const bo_y6 = (match, outcome) => 'First Free Throw In Match';
const bo_z6 = (match, outcome) => 'To Happen First';
const bo_a7 = (match, outcome) => 'Most Points In A Quarter';
const bo_b7 = (match, outcome) => `Race To ${outcome.condition} Points In Match`;
const bo_c7 = (match, outcome) => 'Triple-Double Total In Match';
const bo_d7 = (match, outcome) => 'Double-Double Total In Match';
const bo_e7 = (match, outcome) => `Race To ${outcome.condition} - First Quarter`;
const bo_f7 = (match, outcome) => `Race To ${outcome.condition} - Second Quarter`;
const bo_g7 = (match, outcome) => `Race To ${outcome.condition} - Third Quarter`;
const bo_h7 = (match, outcome) => `Race To ${outcome.condition} - Fourth Quarter`;
const bo_i7 = (match, outcome) => 'Winning Margin 3-Way';
const bo_j7 = (match, outcome) => 'Winning Margin - First Quarter';
const bo_k7 = (match, outcome) => 'Winning Margin - Second Quarter';
const bo_l7 = (match, outcome) => 'Winning Margin - Third Quarter';
const bo_m7 = (match, outcome) => 'Winning Margin - Fourth Quarter';
const bo_n7 = (match, outcome) => 'First Half Exact Total';
const bo_o7 = (match, outcome) => 'Second Half Exact Total';
const bo_p7 = (match, outcome) => `${match.homeTeam} First Half Winning Margin`;
const bo_q7 = (match, outcome) => `${match.homeTeam} Second Half Winning Margin`;
const bo_r7 = (match, outcome) => `${match.awayTeam} First Half Winning Margin`;
const bo_s7 = (match, outcome) => `${match.awayTeam} Second Half Winning Margin`;
const bo_t7 = (match, outcome) => `Race To ${outcome.condition} ${plural(outcome.condition, ['points', 'points', 'points'])}  In The 1st Half`;
const bo_u7 = (match, outcome) => `Race To Score ${outcome.condition} ${plural(outcome.condition, ['points', 'points', 'points'])}  In The 2nd Half`;
const bo_v7 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очков', 'очков'])} в матче`;
const bo_w7 = (match, outcome) => 'Highest Scoring Half Total';
const bo_x7 = (match, outcome) => 'Lowest Scoring Half Total';
const bo_y7 = (match, outcome) => `Race To ${outcome.condition} - First Half`;
const bo_z7 = (match, outcome) => `Race To ${outcome.condition} - Second Half`;
const bo_a8 = (match, outcome) => 'First Period Total';
const bo_b8 = (match, outcome) => 'Second Period Total';
const bo_c8 = (match, outcome) => 'Third Period Total';
const bo_d8 = (match, outcome) => 'First Period Result';
const bo_e8 = (match, outcome) => 'Second Period Result';
const bo_f8 = (match, outcome) => 'Third Period Result';
const bo_g8 = (match, outcome) => 'To Win Match (inc. Penalty Shootouts)';
const bo_h8 = (match, outcome) => 'How many teams score in the 1 period';
const bo_i8 = (match, outcome) => 'How many teams score in the 2 period';
const bo_j8 = (match, outcome) => 'How many teams score in the 3 period';
const bo_k8 = (match, outcome) => 'Period&Match';
const bo_l8 = (match, outcome) => 'Overtime Total';
const bo_m8 = (match, outcome) => 'Overtime Result';
const bo_n8 = (match, outcome) => 'Overtime Handicap';
const bo_o8 = (match, outcome) => 'Final Score';
const bo_p8 = (match, outcome) => 'First Period Handicap';
const bo_q8 = (match, outcome) => 'Second Period Handicap';
const bo_r8 = (match, outcome) => 'Third Period Handicap';
const bo_s8 = (match, outcome) => 'First Period Correct Score';
const bo_t8 = (match, outcome) => 'Second Period Correct Score';
const bo_u8 = (match, outcome) => 'Third Period Correct Score';
const bo_v8 = (match, outcome) => `${numeralMaleEnding(outcome.condition)} Goal`;
const bo_w8 = (match, outcome) => 'First Set Handicap';
const bo_x8 = (match, outcome) => 'Second Set Handicap';
const bo_y8 = (match, outcome) => 'Third Set Handicap';
const bo_z8 = (match, outcome) => 'First Set Total';
const bo_a9 = (match, outcome) => 'Second Set Total';
const bo_b9 = (match, outcome) => 'Third Set Total';
const bo_c9 = (match, outcome) => 'Sets Total';
const bo_d9 = (match, outcome) => `${match.homeTeam} First Set Total`;
const bo_e9 = (match, outcome) => `${match.homeTeam} Second Set Total`;
const bo_f9 = (match, outcome) => `${match.homeTeam} Third Set Total`;
const bo_g9 = (match, outcome) => `${match.awayTeam} First Set Total`;
const bo_h9 = (match, outcome) => `${match.awayTeam} Second Set Total`;
const bo_i9 = (match, outcome) => `${match.awayTeam} Third Set Total`;
const bo_j9 = (match, outcome) => 'First Set Winner';
const bo_k9 = (match, outcome) => 'Second Set Winner';
const bo_l9 = (match, outcome) => 'Third Set Winner';
const bo_m9 = (match, outcome) => `Race To ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])} - First Set`;
const bo_n9 = (match, outcome) => `Race To ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])} - Second Set`;
const bo_o9 = (match, outcome) => `Race To ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])} - Third Set`;
const bo_p9 = (match, outcome) => 'Sets Handicap';
const bo_q9 = (match, outcome) => 'First Set Exact total';
const bo_r9 = (match, outcome) => 'Second Set Exact total';
const bo_s9 = (match, outcome) => 'Third Set Exact total';
const bo_t9 = (match, outcome) => `${match.homeTeam} First Set Winning Margin`;
const bo_u9 = (match, outcome) => `${match.homeTeam} Second Set Winning Margin`;
const bo_v9 = (match, outcome) => `${match.homeTeam} Third Set Winning Margin`;
const bo_w9 = (match, outcome) => `${match.awayTeam} First Set Winning Margin`;
const bo_x9 = (match, outcome) => `${match.awayTeam} Second Set Winning Margin`;
const bo_y9 = (match, outcome) => `${match.awayTeam} Third Set Winning Margin`;
const bo_z9 = (match, outcome) => 'First Set Even/Odd';
const bo_a10 = (match, outcome) => 'Second Set Even/Odd';
const bo_b10 = (match, outcome) => 'Third Set Even/Odd';
const bo_c10 = (match, outcome) => `First Set Result / Total ${outcome.condition}`;
const bo_d10 = (match, outcome) => `Second Set Result / Total ${outcome.condition}`;
const bo_e10 = (match, outcome) => `Third Set Result / Total ${outcome.condition}`;
const bo_f10 = (match, outcome) => 'To Win condition Point - First Set';
const bo_g10 = (match, outcome) => 'To Win condition Point - Second Set';
const bo_h10 = (match, outcome) => 'To Win condition Point - Third Set';
const bo_i10 = (match, outcome) => `Full time Result / Total ${outcome.condition}`;
const bo_j10 = (match, outcome) => 'First Set Winning Margin';
const bo_k10 = (match, outcome) => 'Second Set Winning Margin';
const bo_l10 = (match, outcome) => 'Third Set Winning Margin';
const bo_m10 = (match, outcome) => 'Race Total';
const bo_n10 = (match, outcome) => 'First Fire Line Total';
const bo_o10 = (match, outcome) => 'Second Fire Line Total';
const bo_p10 = (match, outcome) => 'Third Fire Line Total';
const bo_q10 = (match, outcome) => 'Fourth Fire Line Total';
const bo_r10 = (match, outcome) => 'Fifth Fire Line Total';
const bo_s10 = (match, outcome) => 'Sixth Fire Line Total';
const bo_t10 = (match, outcome) => 'Seventh Fire Line Total';
const bo_u10 = (match, outcome) => 'Eighth Fire Line Total';
const bo_v10 = (match, outcome) => `${match.homeTeam} First Fire Line Total`;
const bo_w10 = (match, outcome) => `${match.homeTeam} Second Fire Line Total`;
const bo_x10 = (match, outcome) => `${match.homeTeam} Third Fire Line Total`;
const bo_y10 = (match, outcome) => `${match.homeTeam} Fourth Fire Line Total`;
const bo_z10 = (match, outcome) => `${match.homeTeam} Fifth Fire Line Total`;
const bo_a11 = (match, outcome) => `${match.homeTeam} Sixth Fire Line Total`;
const bo_b11 = (match, outcome) => `${match.homeTeam} Seventh Fire Line Total`;
const bo_c11 = (match, outcome) => `${match.homeTeam} Eighth Fire Line Total`;
const bo_d11 = (match, outcome) => `${match.awayTeam} First Fire Line Total`;
const bo_e11 = (match, outcome) => `${match.awayTeam} Second Fire Line Total`;
const bo_f11 = (match, outcome) => `${match.awayTeam} Third Fire Line Total`;
const bo_g11 = (match, outcome) => `${match.awayTeam} Fourth Fire Line Total`;
const bo_h11 = (match, outcome) => `${match.awayTeam} Fifth Fire Line Total`;
const bo_i11 = (match, outcome) => `${match.awayTeam} Sixth Fire Line Total`;
const bo_j11 = (match, outcome) => `${match.awayTeam} Seventh Fire Line Total`;
const bo_k11 = (match, outcome) => `${match.awayTeam} Eighth Fire Line Total`;
const bo_l11 = (match, outcome) => 'First Fire Line Handicap';
const bo_m11 = (match, outcome) => 'Second Fire Line Handicap';
const bo_n11 = (match, outcome) => 'Third Fire Line Handicap';
const bo_o11 = (match, outcome) => 'Fourth Fire Line Handicap';
const bo_p11 = (match, outcome) => 'Fifth Fire Line Handicap';
const bo_q11 = (match, outcome) => 'Sixth Fire Line Handicap';
const bo_r11 = (match, outcome) => 'Seventh Fire Line Handicap';
const bo_s11 = (match, outcome) => 'Eighth Fire Line Handicap';
const bo_t11 = (match, outcome) => 'First Fire Line Result';
const bo_u11 = (match, outcome) => 'Second Fire Line Result';
const bo_v11 = (match, outcome) => 'Third Fire Line Result';
const bo_w11 = (match, outcome) => 'Fourth Fire Line Result';
const bo_x11 = (match, outcome) => 'Fifth Fire Line Result';
const bo_y11 = (match, outcome) => 'Sixth Fire Line Result';
const bo_z11 = (match, outcome) => 'Seventh Fire Line Result';
const bo_a12 = (match, outcome) => 'Eighth Fire Line Result';
const bo_b12 = (match, outcome) => 'First Fire Line Exact Total';
const bo_c12 = (match, outcome) => 'Second Fire Line Exact Total';
const bo_d12 = (match, outcome) => 'Third Fire Line Exact Total';
const bo_e12 = (match, outcome) => 'Fourth Fire Line Exact Total';
const bo_f12 = (match, outcome) => 'Fifth Fire Line Exact Total';
const bo_g12 = (match, outcome) => 'Sixth Fire Line Exact Total';
const bo_h12 = (match, outcome) => 'Seventh Fire Line Exact Total';
const bo_i12 = (match, outcome) => 'Eighth Fire Line Exact Total';
const bo_j12 = (match, outcome) => 'Will Fight Go The Distance?';
const bo_k12 = (match, outcome) => 'Fight Result';
const bo_l12 = (match, outcome) => 'Round Betting';
const bo_m12 = (match, outcome) => 'Double Outcome';
const bo_n12 = (match, outcome) => 'Total';
const bo_o12 = (match, outcome) => `Who Wins ${outcome.condition} Round?`;
const bo_p12 = (match, outcome) => 'FirstBlood';
const bo_q12 = (match, outcome) => `FirstBlood In ${outcome.condition} Round`;
const bo_r12 = (match, outcome) => `Who Wins ${numeralNeuterEnding(outcome.condition)} Map?`;
const bo_s12 = (match, outcome) => `FirstBlood In ${numeralNeuterEnding(outcome.condition)} Map`;
const bo_t12 = (match, outcome) => `Race To ${outcome.condition} Kills In 1st Map`;
const bo_u12 = (match, outcome) => `Race To ${outcome.condition} Kills In 2nd Map`;
const bo_v12 = (match, outcome) => `Race To ${outcome.condition} Kills In 3rd Map`;
const bo_w12 = (match, outcome) => `Race To ${outcome.condition} Kills In 4th Map`;
const bo_x12 = (match, outcome) => `Race To ${outcome.condition} Kills In 5th Map`;
const bo_y12 = (match, outcome) => 'First Map Result';
const bo_z12 = (match, outcome) => 'Second Map Result';
const bo_a13 = (match, outcome) => 'Third Map Result';
const bo_b13 = (match, outcome) => 'Fourth Map Result';
const bo_c13 = (match, outcome) => 'Fifth Map Result';
const bo_d13 = (match, outcome) => 'First blood In First Map';
const bo_e13 = (match, outcome) => 'First blood In Second Map';
const bo_f13 = (match, outcome) => 'First blood In Third Map';
const bo_g13 = (match, outcome) => 'First blood In Fourth Map';
const bo_h13 = (match, outcome) => 'First blood In Fifth Map';
const bo_i13 = (match, outcome) => 'To Win Match (inc. Shootouts)';
const bo_j13 = (match, outcome) => `Total Of Team Scored ${outcome.conditionTwo}+ Goals`;
const bo_k13 = (match, outcome) => 'Highest Scoring Team Total';
const bo_l13 = (match, outcome) => `Both Halves Total Under ${outcome.condition}`;
const bo_m13 = (match, outcome) => `Both Halves Total Over ${outcome.condition}`;
const bo_n13 = (match, outcome) => 'First Half Total Even/Odd';
const bo_o13 = (match, outcome) => 'Second Half Total Even/Odd';
const bo_p13 = (match, outcome) => `${match.homeTeam} First Half Goals`;
const bo_q13 = (match, outcome) => `${match.homeTeam} Second Half Goals`;
const bo_r13 = (match, outcome) => `${match.awayTeam} First Half Goals`;
const bo_s13 = (match, outcome) => `${match.awayTeam} Second Half Goals`;
const bo_t13 = (match, outcome) => `${match.homeTeam} Full Time Goals`;
const bo_u13 = (match, outcome) => `${match.awayTeam} Full Time Goals`;
const bo_v13 = (match, outcome) => 'Lowest Scoring Team Total';
const bo_w13 = (match, outcome) => `${match.homeTeam} To Score In The First Half Only`;
const bo_x13 = (match, outcome) => `${match.awayTeam} To Score In The First Half Only`;
const bo_y13 = (match, outcome) => `${match.homeTeam} To Score In The Second Half Only`;
const bo_z13 = (match, outcome) => `${match.awayTeam} To Score In The Second Half Only`;
const bo_a14 = (match, outcome) => 'Teams To Score In The First Half';
const bo_b14 = (match, outcome) => 'Teams To Score In The Second Half';
const bo_c14 = (match, outcome) => `Teams To Score Over ${outcome.condition} ${plural(outcome.condition, ['Goal', 'Goals', 'Goals'])}`;
const bo_d14 = (match, outcome) => 'First Goal Method';
const bo_e14 = (match, outcome) => 'Team To Qualify Next Round';
const bo_f14 = (match, outcome) => 'Team To Kick Off';
const bo_g14 = (match, outcome) => 'Either Team To Score Two Goals In A Row';
const bo_h14 = (match, outcome) => `${match.homeTeam} To Win From Behind`;
const bo_i14 = (match, outcome) => `The ${numeralFemaleEnding(outcome.condition)} Yellow Card To Receive`;
const bo_j14 = (match, outcome) => `${match.awayTeam} To Win From Behind`;
const bo_k14 = (match, outcome) => 'First To Happen In Match';
const bo_l14 = (match, outcome) => 'A Player to Score Exacly 2 Goals';
const bo_m14 = (match, outcome) => 'Hat-Trick';
const bo_n14 = (match, outcome) => `Team To Serve ${numeralMaleEnding(outcome.condition)} Corner In The Full Time`;
const bo_o14 = (match, outcome) => `Teams To Score Exactly ${outcome.conditionTwo} ${plural(outcome.conditionTwo, ['Goal', 'Goals', 'Goals'])}`;
const bo_p14 = (match, outcome) => `Both Teams To Score Exactly ${outcome.condition} ${plural(outcome.condition, ['Goal', 'Goalа', 'Goals'])}`;
const bo_q14 = (match, outcome) => 'Last Team To Score';
const bo_r14 = (match, outcome) => 'Own Goal';
const bo_s14 = (match, outcome) => 'Substitute To Score';
const bo_t14 = (match, outcome) => 'Last Goal Minute';
const bo_u14 = (match, outcome) => 'Team To Lift The Cup';
const bo_v14 = (match, outcome) => 'Team To Lift The Super Cup';
const bo_w14 = (match, outcome) => `Half When ${numeralMaleEnding(outcome.condition)} Goal To Score`;
const bo_x14 = (match, outcome) => '1-15th Mins Double Chance';
const bo_y14 = (match, outcome) => '16-30th Mins Double Chance';
const bo_z14 = (match, outcome) => '31st Min - Half Time Double Chance';
const bo_a15 = (match, outcome) => '46-60th Mins Double Chance';
const bo_b15 = (match, outcome) => '61-75th Mins Double Chance';
const bo_c15 = (match, outcome) => '75th Min - Full Time Double Chance';
const bo_d15 = (match, outcome) => `${match.homeTeam} To Score The ${numeralMaleEnding(outcome.condition)} Shootout Penalty`;
const bo_e15 = (match, outcome) => `${match.awayTeam} To Score The ${numeralMaleEnding(outcome.condition)} Shootout Penalty`;
const bo_f15 = (match, outcome) => `${match.homeTeam} To Score The ${numeralMaleEnding(outcome.condition)} Goal`;
const bo_g15 = (match, outcome) => `${match.awayTeam} To Score Its ${numeralMaleEnding(outcome.condition)} Goal`;
const bo_h15 = (match, outcome) => 'First Half Corners';
const bo_i15 = (match, outcome) => 'First Half Yellow Cards';
const bo_j15 = (match, outcome) => 'Full Time Corners Handicap';
const bo_k15 = (match, outcome) => 'First Half Corners Handicap';
const bo_l15 = (match, outcome) => 'Yellow Cards Handicap';
const bo_m15 = (match, outcome) => 'First Half Yellow Cards Handicap';
const bo_n15 = (match, outcome) => 'Full Time Corners Result';
const bo_o15 = (match, outcome) => 'First Half Corners Result';
const bo_p15 = (match, outcome) => 'Full Time Yellow Cards Result';
const bo_q15 = (match, outcome) => 'First Half Yellow Cards Result';
const bo_r15 = (match, outcome) => `Race To Score ${outcome.condition} ${plural(outcome.condition, ['Goal', 'Goals', 'Goals'])} In The Full Time`;
const bo_s15 = (match, outcome) => `${numeralMaleEnding(outcome.condition)} Penalty To Be Missed`;
const bo_t15 = (match, outcome) => 'Full Time Total';
const bo_u15 = (match, outcome) => 'Total Throws-in';
const bo_v15 = (match, outcome) => 'Half Time / Full Time';
const bo_w15 = (match, outcome) => 'Asian Total';
const bo_x15 = (match, outcome) => 'Total Corners';
const bo_y15 = (match, outcome) => 'Full Time Result';
const bo_z15 = (match, outcome) => 'Penalties Total';
const bo_a16 = (match, outcome) => 'Red Cards Total';
const bo_b16 = (match, outcome) => 'First Goal Minute';
const bo_c16 = (match, outcome) => 'Goal Minutes Total';
const bo_d16 = (match, outcome) => 'Total Shots On Target';
const bo_e16 = (match, outcome) => 'Yellow Cards Total';
const bo_f16 = (match, outcome) => '1-15th Mins Handicap';
const bo_g16 = (match, outcome) => '16-30th Mins Handicap';
const bo_h16 = (match, outcome) => '31st Min - Half Time Handicap';
const bo_i16 = (match, outcome) => '46-60th Mins Handicap';
const bo_j16 = (match, outcome) => '61-75th Mins Handicap';
const bo_k16 = (match, outcome) => '76th Min - Full Time';
const bo_l16 = (match, outcome) => `${match.awayTeam} Clean Sheet`;
const bo_m16 = (match, outcome) => `${match.homeTeam} Clean Sheet`;
const bo_n16 = (match, outcome) => 'Substitutions Total';
const bo_o16 = (match, outcome) => 'Full Time Total Even/Odd';
const bo_p16 = (match, outcome) => '1-15th Mins Total';
const bo_q16 = (match, outcome) => '16-30th Mins Total';
const bo_r16 = (match, outcome) => '31st Min - Half Time Total';
const bo_s16 = (match, outcome) => '46-60th Mins Total';
const bo_t16 = (match, outcome) => '61-75th Mins Total';
const bo_u16 = (match, outcome) => '76th Min - Full Time Total';
const bo_v16 = (match, outcome) => `${match.homeTeam} 1-15th Mins Total`;
const bo_w16 = (match, outcome) => `${match.homeTeam} 16-30th Mins Total`;
const bo_x16 = (match, outcome) => `${match.homeTeam} 31st Min - Half Time Total`;
const bo_y16 = (match, outcome) => `${match.homeTeam} 46-60th Mins Total`;
const bo_z16 = (match, outcome) => `${match.homeTeam} 61-75th Mins Total`;
const bo_a17 = (match, outcome) => `${match.homeTeam} 76th Min - Full Time Total`;
const bo_b17 = (match, outcome) => `${match.awayTeam} 1-15th Mins Total`;
const bo_c17 = (match, outcome) => `${match.awayTeam} 16-30th Mins Total`;
const bo_d17 = (match, outcome) => `${match.awayTeam} 31st Min - Half Time Total`;
const bo_e17 = (match, outcome) => `${match.awayTeam} 46-60th Mins Total`;
const bo_f17 = (match, outcome) => `${match.awayTeam} 61-75th Mins Total`;
const bo_g17 = (match, outcome) => `${match.awayTeam} 76th Min - Full Time Total`;
const bo_h17 = (match, outcome) => 'Exact First Half Total';
const bo_i17 = (match, outcome) => 'Exact Second Half Total';
const bo_j17 = (match, outcome) => `${match.homeTeam} To Win To Nil`;
const bo_k17 = (match, outcome) => `${match.awayTeam} To Win To Nil`;
const bo_l17 = (match, outcome) => `${match.homeTeam} To Score Exactly ${outcome.condition} ${plural(outcome.condition, ['Goal', 'Goals', 'Goals'])}`;
const bo_m17 = (match, outcome) => `${match.awayTeam} To Score Exactly ${outcome.condition} ${plural(outcome.condition, ['Goal', 'Goalа', 'Goals'])}`;
const bo_n17 = (match, outcome) => 'First Half Correct Score';
const bo_o17 = (match, outcome) => 'Second Half Correct Score';
const bo_p17 = (match, outcome) => 'Missed Penalties Total';
const bo_q17 = (match, outcome) => `Both Teams To Score Under ${outcome.condition}`;
const bo_r17 = (match, outcome) => `Both Teams To Score Over ${outcome.condition}`;
const bo_s17 = (match, outcome) => 'Half With Most Goals';
const bo_t17 = (match, outcome) => '1-15th Mins Result';
const bo_u17 = (match, outcome) => '16-30th Mins Result';
const bo_v17 = (match, outcome) => '31st Min - Half Time Result';
const bo_w17 = (match, outcome) => '46-60th Mins Result';
const bo_x17 = (match, outcome) => '61-75th Mins Result';
const bo_y17 = (match, outcome) => '75th Min - Full Time Result';
const bo_z17 = (match, outcome) => `${match.homeTeam} To Win Either Half`;
const bo_a18 = (match, outcome) => `${match.awayTeam} To Win Either Half`;
const bo_b18 = (match, outcome) => `Total Of Teams Scored ${outcome.conditionTwo} - ${outcome.conditionThree} Goals `;
const bo_c18 = (match, outcome) => `${outcome.playerName} (${match.homeTeam}) To Score`;
const bo_d18 = (match, outcome) => `${outcome.playerName} (${match.awayTeam}) To Score`;
const bo_e18 = (match, outcome) => 'Games Result';
const bo_f18 = (match, outcome) => 'Games Handicap';
const bo_g18 = (match, outcome) => 'Games Total';
const bo_h18 = (match, outcome) => 'Home Teams Total';
const bo_i18 = (match, outcome) => 'Away Teams Total';
const bo_j18 = (match, outcome) => 'Highest Scoring Match Total';
const bo_k18 = (match, outcome) => 'Lowest Scoring Match Total';
const bo_l18 = (match, outcome) => 'Scoreless Games Total';
const bo_m18 = (match, outcome) => 'Home Teams To Win Total';
const bo_n18 = (match, outcome) => 'Away Teams To Win Total';
const bo_o18 = (match, outcome) => 'Draws Total';
const bo_p18 = (match, outcome) => 'Both Teams To Score: 1st Half&2nd Half';
const bo_q18 = (match, outcome) => `Total ${outcome.condition}/Both Teams To Score`;
const bo_r18 = (match, outcome) => `${match.homeTeam} To Score and Not To Win`;
const bo_s18 = (match, outcome) => `${match.awayTeam} To Score and Not To Win`;
const bo_t18 = (match, outcome) => 'Winning Method';
const bo_u18 = (match, outcome) => 'Injury Time in First Half';
const bo_v18 = (match, outcome) => 'Injury Time in Second Half';
const bo_w18 = (match, outcome) => 'Will Anybody Hit the Goalpost or Crossbar?';
const bo_x18 = (match, outcome) => 'First Substitution time';
const bo_y18 = (match, outcome) => `${match.homeTeam} to Recieve Red Card`;
const bo_z18 = (match, outcome) => `${match.awayTeam}  to Recieve Red Card`;
const bo_a19 = (match, outcome) => 'To Be Penalty an Send Off';
const bo_b19 = (match, outcome) => 'Goal In Injury Time';
const bo_c19 = (match, outcome) => 'Yellow Card For Simulation';
const bo_d19 = (match, outcome) => 'Yellow Card For Taken Off T-Shirt';
const bo_e19 = (match, outcome) => 'To Be Corner Kicks From Each Pitch Corner';
const bo_f19 = (match, outcome) => 'Who Takes 3rd Place?';
const bo_g19 = (match, outcome) => `Total: ${match.awayTeam}  (Extra Time)`;
const bo_h19 = (match, outcome) => `Total: ${match.homeTeam}  (Extra Time)`;
const bo_i19 = (match, outcome) => 'Double Chance (Extra Time)';
const bo_j19 = (match, outcome) => 'Точный счет  (Extra Time)';
const bo_k19 = (match, outcome) => 'Handicap (Extra Time)';
const bo_l19 = (match, outcome) => 'Total (Extra Time)';
const bo_m19 = (match, outcome) => `${match.homeTeam} - ${match.awayTeam} (Extra Time)`;
const bo_n19 = (match, outcome) => `Who Scores ${numeralMaleEnding(outcome.condition)} goal?`;
const bo_o19 = (match, outcome) => 'Handicap - First Extra Time';
const bo_p19 = (match, outcome) => 'First Extra Time Total';
const bo_q19 = (match, outcome) => 'First Extra Time Result';
const bo_r19 = (match, outcome) => 'Handicap - Second Extra Time';
const bo_s19 = (match, outcome) => 'Second Extra Time Total';
const bo_t19 = (match, outcome) => 'Second Extra Time Result';
const bo_u19 = (match, outcome) => 'Shoot-out Correct Score';
const bo_v19 = (match, outcome) => `Total Penalty Scored: ${match.awayTeam} (Shoot-out)`;
const bo_w19 = (match, outcome) => `Total Penalty Scored: ${match.homeTeam} (Shoot-out)`;
const bo_x19 = (match, outcome) => 'Total Penalty Scored (Shoot-out)';
const bo_y19 = (match, outcome) => 'Total Penalty Missed (Shoot-out)';
const bo_z19 = (match, outcome) => `European Handicap ${europeanHandicapCondition(outcome.condition)}`;
const bo_a20 = (match, outcome) => `European Handicap ${europeanHandicapCondition(outcome.condition)} - First Half`;
const bo_b20 = (match, outcome) => `European Handicap ${europeanHandicapCondition(outcome.condition)} - Second Half`;
const bo_c20 = (match, outcome) => `Who Scores ${numeralMaleEnding(outcome.condition)} Goal - First Half?`;
const bo_d20 = (match, outcome) => `Rest Of Game (current score ${outcome.condition}:${outcome.conditionTwo})`;
const bo_e20 = (match, outcome) => `Rest Of First Half (current score ${outcome.condition}:${outcome.conditionTwo})`;
const bo_f20 = (match, outcome) => `First Corners Half Total: ${match.homeTeam}`;
const bo_g20 = (match, outcome) => `First Corners Half Total: ${match.awayTeam}`;
const bo_h20 = (match, outcome) => `Corners Total: ${match.homeTeam}`;
const bo_i20 = (match, outcome) => `Corners Total: ${match.awayTeam}`;
const bo_j20 = (match, outcome) => 'First Half Double Chance';
const bo_k20 = (match, outcome) => 'Second Half Double Chance';
const bo_l20 = (match, outcome) => 'Both To Score?';
const bo_m20 = (match, outcome) => `Both Teams To Score ${outcome.conditionTwo} And More Goals (Their Total)`;
const bo_n20 = (match, outcome) => 'First Half Even/Odd';
const bo_o20 = (match, outcome) => 'Second Half Even/Odd';
const bo_p20 = (match, outcome) => `${match.homeTeam} To Score In The First Half`;
const bo_q20 = (match, outcome) => `${match.homeTeam} To Score In The Second Half`;
const bo_r20 = (match, outcome) => `${match.awayTeam} To Score In The First Half`;
const bo_s20 = (match, outcome) => `${match.awayTeam} To Score In The Second Half`;
const bo_t20 = (match, outcome) => `Teams To Score Over ${outcome.condition} ${plural(outcome.condition, ['goal', 'Goals', 'Goals'])}`;
const bo_u20 = (match, outcome) => `Teams To Score Exactly ${outcome.conditionTwo} ${plural(outcome.conditionTwo, ['goal', 'Goals', 'Goals'])} (Their Total)`;
const bo_v20 = (match, outcome) => 'Match (Full Time) Total';
const bo_w20 = (match, outcome) => 'Half Time / Match (Full Time)';
const bo_x20 = (match, outcome) => 'Match (Full Time) Correct Score';
const bo_y20 = (match, outcome) => 'Match (Full Time) Exact Total';
const bo_z20 = (match, outcome) => 'Match (Full Time) Draw';
const bo_a21 = (match, outcome) => 'Total Penalties';
const bo_b21 = (match, outcome) => 'Total Red Cards';
const bo_c21 = (match, outcome) => 'Total Goal Minutes';
const bo_d21 = (match, outcome) => 'Total Yellow Cards';
const bo_e21 = (match, outcome) => '1-15th Min Handicap';
const bo_f21 = (match, outcome) => '16-30th Min Handicap';
const bo_g21 = (match, outcome) => '46-60th Min Handicap';
const bo_h21 = (match, outcome) => '61-75th Min Handicap';
const bo_i21 = (match, outcome) => `${match.homeTeam} To Score`;
const bo_j21 = (match, outcome) => `${match.awayTeam} To Score`;
const bo_k21 = (match, outcome) => 'Total Substitutions';
const bo_l21 = (match, outcome) => 'Match (Full Time) Total Even/Odd';
const bo_m21 = (match, outcome) => '1-15th Min Total';
const bo_n21 = (match, outcome) => '16-30th Min Total';
const bo_o21 = (match, outcome) => '46-60th Min Total';
const bo_p21 = (match, outcome) => '61-75th Min Total';
const bo_q21 = (match, outcome) => `${match.homeTeam} 1-15th Min Total`;
const bo_r21 = (match, outcome) => `${match.homeTeam} 16-30th Min Total`;
const bo_s21 = (match, outcome) => `${match.homeTeam} 46-60th Min Total`;
const bo_t21 = (match, outcome) => `${match.homeTeam} 61-75th Min Total`;
const bo_u21 = (match, outcome) => `${match.awayTeam} 1-15th Min Total`;
const bo_v21 = (match, outcome) => `${match.awayTeam} 16-30th Min Total`;
const bo_w21 = (match, outcome) => `${match.awayTeam} 46-60th Min Total`;
const bo_x21 = (match, outcome) => `${match.awayTeam} 61-75th Min Total`;
const bo_y21 = (match, outcome) => `${match.awayTeam} To Score Exactly ${outcome.condition} ${plural(outcome.condition, ['Goal', 'Goals', 'Goals'])}`;
const bo_z21 = (match, outcome) => 'Total Missed Penalties';
const bo_a22 = (match, outcome) => 'Team To Win 1st-15th Min';
const bo_b22 = (match, outcome) => 'Team To Win 16th-30th Min';
const bo_c22 = (match, outcome) => 'Team To Win 31st Min - Half Time';
const bo_d22 = (match, outcome) => 'Team To Win 46th-60th Min';
const bo_e22 = (match, outcome) => 'Team To Win 61st-75th Min';
const bo_f22 = (match, outcome) => 'Team To Win 75th Min - Full Time';
const bo_g22 = (match, outcome) => `Teams To Score ${outcome.conditionTwo} Through ${outcome.conditionThree} Goals (Total)`;
const bo_h22 = (match, outcome) => `Team To Score The ${numeralMaleEnding(outcome.condition)} goal`;
const bo_i22 = (match, outcome) => 'First Period Exact Total';
const bo_j22 = (match, outcome) => 'Second Period Exact Total';
const bo_k22 = (match, outcome) => `Game Result / Total ${outcome.condition}`;
const bo_l22 = (match, outcome) => `${match.homeTeam} First Period Winning Margin`;
const bo_m22 = (match, outcome) => `${match.homeTeam} Second Period Winning Margin`;
const bo_n22 = (match, outcome) => `${match.awayTeam} First Period Winning Margin`;
const bo_o22 = (match, outcome) => `${match.awayTeam} Second Period Winning Margin`;
const bo_p22 = (match, outcome) => `Team To First Score ${outcome.condition} ${plural(outcome.condition, ['goal', 'goals', 'goals'])}`;
const bo_q22 = (match, outcome) => 'Hat-Tricks Total';
const bo_r22 = (match, outcome) => 'To Win Match (inc. shootouts)';
const bo_s22 = (match, outcome) => `${match.homeTeam} Victory Margin - ${outcome.condition} ${plural(outcome.condition, ['goal', 'goals', 'goals'])}`;
const bo_t22 = (match, outcome) => `${match.awayTeam} Victory Margin - ${outcome.condition} ${plural(outcome.condition, ['goal', 'goals', 'goals'])}`;
const bo_u22 = (match, outcome) => `Teams To Score Over ${outcome.condition} ${plural(outcome.condition, ['goal', 'goals', 'goals'])}`;
const bo_v22 = (match, outcome) => 'First Period Even/Odd';
const bo_w22 = (match, outcome) => 'Second Period Even/Odd';
const bo_x22 = (match, outcome) => 'Third Period Even/Odd';
const bo_y22 = (match, outcome) => 'Highest Scoring Period Total';
const bo_z22 = (match, outcome) => 'Lowest Scoring Period Total';
const bo_a23 = (match, outcome) => 'Third Period Exact Total';
const bo_b23 = (match, outcome) => `${match.homeTeam} First Period Total`;
const bo_c23 = (match, outcome) => `${match.homeTeam} Second Period Total`;
const bo_d23 = (match, outcome) => `${match.homeTeam} Third Period Total`;
const bo_e23 = (match, outcome) => `${match.awayTeam} First Period Total`;
const bo_f23 = (match, outcome) => `${match.awayTeam} Second Period Total`;
const bo_g23 = (match, outcome) => `${match.awayTeam} Third Period Total`;
const bo_h23 = (match, outcome) => 'Overtime';
const bo_i23 = (match, outcome) => 'Both Teams To Score';
const bo_j23 = (match, outcome) => `${match.homeTeam} To Score ${numeralMaleEnding(outcome.condition)} Shootout`;
const bo_k23 = (match, outcome) => `${match.awayTeam} To Score ${numeralMaleEnding(outcome.condition)} Shootout`;
const bo_l23 = (match, outcome) => 'To Win Match (inc. overtime)';
const bo_m23 = (match, outcome) => `${match.homeTeam} to Score Each Period`;
const bo_n23 = (match, outcome) => `${match.awayTeam}  to Score Each Period`;
const bo_o23 = (match, outcome) => 'To Score Each Period';
const bo_p23 = (match, outcome) => 'Highest Scoring Period';
const bo_q23 = (match, outcome) => `${match.homeTeam} to Win One of Periods`;
const bo_r23 = (match, outcome) => `${match.awayTeam} to Win One of Periods`;
const bo_s23 = (match, outcome) => 'Draw to Be One of Periods';
const bo_t23 = (match, outcome) => '1-10 Minutes Result';
const bo_u23 = (match, outcome) => '11-20 Minutes Result';
const bo_v23 = (match, outcome) => '21-30 Minutes Result';
const bo_w23 = (match, outcome) => '31-40 Minutes Result';
const bo_x23 = (match, outcome) => '41-50 Minutes Result';
const bo_y23 = (match, outcome) => '51-60 Minutes Result';
const bo_z23 = (match, outcome) => '1-10 Minutes Handicap';
const bo_a24 = (match, outcome) => '11-20 Minutes Handicap';
const bo_b24 = (match, outcome) => '21-30 Minutes Handicap';
const bo_c24 = (match, outcome) => '31-40 Minutes Handicap';
const bo_d24 = (match, outcome) => '41-50 Minutes Handicap';
const bo_e24 = (match, outcome) => '51-60 Minutes Handicap';
const bo_f24 = (match, outcome) => '1-10 Minutes Total';
const bo_g24 = (match, outcome) => '11-20 Minutes Total';
const bo_h24 = (match, outcome) => '21-30 Minutes Total';
const bo_i24 = (match, outcome) => '31-40 Minutes Total';
const bo_j24 = (match, outcome) => '41-50 Minutes Total';
const bo_k24 = (match, outcome) => '51-60 Minutes Total';
const bo_l24 = (match, outcome) => 'Highest Number Even/Odd';
const bo_m24 = (match, outcome) => 'Lowest Number Even/Odd';
const bo_n24 = (match, outcome) => 'First Number Even/Odd';
const bo_o24 = (match, outcome) => 'Last Number Even/Odd';
const bo_p24 = (match, outcome) => 'First Is Greater Than Last Number';
const bo_q24 = (match, outcome) => 'All Drawn Numbers Even';
const bo_r24 = (match, outcome) => 'All Drawn Numbers Odd';
const bo_s24 = (match, outcome) => 'Two Сonsecutive Numbers To Draw';
const bo_t24 = (match, outcome) => 'Lowest Number';
const bo_u24 = (match, outcome) => 'Highest Number';
const bo_v24 = (match, outcome) => 'Drawn Numbers Total Value';
const bo_w24 = (match, outcome) => `To Draw A Number Divisible By ${outcome.condition}`;
const bo_x24 = (match, outcome) => 'Difference Between The Highest And The Lowest Numbers Drawn';
const bo_y24 = (match, outcome) => 'Odd Numbers Total Value';
const bo_z24 = (match, outcome) => 'Even Numbers Total Value';
const bo_a25 = (match, outcome) => 'First Number';
const bo_b25 = (match, outcome) => 'Second Number';
const bo_c25 = (match, outcome) => 'Third Number';
const bo_d25 = (match, outcome) => 'Fourth Number';
const bo_e25 = (match, outcome) => 'Fifth Number';
const bo_f25 = (match, outcome) => 'Sixth Number';
const bo_g25 = (match, outcome) => 'Seventh Number';
const bo_h25 = (match, outcome) => `At Least One Number Drawn Between ${outcome.condition} - ${outcome.conditionTwo}`;
const bo_i25 = (match, outcome) => 'Lowest And Highest Numbers Drawn Total';
const bo_j25 = (match, outcome) => `${match.homeTeam} to win by Submission`;
const bo_k25 = (match, outcome) => `${match.awayTeam} to win by Submission`;
const bo_l25 = (match, outcome) => `${match.homeTeam} to win by KO/TKO/DQ`;
const bo_m25 = (match, outcome) => `${match.awayTeam} to win by KO/TKO/DQ`;
const bo_n25 = (match, outcome) => 'Medals Total';
const bo_o25 = (match, outcome) => 'Twenty Ninth Frame Result';
const bo_p25 = (match, outcome) => 'Thirtieth Frame Result';
const bo_q25 = (match, outcome) => 'Thirty First Frame Result';
const bo_r25 = (match, outcome) => 'Thirty Second Frame Result';
const bo_s25 = (match, outcome) => 'Thirty Third Frame Result';
const bo_t25 = (match, outcome) => 'Thirty Fourth Frame Result';
const bo_u25 = (match, outcome) => 'Thirty Fifth Frame Result';
const bo_v25 = (match, outcome) => 'Thirty Sixth Frame Result';
const bo_w25 = (match, outcome) => 'Thirty Seventh Frame Result';
const bo_x25 = (match, outcome) => 'Eighteenth Frame Even/Odd';
const bo_y25 = (match, outcome) => 'Nineteenth Frame Even/Odd';
const bo_z25 = (match, outcome) => 'Twentieth Frame Even/Odd';
const bo_a26 = (match, outcome) => 'Twenty First Frame Even/Odd';
const bo_b26 = (match, outcome) => 'Twenty Second Frame Even/Odd';
const bo_c26 = (match, outcome) => 'Twenty Third Frame Even/Odd';
const bo_d26 = (match, outcome) => 'Twenty Fourth Frame Even/Odd';
const bo_e26 = (match, outcome) => 'Twenty Fifth Frame Even/Odd';
const bo_f26 = (match, outcome) => 'Twenty Sixth Frame Even/Odd';
const bo_g26 = (match, outcome) => 'Twenty Seventh Frame Even/Odd';
const bo_h26 = (match, outcome) => 'Twenty Eighth Frame Even/Odd';
const bo_i26 = (match, outcome) => 'Twenty Ninth Frame Even/Odd';
const bo_j26 = (match, outcome) => 'Thirty Frame Even/Odd';
const bo_k26 = (match, outcome) => 'Thirty First Frame Even/Odd';
const bo_l26 = (match, outcome) => 'Thirty Second Frame Even/Odd';
const bo_m26 = (match, outcome) => 'Thirty Third Frame Even/Odd';
const bo_n26 = (match, outcome) => 'Thirty Fourth Frame Even/Odd';
const bo_o26 = (match, outcome) => 'Thirty Fifth Frame Even/Odd';
const bo_p26 = (match, outcome) => 'Thirty Sixth Frame Even/Odd';
const bo_q26 = (match, outcome) => 'Thirty Seventh Frame Even/Odd';
const bo_r26 = (match, outcome) => 'First Legally Potted Colour - First Frame';
const bo_s26 = (match, outcome) => 'First Legally Potted Colour - Second Frame';
const bo_t26 = (match, outcome) => 'First Legally Potted Colour - Third Frame';
const bo_u26 = (match, outcome) => 'First Legally Potted Colour - Fourth Frame';
const bo_v26 = (match, outcome) => 'First Legally Potted Colour - Fifth Frame';
const bo_w26 = (match, outcome) => 'First Legally Potted Colour - Sixth Frame';
const bo_x26 = (match, outcome) => 'First Legally Potted Colour - Seventh Frame';
const bo_y26 = (match, outcome) => 'First Legally Potted Colour - Eighth Frame';
const bo_z26 = (match, outcome) => 'First Legally Potted Colour - Ninth Frame';
const bo_a27 = (match, outcome) => 'First Legally Potted Colour - Tenth Frame';
const bo_b27 = (match, outcome) => 'First Legally Potted Colour - Eleventh Frame';
const bo_c27 = (match, outcome) => 'First Legally Potted Colour - Twelfth Frame';
const bo_d27 = (match, outcome) => 'First Legally Potted Colour - Thirteenth Frame';
const bo_e27 = (match, outcome) => 'First Legally Potted Colour - Fourteenth Frame';
const bo_f27 = (match, outcome) => 'First Legally Potted Colour - Fifteenth Frame';
const bo_g27 = (match, outcome) => 'First Legally Potted Colour - Sixteenth Frame';
const bo_h27 = (match, outcome) => 'First Legally Potted Colour - Seventeenth Frame';
const bo_i27 = (match, outcome) => 'First Legally Potted Colour - Eighteenth Frame';
const bo_j27 = (match, outcome) => 'First Legally Potted Colour - Nineteenth Frame';
const bo_k27 = (match, outcome) => 'First Legally Potted Colour - Twentieth Frame';
const bo_l27 = (match, outcome) => 'First Legally Potted Colour - Twenty First Frame';
const bo_m27 = (match, outcome) => 'First Legally Potted Colour - Twenty Second Frame';
const bo_n27 = (match, outcome) => 'First Legally Potted Colour - Twenty Third Frame';
const bo_o27 = (match, outcome) => 'First Legally Potted Colour - Twenty Fourth Frame';
const bo_p27 = (match, outcome) => 'First Legally Potted Colour - Twenty Fifth Frame';
const bo_q27 = (match, outcome) => 'First Legally Potted Colour - Twenty Sixth Frame';
const bo_r27 = (match, outcome) => 'First Legally Potted Colour - Twenty Seventh Frame';
const bo_s27 = (match, outcome) => 'First Legally Potted Colour - Twenty Eighth Frame';
const bo_t27 = (match, outcome) => 'First Legally Potted Colour - Twenty Ninth Frame';
const bo_u27 = (match, outcome) => 'First Legally Potted Colour - Thirtieth Frame';
const bo_v27 = (match, outcome) => 'First Legally Potted Colour - Thirty First Frame';
const bo_w27 = (match, outcome) => 'First Legally Potted Colour - Thirty Second Frame';
const bo_x27 = (match, outcome) => 'First Legally Potted Colour - Thirty Third Frame';
const bo_y27 = (match, outcome) => 'First Legally Potted Colour - Thirty Fourth Frame';
const bo_z27 = (match, outcome) => 'First Legally Potted Colour - Thirty Fifth Frame';
const bo_a28 = (match, outcome) => 'First Legally Potted Colour - Thirty Sixth Frame';
const bo_b28 = (match, outcome) => 'First Legally Potted Colour - Thirty Seventh Frame';
const bo_c28 = (match, outcome) => 'First Frame Result';
const bo_d28 = (match, outcome) => 'Second Frame Result';
const bo_e28 = (match, outcome) => 'Third Frame Result';
const bo_f28 = (match, outcome) => 'Fourth Frame Result';
const bo_g28 = (match, outcome) => 'Fifth Frame Result';
const bo_h28 = (match, outcome) => 'Sixth Frame Result';
const bo_i28 = (match, outcome) => 'Seventh Frame Result';
const bo_j28 = (match, outcome) => 'Eighth Frame Result';
const bo_k28 = (match, outcome) => 'Ninth Frame Result';
const bo_l28 = (match, outcome) => 'Tenth Frame Result';
const bo_m28 = (match, outcome) => 'Eleventh Frame Result';
const bo_n28 = (match, outcome) => 'Twelfth Frame Result';
const bo_o28 = (match, outcome) => 'Thirteenth Frame Result';
const bo_p28 = (match, outcome) => 'Fourteenth Frame Result';
const bo_q28 = (match, outcome) => 'Fifteenth Frame Result';
const bo_r28 = (match, outcome) => 'Sixteenth Frame Result';
const bo_s28 = (match, outcome) => 'Seventeenth Frame Result';
const bo_t28 = (match, outcome) => 'Eighteenth Frame Result';
const bo_u28 = (match, outcome) => 'Nineteenth Frame Result';
const bo_v28 = (match, outcome) => 'Twentieth Frame Result';
const bo_w28 = (match, outcome) => 'Twenty First Frame Result';
const bo_x28 = (match, outcome) => 'Twenty Second Frame Result';
const bo_y28 = (match, outcome) => 'Twenty Third Frame Result';
const bo_z28 = (match, outcome) => 'Twenty Fourth Frame Result';
const bo_a29 = (match, outcome) => 'Twenty Fifth Frame Result';
const bo_b29 = (match, outcome) => 'Twenty Sixth Frame Result';
const bo_c29 = (match, outcome) => 'Twenty Seventh Frame Result';
const bo_d29 = (match, outcome) => 'Twenty Eighth Frame Result';
const bo_e29 = (match, outcome) => 'First Player To Pot - Seventh Frame';
const bo_f29 = (match, outcome) => 'First Player To Pot - Eighth Frame';
const bo_g29 = (match, outcome) => 'First Player To Pot - Ninth Frame';
const bo_h29 = (match, outcome) => 'First Player To Pot - Tenth Frame';
const bo_i29 = (match, outcome) => 'First Player To Pot - Eleventh Frame';
const bo_j29 = (match, outcome) => 'First Player To Pot - Twelfth Frame';
const bo_k29 = (match, outcome) => 'First Player To Pot - Thirteenth Frame';
const bo_l29 = (match, outcome) => 'First Player To Pot - Fourteenth Frame';
const bo_m29 = (match, outcome) => 'First Player To Pot - Fifteenth Frame';
const bo_n29 = (match, outcome) => 'First Player To Pot - Sixteenth Frame';
const bo_o29 = (match, outcome) => 'First Player To Pot - Seventeenth Frame';
const bo_p29 = (match, outcome) => 'First Player To Pot - Eighteenth Frame';
const bo_q29 = (match, outcome) => 'First Player To Pot - Nineteenth Frame';
const bo_r29 = (match, outcome) => 'First Player To Pot - Twentieth Frame';
const bo_s29 = (match, outcome) => 'First Player To Pot - Twenty First Frame';
const bo_t29 = (match, outcome) => 'First Player To Pot - Twenty Second Frame';
const bo_u29 = (match, outcome) => 'First Player To Pot - Twenty Third Frame';
const bo_v29 = (match, outcome) => 'First Player To Pot - Twenty Fourth Frame';
const bo_w29 = (match, outcome) => 'First Player To Pot - Twenty Fifth Frame';
const bo_x29 = (match, outcome) => 'First Player To Pot - Twenty Sixth Frame';
const bo_y29 = (match, outcome) => 'First Player To Pot - Twenty Seventh Frame';
const bo_z29 = (match, outcome) => 'First Player To Pot - Twenty Eighth Frame';
const bo_a30 = (match, outcome) => 'First Player To Pot - Twenty Ninth Frame';
const bo_b30 = (match, outcome) => 'First Player To Pot - Thirtieth Frame';
const bo_c30 = (match, outcome) => 'First Player To Pot - Thirty First Frame';
const bo_d30 = (match, outcome) => 'First Player To Pot - Thirty Second Frame';
const bo_e30 = (match, outcome) => 'First Player To Pot - Thirty Third Frame';
const bo_f30 = (match, outcome) => 'First Player To Pot - Thirty Fourth Frame';
const bo_g30 = (match, outcome) => 'First Player To Pot - Thirty Fifth Frame';
const bo_h30 = (match, outcome) => 'First Player To Pot - Thirty Sixth Frame';
const bo_i30 = (match, outcome) => 'First Player To Pot - Thirty Seventh Frame';
const bo_j30 = (match, outcome) => `Race To ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])} In The First Frame`;
const bo_k30 = (match, outcome) => `Race To ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])} In The Second Frame`;
const bo_l30 = (match, outcome) => `Race To ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])} In The Third Frame`;
const bo_m30 = (match, outcome) => `Race To ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])} In The Fourth Frame`;
const bo_n30 = (match, outcome) => `Race To ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])} In The Fifth Frame`;
const bo_o30 = (match, outcome) => `Race To ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])} In The Sixth Frame`;
const bo_p30 = (match, outcome) => `Race To ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])} In The Seventh Frame`;
const bo_q30 = (match, outcome) => `Race To ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])} In The Eighth Frame`;
const bo_r30 = (match, outcome) => `Race To ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])} In The Ninth Frame`;
const bo_s30 = (match, outcome) => `Race To ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])} In The Tenth Frame`;
const bo_t30 = (match, outcome) => `Race To ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])} In The Eleventh Frame`;
const bo_u30 = (match, outcome) => `Race To ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])} In The Twelfth Frame`;
const bo_v30 = (match, outcome) => `Race To ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])} In The Thirteenth Frame`;
const bo_w30 = (match, outcome) => `Race To ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])} In The Fourteenth Frame`;
const bo_x30 = (match, outcome) => `Race To ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])} In The Fifteenth Frame`;
const bo_y30 = (match, outcome) => `Race To ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])} In The Sixteenth Frame`;
const bo_z30 = (match, outcome) => `Race To ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])} In The Seventeenth Frame`;
const bo_a31 = (match, outcome) => `Race To ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])} In The Eighteenth Frame`;
const bo_b31 = (match, outcome) => `Race To ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])} In The Nineteenth Frame`;
const bo_c31 = (match, outcome) => `Race To ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])} In The Twentieth Frame`;
const bo_d31 = (match, outcome) => `Race To ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])} In The Twenty First Frame`;
const bo_e31 = (match, outcome) => `Race To ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])} In The Twenty Second Frame`;
const bo_f31 = (match, outcome) => `Race To ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])} In The Twenty Third Frame`;
const bo_g31 = (match, outcome) => `Race To ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])} In The Twenty Fourth Frame`;
const bo_h31 = (match, outcome) => `Race To ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])} In The Twenty Fifth Frame`;
const bo_i31 = (match, outcome) => `Race To ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])} In The Twenty Sixth Frame`;
const bo_j31 = (match, outcome) => `Race To ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])} In The Twenty Seventh Frame`;
const bo_k31 = (match, outcome) => `Race To ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])} In The Twenty Eighth Frame`;
const bo_l31 = (match, outcome) => `Race To ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])} In The Twenty Ninth Frame`;
const bo_m31 = (match, outcome) => `Race To ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])} In The Thirtieth Frame`;
const bo_n31 = (match, outcome) => `Race To ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])} In The Thirty First Frame`;
const bo_o31 = (match, outcome) => `Race To ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])} In The Thirty Second Frame`;
const bo_p31 = (match, outcome) => `Race To ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])} In The Thirty Third Frame`;
const bo_q31 = (match, outcome) => `Race To ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])} In The Thirty Fourth Frame`;
const bo_r31 = (match, outcome) => `Race To ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])} In The Thirty Fifth Frame`;
const bo_s31 = (match, outcome) => `Race To ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])} In The Thirty Sixth Frame`;
const bo_t31 = (match, outcome) => `Race To ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])} In The Thirty Seventh Frame`;
const bo_u31 = (match, outcome) => 'First Frame Even/Odd';
const bo_v31 = (match, outcome) => 'Second Frame Even/Odd';
const bo_w31 = (match, outcome) => 'Third Frame Even/Odd';
const bo_x31 = (match, outcome) => 'Fourth Frame Even/Odd';
const bo_y31 = (match, outcome) => 'Fifth Frame Even/Odd';
const bo_z31 = (match, outcome) => 'Sixth Frame Even/Odd';
const bo_a32 = (match, outcome) => 'Seventh Frame Even/Odd';
const bo_b32 = (match, outcome) => 'Eighth Frame Even/Odd';
const bo_c32 = (match, outcome) => 'Ninth Frame Even/Odd';
const bo_d32 = (match, outcome) => 'Tenth Frame Even/Odd';
const bo_e32 = (match, outcome) => 'Eleventh Frame Even/Odd';
const bo_f32 = (match, outcome) => 'Twelfth Frame Even/Odd';
const bo_g32 = (match, outcome) => 'Thirteenth Frame Even/Odd';
const bo_h32 = (match, outcome) => 'Fourteenth Frame Even/Odd';
const bo_i32 = (match, outcome) => 'Fifteenth Frame Even/Odd';
const bo_j32 = (match, outcome) => 'Sixteenth Frame Even/Odd';
const bo_k32 = (match, outcome) => 'Seventeenth Frame Even/Odd';
const bo_l32 = (match, outcome) => 'Match Century Breaks Total';
const bo_m32 = (match, outcome) => 'First Frame Handicap';
const bo_n32 = (match, outcome) => 'Second Frame Handicap';
const bo_o32 = (match, outcome) => 'Third Frame Handicap';
const bo_p32 = (match, outcome) => 'Fourth Frame Handicap';
const bo_q32 = (match, outcome) => 'Fifth Frame Handicap';
const bo_r32 = (match, outcome) => 'Sixth Frame Handicap';
const bo_s32 = (match, outcome) => 'Seventh Frame Handicap';
const bo_t32 = (match, outcome) => 'Eighth Frame Handicap';
const bo_u32 = (match, outcome) => 'Ninth Frame Handicap';
const bo_v32 = (match, outcome) => 'Tenth Frame Handicap';
const bo_w32 = (match, outcome) => 'Eleventh Frame Handicap';
const bo_x32 = (match, outcome) => 'Twelfth Frame Handicap';
const bo_y32 = (match, outcome) => 'Thirteenth Frame Handicap';
const bo_z32 = (match, outcome) => 'Fourteenth Frame Handicap';
const bo_a33 = (match, outcome) => 'Fifteenth Frame Handicap';
const bo_b33 = (match, outcome) => 'Sixteenth Frame Handicap';
const bo_c33 = (match, outcome) => 'Seventeenth Frame Handicap';
const bo_d33 = (match, outcome) => 'Eighteenth Frame Handicap';
const bo_e33 = (match, outcome) => 'Nineteenth Frame Handicap';
const bo_f33 = (match, outcome) => 'Twentieth Frame Handicap';
const bo_g33 = (match, outcome) => 'Twenty First Frame Handicap';
const bo_h33 = (match, outcome) => 'Twenty Second Frame Handicap';
const bo_i33 = (match, outcome) => 'Twenty Third Frame Handicap';
const bo_j33 = (match, outcome) => 'Twenty Fourth Frame Handicap';
const bo_k33 = (match, outcome) => 'Twenty Fifth Frame Handicap';
const bo_l33 = (match, outcome) => 'Twenty Sixth Frame Handicap';
const bo_m33 = (match, outcome) => 'Twenty Seventh Frame Handicap';
const bo_n33 = (match, outcome) => 'Twenty Eighth Frame Handicap';
const bo_o33 = (match, outcome) => 'Twenty Ninth Frame Handicap';
const bo_p33 = (match, outcome) => 'Thirty Frame Handicap';
const bo_q33 = (match, outcome) => 'Thirty First Frame Handicap';
const bo_r33 = (match, outcome) => 'Thirty Second Frame Handicap';
const bo_s33 = (match, outcome) => 'Thirty Third Frame Handicap';
const bo_t33 = (match, outcome) => 'Thirty Fourth Frame Handicap';
const bo_u33 = (match, outcome) => 'Thirty Fifth Frame Handicap';
const bo_v33 = (match, outcome) => 'Thirty Sixth Frame Handicap';
const bo_w33 = (match, outcome) => 'Thirty Seventh Frame Handicap';
const bo_x33 = (match, outcome) => 'First Frame Total';
const bo_y33 = (match, outcome) => 'Second Frame Total';
const bo_z33 = (match, outcome) => 'Third Frame Total';
const bo_a34 = (match, outcome) => 'Fourth Frame Total';
const bo_b34 = (match, outcome) => 'Fifth Frame Total';
const bo_c34 = (match, outcome) => 'Sixth Frame Total';
const bo_d34 = (match, outcome) => 'Seventh Frame Total';
const bo_e34 = (match, outcome) => 'Eighth Frame Total';
const bo_f34 = (match, outcome) => 'Ninth Frame Total';
const bo_g34 = (match, outcome) => 'Tenth Frame Total';
const bo_h34 = (match, outcome) => 'Eleventh Frame Total';
const bo_i34 = (match, outcome) => 'Twelfth Frame Total';
const bo_j34 = (match, outcome) => 'Thirteenth Frame Total';
const bo_k34 = (match, outcome) => 'Fourteenth Frame Total';
const bo_l34 = (match, outcome) => 'Fifteenth Frame Total';
const bo_m34 = (match, outcome) => 'Sixteenth Frame Total';
const bo_n34 = (match, outcome) => 'Seventeenth Frame Total';
const bo_o34 = (match, outcome) => 'Eighteenth Frame Total';
const bo_p34 = (match, outcome) => 'Nineteenth Frame Total';
const bo_q34 = (match, outcome) => 'Twentieth Frame Total';
const bo_r34 = (match, outcome) => 'Twenty First Frame Total';
const bo_s34 = (match, outcome) => 'Twenty Second Frame Total';
const bo_t34 = (match, outcome) => 'Twenty Third Frame';
const bo_u34 = (match, outcome) => 'Twenty Fourth Frame Total';
const bo_v34 = (match, outcome) => 'Twenty Fifth Frame Total';
const bo_w34 = (match, outcome) => 'Twenty Sixth Frame Total';
const bo_x34 = (match, outcome) => 'Twenty Seventh Frame Total';
const bo_y34 = (match, outcome) => 'Twenty Eighth Frame Total';
const bo_z34 = (match, outcome) => 'Twenty Ninth Frame Total';
const bo_a35 = (match, outcome) => 'Thirtieth Frame Total';
const bo_b35 = (match, outcome) => 'Thirty First Frame Total';
const bo_c35 = (match, outcome) => 'Thirty Second Frame Total';
const bo_d35 = (match, outcome) => 'Thirty Third Frame Total';
const bo_e35 = (match, outcome) => 'Thirty Fourth Frame';
const bo_f35 = (match, outcome) => 'Thirty Fifth Frame Total';
const bo_g35 = (match, outcome) => 'Thirty Sixth Frame Total';
const bo_h35 = (match, outcome) => 'Thirty Seventh Frame Total';
const bo_i35 = (match, outcome) => 'First Player To Pot - First Frame';
const bo_j35 = (match, outcome) => 'First Player To Pot - Second Frame';
const bo_k35 = (match, outcome) => 'First Player To Pot - Third Frame';
const bo_l35 = (match, outcome) => 'First Player To Pot - Fourth Frame';
const bo_m35 = (match, outcome) => 'First Player To Pot - Fifth Frame';
const bo_n35 = (match, outcome) => 'First Player To Pot - Sixth Frame';
const bo_o35 = (match, outcome) => 'Fourth Game Handicap';
const bo_p35 = (match, outcome) => 'Fifth Game Handicap';
const bo_q35 = (match, outcome) => 'Sixth Game Handicap';
const bo_r35 = (match, outcome) => 'Seventh Game Handicap';
const bo_s35 = (match, outcome) => 'Fourth Game Total';
const bo_t35 = (match, outcome) => 'Fifth Game Total';
const bo_u35 = (match, outcome) => 'Sixth Game Total';
const bo_v35 = (match, outcome) => 'Seventh Game Total';
const bo_w35 = (match, outcome) => 'Match Games Total';
const bo_x35 = (match, outcome) => `${match.homeTeam} Fourth Game Total`;
const bo_y35 = (match, outcome) => `${match.homeTeam} Fifth Game Total`;
const bo_z35 = (match, outcome) => `${match.homeTeam} Sixth Game Total`;
const bo_a36 = (match, outcome) => `${match.homeTeam} Seventh Game Total`;
const bo_b36 = (match, outcome) => `${match.awayTeam} Fourth Game Total`;
const bo_c36 = (match, outcome) => `${match.awayTeam} Fifth Game Total`;
const bo_d36 = (match, outcome) => `${match.awayTeam} Sixth Game Total`;
const bo_e36 = (match, outcome) => `${match.awayTeam} Seventh Game Total`;
const bo_f36 = (match, outcome) => `Race To ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])} - Fourth Game`;
const bo_g36 = (match, outcome) => `Race To ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])} - Fifth Game`;
const bo_h36 = (match, outcome) => `Race To ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])} - Sixth Game`;
const bo_i36 = (match, outcome) => `Race To ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])} - Seventh Game`;
const bo_j36 = (match, outcome) => 'Fourth Game Winner';
const bo_k36 = (match, outcome) => 'Fifth Game Winner';
const bo_l36 = (match, outcome) => 'Sixth Game Winner';
const bo_m36 = (match, outcome) => 'Seventh Game Winner';
const bo_n36 = (match, outcome) => `${match.homeTeam} 1st Game Winning Margin - ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])}`;
const bo_o36 = (match, outcome) => `${match.homeTeam} 2nd Game Winning Margin - ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])}`;
const bo_p36 = (match, outcome) => `${match.homeTeam} 3rd Game Winning Margin - ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])}`;
const bo_q36 = (match, outcome) => `${match.homeTeam} 4th Game Winning Margin - ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])}`;
const bo_r36 = (match, outcome) => `${match.homeTeam} 5th Game Winning Margin - ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])}`;
const bo_s36 = (match, outcome) => `${match.homeTeam} 6th Game Winning Margin - ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])}`;
const bo_t36 = (match, outcome) => `${match.homeTeam} 7th Game Winning Margin - ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])}`;
const bo_u36 = (match, outcome) => `${match.awayTeam} 1st Game Winning Margin - ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])}`;
const bo_v36 = (match, outcome) => `${match.awayTeam} 2nd Game Winning Margin - ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])}`;
const bo_w36 = (match, outcome) => `${match.awayTeam} 3rd Game Winning Margin - ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])}`;
const bo_x36 = (match, outcome) => `${match.awayTeam} 4th Game Winning Margin - ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])}`;
const bo_y36 = (match, outcome) => `${match.awayTeam} 5th Game Winning Margin - ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])}`;
const bo_z36 = (match, outcome) => `${match.awayTeam} 6th Game Winning Margin - ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])}`;
const bo_a37 = (match, outcome) => `${match.awayTeam} 7th Game Winning Margin - ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])}`;
const bo_b37 = (match, outcome) => 'First Game Exact Total';
const bo_c37 = (match, outcome) => 'Second Game Exact Total';
const bo_d37 = (match, outcome) => 'Third Game Exact Total';
const bo_e37 = (match, outcome) => 'Fourth Game Exact Total';
const bo_f37 = (match, outcome) => 'Fifth Game Exact Total';
const bo_g37 = (match, outcome) => 'Sixth Game Exact Total';
const bo_h37 = (match, outcome) => 'Seventh Game Exact Total';
const bo_i37 = (match, outcome) => `${numeralNeuterEnding(outcome.condition)} Point - First Game`;
const bo_j37 = (match, outcome) => `${numeralNeuterEnding(outcome.condition)} Point - Second Game`;
const bo_k37 = (match, outcome) => `${numeralNeuterEnding(outcome.condition)} Point - Third Game`;
const bo_l37 = (match, outcome) => `${numeralNeuterEnding(outcome.condition)} Point - Fourth Game`;
const bo_m37 = (match, outcome) => `${numeralNeuterEnding(outcome.condition)} Point - Fifth Game`;
const bo_n37 = (match, outcome) => `${numeralNeuterEnding(outcome.condition)} Point - Sixth Game`;
const bo_o37 = (match, outcome) => `${numeralNeuterEnding(outcome.condition)} Point - Seventh Game`;
const bo_p37 = (match, outcome) => 'Fourth Set Even/Odd';
const bo_q37 = (match, outcome) => 'Fifth Set Even/Odd';
const bo_r37 = (match, outcome) => 'Sixth Set Even/Odd';
const bo_s37 = (match, outcome) => 'Seventh Set Even/Odd';
const bo_t37 = (match, outcome) => 'Match Correct Score';
const bo_u37 = (match, outcome) => `${match.awayTeam} To Break In The 1st or 2-nd Games`;
const bo_v37 = (match, outcome) => 'Games Taken In A Row Total By Player';
const bo_w37 = (match, outcome) => 'Players To Exchange The Breaks';
const bo_x37 = (match, outcome) => `${match.homeTeam} Fourth Set Total`;
const bo_y37 = (match, outcome) => `${match.homeTeam} Fifth Set Total`;
const bo_z37 = (match, outcome) => `${match.awayTeam} Fourth Set Total`;
const bo_a38 = (match, outcome) => `${match.awayTeam} Fifth Set Total`;
const bo_b38 = (match, outcome) => 'First Set / Match';
const bo_c38 = (match, outcome) => `Break Point In The ${outcome.condition} Game`;
const bo_d38 = (match, outcome) => 'Second Set Breaks Total';
const bo_e38 = (match, outcome) => 'Third Set Breaks Total';
const bo_f38 = (match, outcome) => 'Fourth Set Breaks Total';
const bo_g38 = (match, outcome) => 'Fifth Set Breaks Total';
const bo_h38 = (match, outcome) => `Result & Total ${outcome.condition} - Second Set`;
const bo_i38 = (match, outcome) => `Result & Total ${outcome.condition} - Third Set`;
const bo_j38 = (match, outcome) => `Result & Total ${outcome.condition} - Fourth Set`;
const bo_k38 = (match, outcome) => `Result & Total ${outcome.condition} - Fifth Set`;
const bo_l38 = (match, outcome) => `${match.homeTeam} First Set Breaks Total`;
const bo_m38 = (match, outcome) => `${match.homeTeam} Second Set Breaks Total`;
const bo_n38 = (match, outcome) => `${match.homeTeam} Third Set Breaks Total`;
const bo_o38 = (match, outcome) => `${match.homeTeam} Fourth Set Breaks Total`;
const bo_p38 = (match, outcome) => `${match.homeTeam} Fifth Set Breaks Total`;
const bo_q38 = (match, outcome) => `${match.awayTeam} First Set Breaks Total`;
const bo_r38 = (match, outcome) => `${match.awayTeam} Second Set Breaks Total`;
const bo_s38 = (match, outcome) => `${match.awayTeam} Third Set Breaks Total`;
const bo_t38 = (match, outcome) => `${match.awayTeam} Fourth Set Breaks Total`;
const bo_u38 = (match, outcome) => `${match.awayTeam} Fifth Set Breaks Total`;
const bo_v38 = (match, outcome) => `A Player To Win ${outcome.condition} ${plural(outcome.condition, ['Game', 'Games', 'Games'])} In A Row - First Set`;
const bo_w38 = (match, outcome) => `A Player To Win ${outcome.condition} ${plural(outcome.condition, ['Game', 'Games', 'Games'])} In A Row - Second Set`;
const bo_x38 = (match, outcome) => `A Player To Win ${outcome.condition} ${plural(outcome.condition, ['Game', 'Games', 'Games'])} In A Row - Third Set`;
const bo_y38 = (match, outcome) => `A Player To Win ${outcome.condition} ${plural(outcome.condition, ['Game', 'Games', 'Games'])} In A Row - Fourth Set`;
const bo_z38 = (match, outcome) => `A Player To Win ${outcome.condition} ${plural(outcome.condition, ['Game', 'Games', 'Games'])} In A Row - Fifth Set`;
const bo_a39 = (match, outcome) => `${match.homeTeam} To Win ${outcome.condition} ${plural(outcome.condition, ['Game', 'Games', 'Games'])} In A Row - Second Set`;
const bo_b39 = (match, outcome) => `${match.homeTeam} To Win ${outcome.condition} ${plural(outcome.condition, ['Game', 'Games', 'Games'])} In A Row - Third Set`;
const bo_c39 = (match, outcome) => `${match.homeTeam} To Win ${outcome.condition} ${plural(outcome.condition, ['Game', 'Games', 'Games'])} In A Row - Fourth Set`;
const bo_d39 = (match, outcome) => `${match.homeTeam} To Win ${outcome.condition} ${plural(outcome.condition, ['Game', 'Games', 'Games'])} In A Row - Fifth Set`;
const bo_e39 = (match, outcome) => `${match.awayTeam} To Win ${outcome.condition} ${plural(outcome.condition, ['Game', 'Games', 'Games'])} In A Row - First Set`;
const bo_f39 = (match, outcome) => `${match.awayTeam} To Win ${outcome.condition} ${plural(outcome.condition, ['Game', 'Games', 'Games'])} In A Row - Second Set`;
const bo_g39 = (match, outcome) => `${match.awayTeam} To Win ${outcome.condition} ${plural(outcome.condition, ['Game', 'Games', 'Games'])} In A Row - Third Set`;
const bo_h39 = (match, outcome) => `${match.awayTeam} To Win ${outcome.condition} ${plural(outcome.condition, ['Game', 'Games', 'Games'])} In A Row - Fourth Set`;
const bo_i39 = (match, outcome) => `${match.awayTeam} To Win ${outcome.condition} ${plural(outcome.condition, ['Game', 'Games', 'Games'])} In A Row - Fifth Set`;
const bo_j39 = (match, outcome) => 'Match Handicap';
const bo_k39 = (match, outcome) => 'Fourth Set Handicap';
const bo_l39 = (match, outcome) => 'Fifth Set Handicap';
const bo_m39 = (match, outcome) => 'Fourth Set Total';
const bo_n39 = (match, outcome) => 'Fifth Set Total';
const bo_o39 = (match, outcome) => 'Number of Sets';
const bo_p39 = (match, outcome) => `${outcome.condition} Game Score`;
const bo_q39 = (match, outcome) => `${outcome.condition} Game Winner`;
const bo_r39 = (match, outcome) => '1st Set Score';
const bo_s39 = (match, outcome) => '2nd Set Score';
const bo_t39 = (match, outcome) => '3rd Set Score';
const bo_u39 = (match, outcome) => '4th Set Score';
const bo_v39 = (match, outcome) => '5th Set Score';
const bo_w39 = (match, outcome) => `15X15 in ${outcome.condition} Game`;
const bo_x39 = (match, outcome) => `30X30 in ${outcome.condition} Game`;
const bo_y39 = (match, outcome) => `${outcome.condition} Game To Deuce`;
const bo_z39 = (match, outcome) => `Race To ${outcome.condition} ${plural(outcome.condition, ['Game', 'Games', 'Games'])} - First Set`;
const bo_a40 = (match, outcome) => `Race To ${outcome.condition} ${plural(outcome.condition, ['Game', 'Games', 'Games'])} - Second Set`;
const bo_b40 = (match, outcome) => `Race To ${outcome.condition} ${plural(outcome.condition, ['Game', 'Games', 'Games'])} - Third Set`;
const bo_c40 = (match, outcome) => `Race To ${outcome.condition} ${plural(outcome.condition, ['Game', 'Games', 'Games'])} - Fourth Set`;
const bo_d40 = (match, outcome) => `Race To ${outcome.condition} ${plural(outcome.condition, ['Game', 'Games', 'Games'])} - Fifth Set`;
const bo_e40 = (match, outcome) => 'Fourth Set Winner';
const bo_f40 = (match, outcome) => 'Fifth Set Winner';
const bo_g40 = (match, outcome) => `First Point - ${outcome.condition} Game`;
const bo_h40 = (match, outcome) => 'Tie Break in First Set';
const bo_i40 = (match, outcome) => 'Tie Break in Second Set';
const bo_j40 = (match, outcome) => 'Tie Break in Third Set';
const bo_k40 = (match, outcome) => 'Tie Break in Fourth Set';
const bo_l40 = (match, outcome) => 'Tie Break in Fifth Set';
const bo_m40 = (match, outcome) => 'Tie Break in Match';
const bo_n40 = (match, outcome) => 'First Set Tie-Break Total';
const bo_o40 = (match, outcome) => 'Second Set Tie-Break Total';
const bo_p40 = (match, outcome) => 'Third Set Tie-Break Total';
const bo_q40 = (match, outcome) => 'Fourth Set Tie-Break Total';
const bo_r40 = (match, outcome) => 'Fifth Set Tie-Break Total';
const bo_s40 = (match, outcome) => 'First Set Tie-Break Score';
const bo_t40 = (match, outcome) => 'Second Set Tie-Break Score';
const bo_u40 = (match, outcome) => 'Third Set Tie-Break Score';
const bo_v40 = (match, outcome) => 'Fourth Set Tie-Break Score';
const bo_w40 = (match, outcome) => 'Fifth Set Tie-Break Score';
const bo_x40 = (match, outcome) => 'First Set Tie Break Exact Total';
const bo_y40 = (match, outcome) => 'Second Set Tie Break Exact Total';
const bo_z40 = (match, outcome) => 'Third Set Tie Break Exact Total';
const bo_a41 = (match, outcome) => 'Fourth Set Tie Break Exact Total';
const bo_b41 = (match, outcome) => 'Fifth Set Tie Break Exact Total';
const bo_c41 = (match, outcome) => 'First Set Tie Break Winner';
const bo_d41 = (match, outcome) => 'Second Set Tie Break Winner';
const bo_e41 = (match, outcome) => 'Third Set Tie Break Winner';
const bo_f41 = (match, outcome) => 'Fourth Set Tie Break Winner';
const bo_g41 = (match, outcome) => 'Fifth Set Tie Break Winner';
const bo_h41 = (match, outcome) => 'First Set Breaks Total';
const bo_i41 = (match, outcome) => 'Match Breaks Total';
const bo_j41 = (match, outcome) => `${match.homeTeam} To Win A Set In The Match`;
const bo_k41 = (match, outcome) => `${match.awayTeam} To Win A Set In The Match`;
const bo_l41 = (match, outcome) => `Result & Total ${outcome.condition} - First Set`;
const bo_m41 = (match, outcome) => 'Lowest Scoring Set Total';
const bo_n41 = (match, outcome) => 'To Serve The First Ace';
const bo_o41 = (match, outcome) => 'To Double Fault First';
const bo_p41 = (match, outcome) => `${match.homeTeam} Highest Serving Speed (km/h)`;
const bo_q41 = (match, outcome) => `${match.awayTeam} Highest Serving Speed (km/h)`;
const bo_r41 = (match, outcome) => 'To Lose First Set / To Win Match';
const bo_s41 = (match, outcome) => `${match.homeTeam} % Good First Serves`;
const bo_t41 = (match, outcome) => `${match.awayTeam} % Good First Serves`;
const bo_u41 = (match, outcome) => 'Match Breaks Result';
const bo_v41 = (match, outcome) => `${match.homeTeam} Breaks Total`;
const bo_w41 = (match, outcome) => `${match.awayTeam} Breaks Total`;
const bo_x41 = (match, outcome) => 'To Break First';
const bo_y41 = (match, outcome) => `${match.homeTeam} To Break In The 1st or 2nd Game`;
const bo_z41 = (match, outcome) => 'A Set To Be Completed 6:0 or 0:6';
const bo_a42 = (match, outcome) => `${numeralMaleEnding(outcome.condition)} Game Winner`;
const bo_b42 = (match, outcome) => `To Be 15x15 In ${outcome.condition} Game?`;
const bo_c42 = (match, outcome) => `To Be 30x30 In ${outcome.condition} Game?`;
const bo_d42 = (match, outcome) => `To Be 40x40 In ${outcome.condition} Game?`;
const bo_e42 = (match, outcome) => `${numeralMaleEnding(outcome.condition)} Game Score`;
const bo_f42 = (match, outcome) => 'Aces Total';
const bo_g42 = (match, outcome) => `Match Aces Total: ${match.homeTeam}`;
const bo_h42 = (match, outcome) => `Match Aces Total: ${match.awayTeam}`;
const bo_i42 = (match, outcome) => 'Match Total Double Faults';
const bo_j42 = (match, outcome) => `Match Total Double Faults: ${match.homeTeam}`;
const bo_k42 = (match, outcome) => `Match Total Double Faults: ${match.awayTeam}`;
const bo_l42 = (match, outcome) => 'Highest Scoring Set';
const bo_m42 = (match, outcome) => 'To Win Match By Ace';
const bo_n42 = (match, outcome) => `To Be Ace In 1st Or 2nd Games: ${match.homeTeam}`;
const bo_o42 = (match, outcome) => `To Be Ace In 1st Or 2nd Games: ${match.awayTeam}`;
const bo_p42 = (match, outcome) => `To Be Double Fault In 1st Or 2nd Games: ${match.homeTeam}`;
const bo_q42 = (match, outcome) => `To Be Double Fault In 1st Or 2nd Games: ${match.awayTeam}`;
const bo_r42 = (match, outcome) => 'First Set Aces Total';
const bo_s42 = (match, outcome) => 'To Be Disqualification Or Retirement';
const bo_t42 = (match, outcome) => `Win % 1st serve ${match.homeTeam}`;
const bo_u42 = (match, outcome) => `Win % 1st serve ${match.awayTeam}`;
const bo_v42 = (match, outcome) => 'Breaks Result - First Set';
const bo_w42 = (match, outcome) => 'Breaks Result - Second Set';
const bo_x42 = (match, outcome) => 'Breaks Result - Third Set';
const bo_y42 = (match, outcome) => 'Breaks Result - Fourth Set';
const bo_z42 = (match, outcome) => 'Breaks Result - Fifth Set';
const bo_a43 = (match, outcome) => 'Match Breaks Handicap';
const bo_b43 = (match, outcome) => 'Breaks Handicap - First Set';
const bo_c43 = (match, outcome) => 'Breaks Handicap - Second Set';
const bo_d43 = (match, outcome) => 'Breaks Handicap - Third Set';
const bo_e43 = (match, outcome) => 'Breaks Handicap - Fourth Set';
const bo_f43 = (match, outcome) => 'Breaks Handicap - Fifth Set';
const bo_g43 = (match, outcome) => `Point Winner - Point ${outcome.conditionTwo}, Game ${numeralMaleEnding(outcome.condition)}`;
const bo_h43 = (match, outcome) => `To Win ${outcome.condition} And ${outcome.conditionTwo} Games`;
const bo_i43 = (match, outcome) => `${numeralMaleEnding(outcome.conditionTwo)} Game Handicap`;
const bo_j43 = (match, outcome) => `${numeralMaleEnding(outcome.conditionTwo)} Game Total`;
const bo_k43 = (match, outcome) => 'First Set Result';
const bo_l43 = (match, outcome) => 'Second Set Result';
const bo_m43 = (match, outcome) => 'Third Set Result';
const bo_n43 = (match, outcome) => 'Fourth Set Result';
const bo_o43 = (match, outcome) => 'Fifth Set Result';
const bo_p43 = (match, outcome) => `Race To ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])} - Fourth Set`;
const bo_q43 = (match, outcome) => `Race To ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])} - Fifth Set`;
const bo_r43 = (match, outcome) => 'Handicap - Sets';
const bo_s43 = (match, outcome) => 'First Set Exact Total';
const bo_t43 = (match, outcome) => 'Second Set Exact Total';
const bo_u43 = (match, outcome) => 'Third Set Exact Total';
const bo_v43 = (match, outcome) => 'Fourth Set Exact Total';
const bo_w43 = (match, outcome) => 'Fifth Set Exact Total';
const bo_x43 = (match, outcome) => `${match.homeTeam} Fourth Set Winning Margin`;
const bo_y43 = (match, outcome) => `${match.homeTeam} Fifth Set Winning Margin`;
const bo_z43 = (match, outcome) => `${match.awayTeam} Fourth Set Winning Margin`;
const bo_a44 = (match, outcome) => `${match.awayTeam} Fifth Set Winning Margin`;
const bo_b44 = (match, outcome) => `First Set Result & Total ${outcome.condition}`;
const bo_c44 = (match, outcome) => `Fourth Set Result / Total ${outcome.condition}`;
const bo_d44 = (match, outcome) => `Fifth Set Result / Total ${outcome.condition}`;
const bo_e44 = (match, outcome) => 'Fifth Set Result / Total';
const bo_f44 = (match, outcome) => 'Highest Scoring Set Total';
const bo_g44 = (match, outcome) => 'Fourth Set Winning Margin';
const bo_h44 = (match, outcome) => 'Fifth Set Winning Margin';
const bo_i44 = (match, outcome) => '10 Points Miniset Winner - Fourth Set';
const bo_j44 = (match, outcome) => '10 Points Miniset Handicap - Fourth Set';
const bo_k44 = (match, outcome) => '10 Points Miniset Total - Fourth Set';
const bo_l44 = (match, outcome) => '15 Points Miniset Winner - Fourth Set';
const bo_m44 = (match, outcome) => '15 Points Miniset Handicap - Fourth Set';
const bo_n44 = (match, outcome) => '15 Points Miniset Total - Fourth Set';
const bo_o44 = (match, outcome) => `Who Wins ${numeralNeuterEnding(outcome.condition)} Point In First Set`;
const bo_p44 = (match, outcome) => `Who Wins ${numeralNeuterEnding(outcome.condition)} Point In Second Set`;
const bo_q44 = (match, outcome) => `Who Wins ${numeralNeuterEnding(outcome.condition)} Point In Third Set`;
const bo_r44 = (match, outcome) => `Who Wins ${numeralNeuterEnding(outcome.condition)} Point In Fourth Set`;
const bo_s44 = (match, outcome) => `Who Wins ${numeralNeuterEnding(outcome.condition)} Point In Fifth Set`;
const bo_t44 = (match, outcome) => `Result / Total ${outcome.condition}`;
const bo_u44 = (match, outcome) => 'Golden Set Handicap';
const bo_v44 = (match, outcome) => 'Golden Set Total';
const bo_w44 = (match, outcome) => `${match.homeTeam} Golden Set Total`;
const bo_x44 = (match, outcome) => `${match.awayTeam} Golden Set Total`;
const bo_y44 = (match, outcome) => 'Golden Set Result';
const bo_z44 = (match, outcome) => `Race To ${outcome.condition} ${plural(outcome.condition, ['point', 'points', 'points'])} - Golden Set`;
const bo_a45 = (match, outcome) => 'Golden Set Exact Total';
const bo_b45 = (match, outcome) => 'Golden Set Even/Odd';
const bo_c45 = (match, outcome) => `Golden Set Result / Total ${outcome.condition}`;
const bo_d45 = (match, outcome) => 'Golden Set Winning Margin';
const bo_e45 = (match, outcome) => 'How many sets will exceed score limit';
const bo_f45 = (match, outcome) => `${outcome.condition} Round Winner`;
const bo_g45 = (match, outcome) => 'Game Handicap';
const bo_h45 = (match, outcome) => 'Game Score';
const bo_i45 = (match, outcome) => '13th Sector To Appear';
const bo_j45 = (match, outcome) => '13th Sector To Appear in The First Round';

const fa_b1 = (match, outcome) => `Han1(${signed(outcome.condition)})`;
const fa_c1 = (match, outcome) => `Han2(${signed(-outcome.condition)})`;
const fa_d1 = (match, outcome) => `Under ${outcome.condition}`;
const fa_e1 = (match, outcome) => `Over ${outcome.condition}`;
const fa_f1 = (match, outcome) => 'Even';
const fa_g1 = (match, outcome) => 'Odd';
const fa_h1 = (match, outcome) => `${match.homeTeam}`;
const fa_i1 = (match, outcome) => `${match.awayTeam}`;
const fa_j1 = (match, outcome) => '1-st Higher';
const fa_k1 = (match, outcome) => '2-nd Higher';
const fa_l1 = (match, outcome) => 'Yes';
const fa_m1 = (match, outcome) => 'No';
const fa_n1 = (match, outcome) => '0-2';
const fa_o1 = (match, outcome) => '0-3';
const fa_p1 = (match, outcome) => '1-2';
const fa_q1 = (match, outcome) => '1-3';
const fa_r1 = (match, outcome) => '2-0';
const fa_s1 = (match, outcome) => '2-1';
const fa_t1 = (match, outcome) => '2-3';
const fa_u1 = (match, outcome) => '3-0';
const fa_v1 = (match, outcome) => '3-1';
const fa_w1 = (match, outcome) => '3-2';
const fa_x1 = (match, outcome) => 'W1';
const fa_y1 = (match, outcome) => 'W2';
const fa_z1 = (match, outcome) => 'Х';
const fa_a2 = (match, outcome) => 'No one';
const fa_b2 = (match, outcome) => '1X';
const fa_c2 = (match, outcome) => '12';
const fa_d2 = (match, outcome) => '2X';
const fa_e2 = (match, outcome) => `W1&Tu ${outcome.condition}`;
const fa_f2 = (match, outcome) => `W1&To ${outcome.condition}`;
const fa_g2 = (match, outcome) => `W2&Tu ${outcome.condition}`;
const fa_h2 = (match, outcome) => `W2&To ${outcome.condition}`;
const fa_i2 = (match, outcome) => `Х&Tu ${outcome.condition}`;
const fa_j2 = (match, outcome) => `Х&To ${outcome.condition}`;
const fa_k2 = (match, outcome) => '0';
const fa_l2 = (match, outcome) => '1';
const fa_m2 = (match, outcome) => '2';
const fa_n2 = (match, outcome) => '3';
const fa_o2 = (match, outcome) => '4';
const fa_p2 = (match, outcome) => '≥ 5';
const fa_q2 = (match, outcome) => 'Both';
const fa_r2 = (match, outcome) => 'One';
const fa_s2 = (match, outcome) => 'No Goals';
const fa_t2 = (match, outcome) => '0-0';
const fa_u2 = (match, outcome) => '0-1';
const fa_v2 = (match, outcome) => '0-4';
const fa_w2 = (match, outcome) => '0-5';
const fa_x2 = (match, outcome) => '1-0';
const fa_y2 = (match, outcome) => '1-1';
const fa_z2 = (match, outcome) => '1-4';
const fa_a3 = (match, outcome) => '1-5';
const fa_b3 = (match, outcome) => '2-2';
const fa_c3 = (match, outcome) => '2-4';
const fa_d3 = (match, outcome) => '2-5';
const fa_e3 = (match, outcome) => '2-6';
const fa_f3 = (match, outcome) => '3-3';
const fa_g3 = (match, outcome) => '3-4';
const fa_h3 = (match, outcome) => '3-5';
const fa_i3 = (match, outcome) => '4-0';
const fa_j3 = (match, outcome) => '4-1';
const fa_k3 = (match, outcome) => '4-2';
const fa_l3 = (match, outcome) => '4-3';
const fa_m3 = (match, outcome) => '4-4';
const fa_n3 = (match, outcome) => '5-0';
const fa_o3 = (match, outcome) => '5-1';
const fa_p3 = (match, outcome) => '5-2';
const fa_q3 = (match, outcome) => '5-3';
const fa_r3 = (match, outcome) => 'Any Other';
const fa_s3 = (match, outcome) => `≤ ${outcome.condition}`;
const fa_t3 = (match, outcome) => `${outcome.condition + 1} - ${outcome.condition + 2}`;
const fa_u3 = (match, outcome) => `${outcome.condition + 3} - ${outcome.condition + 4}`;
const fa_v3 = (match, outcome) => `${outcome.condition + 5} - ${outcome.condition + 6}`;
const fa_w3 = (match, outcome) => `${outcome.condition + 7} - ${outcome.condition + 8}`;
const fa_x3 = (match, outcome) => `≥ ${outcome.condition + 9}`;
const fa_y3 = (match, outcome) => '6-9';
const fa_z3 = (match, outcome) => '10-12';
const fa_a4 = (match, outcome) => '13-16';
const fa_b4 = (match, outcome) => '17-20';
const fa_c4 = (match, outcome) => '21+';
const fa_d4 = (match, outcome) => '1st Half';
const fa_e4 = (match, outcome) => '2nd Half';
const fa_f4 = (match, outcome) => '1st Quarter';
const fa_g4 = (match, outcome) => '2nd Quarter';
const fa_h4 = (match, outcome) => '3rd Quarter';
const fa_i4 = (match, outcome) => '4th Quarter';
const fa_j4 = (match, outcome) => 'W1: 1-2';
const fa_k4 = (match, outcome) => 'W1: 3-5';
const fa_l4 = (match, outcome) => 'W1: 6-9';
const fa_m4 = (match, outcome) => 'W1: 10-12';
const fa_n4 = (match, outcome) => 'W1: 13-16';
const fa_o4 = (match, outcome) => 'W1: 17-20';
const fa_p4 = (match, outcome) => 'W1: 21+';
const fa_q4 = (match, outcome) => 'W2: 1-2';
const fa_r4 = (match, outcome) => 'W2: 3-5';
const fa_s4 = (match, outcome) => 'W2: 6-9';
const fa_t4 = (match, outcome) => 'W2: 10-12';
const fa_u4 = (match, outcome) => 'W2: 13-16';
const fa_v4 = (match, outcome) => 'W2: 17-20';
const fa_w4 = (match, outcome) => 'W2: 21+';
const fa_x4 = (match, outcome) => 'W1: 3-4';
const fa_y4 = (match, outcome) => 'W1: 5-7';
const fa_z4 = (match, outcome) => 'W1: 8+';
const fa_a5 = (match, outcome) => 'Х2';
const fa_b5 = (match, outcome) => 'W2: 3-4';
const fa_c5 = (match, outcome) => 'W2: 5-7';
const fa_d5 = (match, outcome) => 'W2: 8+';
const fa_e5 = (match, outcome) => 'Х1';
const fa_f5 = (match, outcome) => 'Free Throw';
const fa_g5 = (match, outcome) => '3-Pointer';
const fa_h5 = (match, outcome) => '2-Pointer';
const fa_i5 = (match, outcome) => `W1 ≥ ${outcome.condition}`;
const fa_j5 = (match, outcome) => `Margin under ${outcome.condition}`;
const fa_k5 = (match, outcome) => `W2 ≥ ${outcome.condition}`;
const fa_l5 = (match, outcome) => 'Neither';
const fa_m5 = (match, outcome) => 'W1: 1';
const fa_n5 = (match, outcome) => 'W1: 2';
const fa_o5 = (match, outcome) => 'W1: 3';
const fa_p5 = (match, outcome) => 'W1: 4';
const fa_q5 = (match, outcome) => 'W1: 5+';
const fa_r5 = (match, outcome) => 'W2: 1';
const fa_s5 = (match, outcome) => 'W2: 2';
const fa_t5 = (match, outcome) => 'W2: 3';
const fa_u5 = (match, outcome) => 'W2: 4';
const fa_v5 = (match, outcome) => 'W2: 5+';
const fa_w5 = (match, outcome) => '1Х';
const fa_x5 = (match, outcome) => '0 or 1';
const fa_y5 = (match, outcome) => '5';
const fa_z5 = (match, outcome) => '6';
const fa_a6 = (match, outcome) => '7';
const fa_b6 = (match, outcome) => '8+';
const fa_c6 = (match, outcome) => 'W1&W1';
const fa_d6 = (match, outcome) => 'W1&X';
const fa_e6 = (match, outcome) => 'W1&W2';
const fa_f6 = (match, outcome) => 'X&W1';
const fa_g6 = (match, outcome) => 'X&X';
const fa_h6 = (match, outcome) => 'X&W2';
const fa_i6 = (match, outcome) => 'W2&W1';
const fa_j6 = (match, outcome) => 'W2&X';
const fa_k6 = (match, outcome) => 'W2&W2';
const fa_l6 = (match, outcome) => `${outcome.condition + 1}`;
const fa_m6 = (match, outcome) => `${outcome.condition + 2}`;
const fa_n6 = (match, outcome) => `${outcome.condition + 3}`;
const fa_o6 = (match, outcome) => `${outcome.condition + 4}`;
const fa_p6 = (match, outcome) => `${outcome.condition + 5}`;
const fa_q6 = (match, outcome) => `${outcome.condition + 6}`;
const fa_r6 = (match, outcome) => `≥ ${outcome.condition + 7}`;
const fa_s6 = (match, outcome) => '4-6';
const fa_t6 = (match, outcome) => '7+';
const fa_u6 = (match, outcome) => '7 And More';
const fa_v6 = (match, outcome) => '7 and more';
const fa_w6 = (match, outcome) => 'W1&U';
const fa_x6 = (match, outcome) => 'W1&O';
const fa_y6 = (match, outcome) => 'W2&U';
const fa_z6 = (match, outcome) => 'W2&O';
const fa_a7 = (match, outcome) => 'W1: 2-3';
const fa_b7 = (match, outcome) => 'W1: 4-6';
const fa_c7 = (match, outcome) => 'W1: ≥7';
const fa_d7 = (match, outcome) => 'W2: 2-3';
const fa_e7 = (match, outcome) => 'W2: 4-6';
const fa_f7 = (match, outcome) => 'W2: ≥7';
const fa_g7 = (match, outcome) => `${outcome.condition}`;
const fa_h7 = (match, outcome) => `≥ ${outcome.condition + 6}`;
const fa_i7 = (match, outcome) => 'W1: To Win Inside Distance';
const fa_j7 = (match, outcome) => 'W1: Point Victory';
const fa_k7 = (match, outcome) => 'Draw';
const fa_l7 = (match, outcome) => 'W2: To Win Inside Distance';
const fa_m7 = (match, outcome) => 'W2: Point Victory';
const fa_n7 = (match, outcome) => 'W1: 1 round';
const fa_o7 = (match, outcome) => 'W1: 2 round';
const fa_p7 = (match, outcome) => 'W1: 3 round';
const fa_q7 = (match, outcome) => 'W1: 4 round';
const fa_r7 = (match, outcome) => 'W1: 5 round';
const fa_s7 = (match, outcome) => 'W1: 6 round';
const fa_t7 = (match, outcome) => 'W1: 7 round';
const fa_u7 = (match, outcome) => 'W1: 8 round';
const fa_v7 = (match, outcome) => 'W1: 9 round';
const fa_w7 = (match, outcome) => 'W1: 10 round';
const fa_x7 = (match, outcome) => 'W1: 11 round';
const fa_y7 = (match, outcome) => 'W1: 12 round';
const fa_z7 = (match, outcome) => 'W2: 1 round';
const fa_a8 = (match, outcome) => 'W2: 2 round';
const fa_b8 = (match, outcome) => 'W2: 3 round';
const fa_c8 = (match, outcome) => 'W2: 4 round';
const fa_d8 = (match, outcome) => 'W2: 5 round';
const fa_e8 = (match, outcome) => 'W2: 6 round';
const fa_f8 = (match, outcome) => 'W2: 7 round';
const fa_g8 = (match, outcome) => 'W2: 8 round';
const fa_h8 = (match, outcome) => 'W2: 9 round';
const fa_i8 = (match, outcome) => 'W2: 10 round';
const fa_j8 = (match, outcome) => 'W2: 11 round';
const fa_k8 = (match, outcome) => 'W2: 12 round';
const fa_l8 = (match, outcome) => `HAN1(${signed(outcome.condition)})`;
const fa_m8 = (match, outcome) => `HAN2(${signed(-outcome.condition)})`;
const fa_n8 = (match, outcome) => '1st Higher';
const fa_o8 = (match, outcome) => '2nd Higher';
const fa_p8 = (match, outcome) => 'X';
const fa_q8 = (match, outcome) => 'One Only';
const fa_r8 = (match, outcome) => 'Both Teams';
const fa_s8 = (match, outcome) => 'Only One';
const fa_t8 = (match, outcome) => 'Header';
const fa_u8 = (match, outcome) => 'Shot';
const fa_v8 = (match, outcome) => 'Own Goal';
const fa_w8 = (match, outcome) => 'Penalty';
const fa_x8 = (match, outcome) => `Next Round: ${match.homeTeam}`;
const fa_y8 = (match, outcome) => `Next Round: ${match.awayTeam}`;
const fa_z8 = (match, outcome) => 'No Yellow Cards';
const fa_a9 = (match, outcome) => 'Corner';
const fa_b9 = (match, outcome) => 'Offside';
const fa_c9 = (match, outcome) => 'Yellow Card';
const fa_d9 = (match, outcome) => 'Goal';
const fa_e9 = (match, outcome) => `Before ${outcome.condition}`;
const fa_f9 = (match, outcome) => `After ${outcome.condition}`;
const fa_g9 = (match, outcome) => 'First Half';
const fa_h9 = (match, outcome) => 'Second Half';
const fa_i9 = (match, outcome) => 'In The First Half';
const fa_j9 = (match, outcome) => 'In The Second Half';
const fa_k9 = (match, outcome) => 'Not To Score';
const fa_l9 = (match, outcome) => 'No One';
const fa_m9 = (match, outcome) => '1&1';
const fa_n9 = (match, outcome) => '1&X';
const fa_o9 = (match, outcome) => '1&2';
const fa_p9 = (match, outcome) => 'X&1';
const fa_q9 = (match, outcome) => 'X&2';
const fa_r9 = (match, outcome) => '2&1';
const fa_s9 = (match, outcome) => '2&X';
const fa_t9 = (match, outcome) => '2&2';
const fa_u9 = (match, outcome) => '0-6';
const fa_v9 = (match, outcome) => '1-6';
const fa_w9 = (match, outcome) => '6-0';
const fa_x9 = (match, outcome) => '6-1';
const fa_y9 = (match, outcome) => 'Draw by Goals';
const fa_z9 = (match, outcome) => 'Scoreless Draw';
const fa_a10 = (match, outcome) => 'No Draw';
const fa_b10 = (match, outcome) => 'No Goal';
const fa_c10 = (match, outcome) => 'Tie';
const fa_d10 = (match, outcome) => 'Yes&Yes';
const fa_e10 = (match, outcome) => 'Yes&No';
const fa_f10 = (match, outcome) => 'No&Yes';
const fa_g10 = (match, outcome) => 'No&No';
const fa_h10 = (match, outcome) => 'Over&Yes';
const fa_i10 = (match, outcome) => 'Over&No';
const fa_j10 = (match, outcome) => 'Under&Yes';
const fa_k10 = (match, outcome) => 'Under&No';
const fa_l10 = (match, outcome) => 'W1 in Full Time';
const fa_m10 = (match, outcome) => 'W2 in Full Time';
const fa_n10 = (match, outcome) => 'W1 in Extra Time';
const fa_o10 = (match, outcome) => 'W2 in Extra Time';
const fa_p10 = (match, outcome) => 'W1 by Shootouts';
const fa_q10 = (match, outcome) => 'W2 by Shootouts';
const fa_r10 = (match, outcome) => 'Half Time';
const fa_s10 = (match, outcome) => 'Any other';
const fa_t10 = (match, outcome) => 'П1';
const fa_u10 = (match, outcome) => 'П2';
const fa_v10 = (match, outcome) => '5-4';
const fa_w10 = (match, outcome) => 'W1 with any other';
const fa_x10 = (match, outcome) => '4-5';
const fa_y10 = (match, outcome) => 'W2 with any other';
const fa_z10 = (match, outcome) => '1-10';
const fa_a11 = (match, outcome) => '11-20';
const fa_b11 = (match, outcome) => '21-30';
const fa_c11 = (match, outcome) => '31-40';
const fa_d11 = (match, outcome) => '41-50';
const fa_e11 = (match, outcome) => '51-60';
const fa_f11 = (match, outcome) => '61-70';
const fa_g11 = (match, outcome) => '71-80';
const fa_h11 = (match, outcome) => '81-FT';
const fa_i11 = (match, outcome) => '5 And More';
const fa_j11 = (match, outcome) => 'No One To Score';
const fa_k11 = (match, outcome) => 'Each Team';
const fa_l11 = (match, outcome) => 'V1';
const fa_m11 = (match, outcome) => 'V2';
const fa_n11 = (match, outcome) => 'To Score';
const fa_o11 = (match, outcome) => 'First Under';
const fa_p11 = (match, outcome) => 'Equal';
const fa_q11 = (match, outcome) => 'First Over';
const fa_r11 = (match, outcome) => 'V1: 1-2';
const fa_s11 = (match, outcome) => 'V1: 3-4';
const fa_t11 = (match, outcome) => 'V1: 5-7';
const fa_u11 = (match, outcome) => 'V1: 8 and more';
const fa_v11 = (match, outcome) => 'X2';
const fa_w11 = (match, outcome) => 'X1';
const fa_x11 = (match, outcome) => 'no one';
const fa_y11 = (match, outcome) => 'One not to score';
const fa_z11 = (match, outcome) => '5+';
const fa_a12 = (match, outcome) => '1<2';
const fa_b12 = (match, outcome) => '1=2';
const fa_c12 = (match, outcome) => '1>2';
const fa_d12 = (match, outcome) => '1<3';
const fa_e12 = (match, outcome) => '1=3';
const fa_f12 = (match, outcome) => '1>3';
const fa_g12 = (match, outcome) => '2<3';
const fa_h12 = (match, outcome) => '2=3';
const fa_i12 = (match, outcome) => '2>3';
const fa_j12 = (match, outcome) => 'yes';
const fa_k12 = (match, outcome) => 'no';
const fa_l12 = (match, outcome) => 'Yellow Ball';
const fa_m12 = (match, outcome) => 'Green Ball';
const fa_n12 = (match, outcome) => 'Brown Ball';
const fa_o12 = (match, outcome) => 'Blue Ball';
const fa_p12 = (match, outcome) => 'Pink Ball';
const fa_q12 = (match, outcome) => 'Black Ball';
const fa_r12 = (match, outcome) => `≥ ${outcome.condition + 5}`;
const fa_s12 = (match, outcome) => '≤ 14';
const fa_t12 = (match, outcome) => ' 15 - 17';
const fa_u12 = (match, outcome) => ' 18 - 19';
const fa_v12 = (match, outcome) => '≥ 20';
const fa_w12 = (match, outcome) => 'W1-Love';
const fa_x12 = (match, outcome) => 'W1-15';
const fa_y12 = (match, outcome) => 'W1-30';
const fa_z12 = (match, outcome) => 'W1-40';
const fa_a13 = (match, outcome) => 'Love-W2';
const fa_b13 = (match, outcome) => '15-W2';
const fa_c13 = (match, outcome) => '30-W2';
const fa_d13 = (match, outcome) => '40-W2';
const fa_e13 = (match, outcome) => '3-6';
const fa_f13 = (match, outcome) => '5-7';
const fa_g13 = (match, outcome) => '6-2';
const fa_h13 = (match, outcome) => '6-3';
const fa_i13 = (match, outcome) => '6-4';
const fa_j13 = (match, outcome) => '6-7';
const fa_k13 = (match, outcome) => '7-5';
const fa_l13 = (match, outcome) => '7-6';
const fa_m13 = (match, outcome) => '7-0';
const fa_n13 = (match, outcome) => '7-1';
const fa_o13 = (match, outcome) => '7-2';
const fa_p13 = (match, outcome) => '7-3';
const fa_q13 = (match, outcome) => '7-4';
const fa_r13 = (match, outcome) => 'W1 Any Other';
const fa_s13 = (match, outcome) => '0-7';
const fa_t13 = (match, outcome) => '1-7';
const fa_u13 = (match, outcome) => '2-7';
const fa_v13 = (match, outcome) => '3-7';
const fa_w13 = (match, outcome) => '4-7';
const fa_x13 = (match, outcome) => 'W2 Any Other';
const fa_y13 = (match, outcome) => '8';
const fa_z13 = (match, outcome) => '9';
const fa_a14 = (match, outcome) => '10';
const fa_b14 = (match, outcome) => '11';
const fa_c14 = (match, outcome) => '≥ 13';
const fa_d14 = (match, outcome) => `${match.homeTeam} (Svr)`;
const fa_e14 = (match, outcome) => `${match.awayTeam} (Svr)`;
const fa_f14 = (match, outcome) => 'W1-0';
const fa_g14 = (match, outcome) => '0-W2';
const fa_h14 = (match, outcome) => 'Second';
const fa_i14 = (match, outcome) => 'First';
const fa_j14 = (match, outcome) => 'Да';
const fa_k14 = (match, outcome) => 'Нет';
const fa_l14 = (match, outcome) => 'Both W1';
const fa_m14 = (match, outcome) => 'Both W2';
const fa_n14 = (match, outcome) => 'Han1';
const fa_o14 = (match, outcome) => 'Han2';
const fa_p14 = (match, outcome) => 'W1: 7+';
const fa_q14 = (match, outcome) => 'W2: 7+';
const fa_r14 = (match, outcome) => '6-5';
const fa_s14 = (match, outcome) => '5-6';

let groupConfig = {
    32: {
        0: 'Матч',
        1: 'First Set',
        2: 'Second Set',
        3: 'ThirdSet',
        4: 'Miniset to 10 Points (First Set)',
        5: 'Miniset to 15 Points (First Set)',
        6: 'Miniset to 10 Points (Second Set)',
        7: 'Miniset to 15 Points (Second Set)',
        8: 'Miniset to 10 Points (Third Set)',
        9: 'Miniset to 15 Points (Third Set)'
    },
    35: {
        0: 'Матч',
        1: 'Первый период'
    },
    31: {
        0: 'Матч',
        1: 'First Quarter',
        2: 'Second Quarter',
        3: 'Third Quarter',
        4: 'Fourth Quarter',
        5: '2-Pointers',
        6: '3-Pointers',
        7: 'First Half',
        8: 'Second Half'
    },
    41: {
        0: 'Матч',
        1: 'First Half',
        2: 'Second Half',
        3: '2-Pointers',
        4: '3-Pointers'
    },
    18: {
        0: 'Матч',
        1: 'Первый период',
        2: 'Второй период',
        3: 'Третий период'
    },
    3: {
        0: 'Матч',
        1: 'First Set',
        2: 'Second Set',
        3: 'Third Set',
        4: 'Miniset to 10 Points (First Period)',
        5: 'Miniset to 15 Points (First Period)',
        6: 'Miniset to 10 Points (Second Period)',
        7: 'Miniset to 15 Points (Second Period)'
    },
    20: {
        0: 'Матч',
        1: 'Первый огневой рубеж',
        2: 'Второй огневой рубеж',
        3: 'Третий огневой рубеж',
        4: 'Четвертый огневой рубеж',
        5: 'Пятый огневой рубеж',
        6: 'Шестой огневой рубеж',
        7: 'Седьмой огневой рубеж',
        8: 'Восьмой огневой рубеж'
    },
    42: {
        0: 'Match',
        1: 'First map',
        2: 'Second map',
        3: 'Third map',
        4: 'Fourth map',
        5: 'Fifth map'
    },
    36: {
        0: 'Матч',
        1: 'Первый период'
    },
    7: {
        0: 'Матч',
        1: 'First Half',
        2: 'Second Half',
        3: '1-15th Mins',
        4: '16-30th Mins',
        5: '31st Min - Half Time',
        6: '46-60th Mins',
        7: '60-75th Mins',
        8: '76th Min - Full Time',
        9: 'Corners',
        10: 'Corners (First Half)',
        11: 'Yellow Cards',
        12: 'Yellow Cards (First Half)',
        13: 'Overtime',
        14: 'First Overtime',
        15: 'Second Overtime',
        16: 'Серия пенальти'
    },
    34: {
        0: 'Матч',
        1: 'First Time',
        2: 'Second Time',
        3: '1-15th Mins',
        4: '16-30th Mins',
        5: '31st Min - Half Time',
        6: '46-60th Mins',
        7: '60-75th Mins',
        8: '76th Min - Full Time',
        9: 'Corners',
        10: 'Yellow Cards'
    },
    19: {
        0: 'Матч',
        1: 'Первый период',
        2: 'Второй период'
    },
    30: {
        0: 'Матч',
        1: 'First Period',
        2: 'Second Period',
        3: 'Third Period',
        4: '1-10 Minutes',
        5: '11-20 Minutes',
        6: '21-30 Minutes',
        7: '31-40 Minutes',
        8: '41-50 Minutes',
        9: '51-60 Minutes'
    },
    9: {
        0: 'Матч',
        1: 'Первый период',
        2: 'Второй период'
    },
    29: {
        0: 'Матч',
        1: 'Первый период',
        2: 'Второй период',
        3: 'Третий период',
        4: 'Четвертый период',
        5: 'Пятый период',
        6: 'Шестой период',
        7: 'Седьмой период',
        8: 'Восьмой период',
        9: 'Девятый период',
        10: 'Десятый период',
        11: 'Одинадцатый период',
        12: 'Двенадцатый период',
        13: 'Тринадцатый период',
        14: 'Четырнадцатый период',
        15: 'Пятнадцатый период',
        16: 'Шестнадцатый период',
        17: 'Семнадцатый период',
        18: 'Восемнадцатый период',
        19: 'Девятнадцатый период',
        20: 'Двадцатый период',
        21: 'Двадцать первый период',
        22: 'Двадцать второй период',
        23: 'Двадцать третий период',
        24: 'Двадцать четвертый период',
        25: 'Двадцать пятый период',
        26: 'Двадцать шестой период',
        27: 'Двадцать седьмой период',
        28: 'Двадцать восьмой период',
        29: 'Двадцать девятый период',
        30: 'Тридцатый период',
        31: 'Тридцать первый период',
        32: 'Тридцать второй период',
        33: 'Тридцать третий период',
        34: 'Тридцать четвертый период',
        35: 'Тридцать пятый период',
        36: 'Тридцать шестой период',
        37: 'Тридцать седьмой период'
    },
    2: {
        0: 'Матч',
        1: 'First Set',
        2: 'Second Set',
        3: 'Third Set',
        4: 'Fourth Set',
        5: 'Fifth Set',
        6: 'Sixth Set',
        7: 'Seventh Set'
    },
    6: {
        0: 'Матч',
        1: 'First Set',
        2: 'Second Set',
        3: 'Third Set',
        4: 'Fourth Set',
        5: 'Fifth Set'
    },
    4: {
        0: 'Матч',
        1: 'First Set',
        2: 'Second Set',
        3: 'Third Set',
        4: 'Fourth Set',
        5: 'Fifth Set',
        6: 'Golden Set',
        7: 'Miniset to 10 Points (First Set)',
        8: 'Miniset to 15 Points (First Set)',
        9: 'Miniset to 10 Points (Second Set)',
        10: 'Miniset to 15 Points (Second Set)',
        11: 'Miniset to 10 Points (Third Set)',
        12: 'Miniset to 15 Points (Third Set)',
        13: 'Miniset to 10 Points (Fourth Set)',
        14: 'Miniset to 15 Points (Fourth Set)'
    },
    8: {
        0: 'Матч',
        1: 'First Quarter',
        2: 'Second Quarter',
        3: 'Third Quarter',
        4: 'Fourth Quarter'
    }
};

let slotConfig = {
    32: {
        366: sl_b1,
        21: sl_c1,
        195: sl_d1,
        557: sl_e1,
        607: sl_f1,
        122: sl_g1,
        129: sl_h1,
        138: sl_i1,
        182: sl_j1,
        367: sl_b1,
        22: sl_c1,
        196: sl_d1,
        558: sl_e1,
        608: sl_f1,
        123: sl_g1,
        130: sl_h1,
        139: sl_i1,
        183: sl_j1,
        368: sl_b1,
        23: sl_c1,
        197: sl_d1,
        559: sl_e1,
        609: sl_f1,
        124: sl_g1,
        131: sl_h1,
        140: sl_i1,
        184: sl_j1,
        362: sl_b1,
        17: sl_c1,
        176: sl_d1,
        358: sl_b1,
        13: sl_c1,
        172: sl_d1,
        363: sl_b1,
        18: sl_c1,
        177: sl_d1,
        359: sl_b1,
        14: sl_c1,
        173: sl_d1,
        364: sl_b1,
        19: sl_c1,
        178: sl_d1,
        360: sl_b1,
        15: sl_c1,
        174: sl_d1
    },
    35: {
        664: sl_k1,
        21: sl_c1,
        195: sl_d1,
        138: sl_i1,
        182: sl_j1
    },
    31: {
        664: sl_l1,
        21: sl_m1,
        195: sl_n1,
        769: sl_o1,
        138: sl_i1,
        182: sl_j1,
        775: sl_p1,
        765: sl_q1,
        629: sl_r1,
        633: sl_s1,
        665: sl_l1,
        22: sl_m1,
        196: sl_n1,
        770: sl_o1,
        139: sl_i1,
        183: sl_j1,
        776: sl_p1,
        766: sl_q1,
        630: sl_r1,
        634: sl_s1,
        666: sl_l1,
        23: sl_m1,
        197: sl_n1,
        771: sl_o1,
        140: sl_i1,
        184: sl_j1,
        777: sl_p1,
        767: sl_q1,
        631: sl_r1,
        635: sl_s1,
        667: sl_l1,
        24: sl_m1,
        198: sl_n1,
        772: sl_o1,
        141: sl_i1,
        185: sl_j1,
        778: sl_p1,
        768: sl_q1,
        632: sl_r1,
        636: sl_s1,
        676: sl_k1,
        248: sl_d1,
        62: sl_c1,
        241: sl_i1,
        233: sl_j1,
        406: sl_t1,
        675: sl_k1,
        246: sl_d1,
        61: sl_c1,
        240: sl_i1,
        232: sl_j1,
        405: sl_t1,
        672: sl_k1,
        58: sl_c1,
        238: sl_d1,
        234: sl_i1,
        236: sl_j1,
        673: sl_k1,
        59: sl_c1,
        239: sl_d1,
        235: sl_i1,
        237: sl_j1
    },
    41: {
        664: sl_k1,
        21: sl_c1,
        195: sl_d1,
        782: sl_u1,
        785: sl_p1,
        780: sl_q1,
        138: sl_i1,
        182: sl_j1,
        639: sl_r1,
        665: sl_k1,
        22: sl_c1,
        196: sl_d1,
        783: sl_u1,
        786: sl_p1,
        781: sl_q1,
        139: sl_i1,
        183: sl_j1,
        640: sl_r1,
        64: sl_c1,
        678: sl_k1,
        250: sl_d1,
        63: sl_c1,
        677: sl_k1,
        249: sl_d1
    },
    18: {
        664: sl_k1,
        195: sl_d1,
        698: sl_v1,
        21: sl_c1,
        734: sl_w1,
        665: sl_k1,
        196: sl_d1,
        699: sl_v1,
        22: sl_c1,
        735: sl_w1,
        666: sl_k1,
        197: sl_d1,
        700: sl_v1,
        23: sl_c1,
        736: sl_w1
    },
    3: {
        366: sl_b1,
        21: sl_c1,
        195: sl_d1,
        896: sl_x1,
        138: sl_i1,
        182: sl_j1,
        557: sl_e1,
        83: sl_y1,
        788: sl_p1,
        842: sl_q1,
        845: sl_z1,
        848: sl_a2,
        607: sl_b2,
        791: sl_s1,
        367: sl_b1,
        22: sl_c1,
        196: sl_d1,
        897: sl_x1,
        139: sl_i1,
        183: sl_j1,
        558: sl_e1,
        84: sl_y1,
        789: sl_p1,
        843: sl_q1,
        846: sl_z1,
        849: sl_a2,
        608: sl_b2,
        792: sl_s1,
        368: sl_b1,
        23: sl_c1,
        197: sl_d1,
        898: sl_x1,
        140: sl_i1,
        184: sl_j1,
        559: sl_e1,
        85: sl_y1,
        790: sl_p1,
        844: sl_q1,
        847: sl_z1,
        850: sl_a2,
        609: sl_b2,
        793: sl_s1,
        362: sl_b1,
        17: sl_c1,
        176: sl_d1,
        358: sl_b1,
        13: sl_c1,
        172: sl_d1,
        363: sl_b1,
        18: sl_c1,
        177: sl_d1,
        359: sl_b1,
        14: sl_c1,
        173: sl_d1
    },
    20: {
        664: sl_k1,
        21: sl_c1,
        195: sl_d1,
        138: sl_i1,
        182: sl_j1,
        851: sl_u1,
        665: sl_k1,
        22: sl_c1,
        196: sl_d1,
        139: sl_i1,
        183: sl_j1,
        852: sl_u1,
        666: sl_k1,
        23: sl_c1,
        197: sl_d1,
        140: sl_i1,
        184: sl_j1,
        853: sl_u1,
        667: sl_k1,
        24: sl_c1,
        198: sl_d1,
        141: sl_i1,
        185: sl_j1,
        854: sl_u1,
        199: sl_k1,
        142: sl_c1,
        186: sl_d1,
        25: sl_i1,
        668: sl_j1,
        855: sl_u1,
        200: sl_k1,
        143: sl_c1,
        187: sl_d1,
        26: sl_i1,
        669: sl_j1,
        856: sl_u1,
        201: sl_k1,
        144: sl_c1,
        188: sl_d1,
        27: sl_i1,
        670: sl_j1,
        857: sl_u1,
        202: sl_k1,
        145: sl_c1,
        189: sl_d1,
        28: sl_i1,
        671: sl_j1,
        858: sl_u1
    },
    42: {
        557: sl_c2,
        1865: sl_d2,
        558: sl_c2,
        1866: sl_d2,
        559: sl_c2,
        1867: sl_d2,
        560: sl_c2,
        1868: sl_d2,
        561: sl_c2,
        1869: sl_d2
    },
    36: {
        664: sl_k1,
        21: sl_c1,
        195: sl_d1
    },
    7: {
        426: sl_e2,
        526: sl_f2,
        419: sl_g2,
        519: sl_h2,
        664: sl_k1,
        21: sl_c1,
        195: sl_d1,
        138: sl_i1,
        182: sl_j1,
        734: sl_w1,
        756: sl_u1,
        698: sl_i2,
        794: sl_j2,
        860: sl_k2,
        273: sl_l2,
        83: sl_m2,
        727: sl_n2,
        729: sl_o2,
        731: sl_p2,
        648: sl_q2,
        420: sl_g2,
        520: sl_h2,
        665: sl_k1,
        22: sl_c1,
        196: sl_d1,
        139: sl_i1,
        183: sl_j1,
        735: sl_w1,
        757: sl_u1,
        699: sl_i2,
        859: sl_j2,
        861: sl_k2,
        274: sl_l2,
        84: sl_m2,
        728: sl_n2,
        649: sl_r2,
        652: sl_k1,
        641: sl_q2,
        2: sl_c1,
        160: sl_d1,
        148: sl_i1,
        154: sl_j1,
        655: sl_k1,
        642: sl_q2,
        5: sl_c1,
        163: sl_d1,
        149: sl_i1,
        155: sl_j1,
        657: sl_l1,
        643: sl_s2,
        7: sl_m1,
        165: sl_n1,
        150: sl_t2,
        156: sl_u2,
        658: sl_k1,
        644: sl_q2,
        930: sl_c1,
        166: sl_d1,
        151: sl_i1,
        157: sl_j1,
        660: sl_k1,
        645: sl_q2,
        9: sl_c1,
        168: sl_d1,
        152: sl_i1,
        158: sl_j1,
        663: sl_k1,
        646: sl_q2,
        12: sl_c1,
        171: sl_d1,
        153: sl_i1,
        159: sl_j1,
        680: sl_v2,
        66: sl_w2,
        255: sl_d1,
        438: sl_x2,
        354: sl_y2,
        355: sl_z2,
        681: sl_k1,
        67: sl_c1,
        258: sl_a3,
        356: sl_y2,
        357: sl_z2,
        690: sl_k1,
        81: sl_c1,
        353: sl_d1,
        440: sl_b3,
        441: sl_c3,
        682: sl_k1,
        68: sl_c1,
        259: sl_d1,
        146: sl_y2,
        650: sl_q2,
        740: sl_d3,
        69: sl_c1,
        262: sl_d1,
        683: sl_e3,
        694: sl_f3,
        180: sl_z2,
        70: sl_c1,
        263: sl_d1,
        684: sl_k1,
        72: sl_c1,
        277: sl_d1,
        686: sl_k1,
        181: sl_g3,
        147: sl_h3,
        741: sl_w1,
        276: sl_i3,
        275: sl_j3
    },
    34: {
        419: sl_g2,
        519: sl_h2,
        664: sl_k1,
        21: sl_c1,
        195: sl_d1,
        138: sl_i1,
        182: sl_j1,
        734: sl_w1,
        756: sl_u1,
        698: sl_i2,
        794: sl_j2,
        860: sl_k2,
        83: sl_y1,
        420: sl_g2,
        520: sl_h2,
        665: sl_k1,
        22: sl_c1,
        196: sl_d1,
        139: sl_i1,
        183: sl_j1,
        735: sl_w1,
        757: sl_u1,
        699: sl_i2,
        795: sl_j2,
        861: sl_k2,
        84: sl_y1,
        652: sl_k1,
        2: sl_c1,
        160: sl_d1,
        148: sl_i1,
        154: sl_j1,
        655: sl_k1,
        5: sl_c1,
        163: sl_d1,
        149: sl_i1,
        155: sl_j1,
        657: sl_k1,
        7: sl_c1,
        165: sl_d1,
        150: sl_i1,
        156: sl_j1,
        658: sl_k1,
        930: sl_c1,
        166: sl_d1,
        151: sl_i1,
        157: sl_j1,
        660: sl_k1,
        9: sl_c1,
        168: sl_d1,
        152: sl_i1,
        158: sl_j1,
        663: sl_k1,
        12: sl_c1,
        171: sl_d1,
        153: sl_i1,
        159: sl_j1,
        255: sl_d1,
        353: sl_d1
    },
    19: {
        664: sl_k1,
        21: sl_c1,
        195: sl_d1,
        877: sl_u1,
        138: sl_i1,
        182: sl_j1,
        875: sl_p1,
        873: sl_q1,
        196: sl_d1,
        878: sl_u1,
        876: sl_p1,
        874: sl_q1,
        665: sl_k1,
        22: sl_c1
    },
    30: {
        664: sl_k1,
        21: sl_c1,
        195: sl_d1,
        756: sl_u1,
        138: sl_i1,
        182: sl_j1,
        734: sl_w1,
        83: sl_y1,
        698: sl_k3,
        665: sl_k1,
        22: sl_c1,
        196: sl_d1,
        757: sl_u1,
        139: sl_i1,
        183: sl_j1,
        735: sl_w1,
        84: sl_y1,
        699: sl_k3,
        666: sl_k1,
        23: sl_c1,
        197: sl_d1,
        758: sl_u1,
        140: sl_i1,
        184: sl_j1,
        736: sl_w1,
        85: sl_y1,
        700: sl_k3,
        653: sl_k1,
        161: sl_d1,
        3: sl_c1,
        654: sl_k1,
        162: sl_d1,
        4: sl_c1,
        656: sl_k1,
        164: sl_d1,
        6: sl_c1,
        659: sl_k1,
        167: sl_d1,
        8: sl_c1,
        661: sl_k1,
        169: sl_d1,
        10: sl_c1,
        662: sl_k1,
        170: sl_d1,
        11: sl_c1
    },
    9: {
        664: sl_k1,
        195: sl_d1,
        665: sl_k1,
        196: sl_d1
    },
    29: {
        366: sl_k1,
        21: sl_c1,
        195: sl_d1,
        466: sl_l3,
        557: sl_e1,
        799: sl_m3,
        83: sl_y1,
        367: sl_k1,
        22: sl_c1,
        196: sl_d1,
        467: sl_l3,
        558: sl_e1,
        800: sl_m3,
        84: sl_y1,
        368: sl_k1,
        23: sl_c1,
        197: sl_d1,
        468: sl_l3,
        559: sl_e1,
        801: sl_m3,
        85: sl_y1,
        369: sl_k1,
        24: sl_c1,
        198: sl_d1,
        469: sl_l3,
        560: sl_e1,
        802: sl_m3,
        86: sl_y1,
        370: sl_k1,
        25: sl_c1,
        199: sl_d1,
        470: sl_l3,
        561: sl_e1,
        803: sl_m3,
        87: sl_y1,
        371: sl_k1,
        26: sl_c1,
        200: sl_d1,
        471: sl_l3,
        562: sl_e1,
        804: sl_m3,
        88: sl_y1,
        372: sl_k1,
        27: sl_c1,
        201: sl_d1,
        472: sl_l3,
        563: sl_e1,
        805: sl_m3,
        89: sl_y1,
        373: sl_k1,
        28: sl_c1,
        202: sl_d1,
        473: sl_l3,
        564: sl_e1,
        806: sl_m3,
        90: sl_y1,
        374: sl_k1,
        29: sl_c1,
        203: sl_d1,
        474: sl_l3,
        565: sl_e1,
        807: sl_m3,
        91: sl_y1,
        375: sl_k1,
        30: sl_c1,
        204: sl_d1,
        475: sl_l3,
        566: sl_e1,
        808: sl_m3,
        92: sl_y1,
        376: sl_k1,
        31: sl_c1,
        205: sl_d1,
        476: sl_l3,
        567: sl_e1,
        809: sl_m3,
        93: sl_y1,
        377: sl_k1,
        32: sl_c1,
        206: sl_d1,
        477: sl_l3,
        568: sl_e1,
        810: sl_m3,
        94: sl_y1,
        378: sl_k1,
        33: sl_c1,
        207: sl_d1,
        478: sl_l3,
        569: sl_e1,
        811: sl_m3,
        95: sl_y1,
        379: sl_k1,
        34: sl_c1,
        208: sl_d1,
        479: sl_l3,
        570: sl_e1,
        812: sl_m3,
        96: sl_y1,
        380: sl_k1,
        35: sl_c1,
        209: sl_d1,
        480: sl_l3,
        571: sl_e1,
        813: sl_m3,
        97: sl_y1,
        381: sl_k1,
        36: sl_c1,
        210: sl_d1,
        481: sl_l3,
        572: sl_e1,
        814: sl_m3,
        98: sl_y1,
        382: sl_k1,
        37: sl_c1,
        211: sl_d1,
        482: sl_l3,
        573: sl_e1,
        815: sl_m3,
        99: sl_y1,
        383: sl_k1,
        38: sl_c1,
        212: sl_d1,
        483: sl_l3,
        574: sl_e1,
        816: sl_m3,
        100: sl_y1,
        384: sl_k1,
        39: sl_c1,
        213: sl_d1,
        484: sl_l3,
        575: sl_e1,
        817: sl_m3,
        101: sl_y1,
        385: sl_k1,
        40: sl_c1,
        214: sl_d1,
        485: sl_l3,
        576: sl_e1,
        818: sl_m3,
        104: sl_y1,
        386: sl_k1,
        41: sl_c1,
        215: sl_d1,
        486: sl_l3,
        577: sl_e1,
        819: sl_m3,
        105: sl_y1,
        387: sl_k1,
        42: sl_c1,
        216: sl_d1,
        487: sl_l3,
        578: sl_e1,
        820: sl_m3,
        106: sl_y1,
        388: sl_k1,
        43: sl_c1,
        217: sl_d1,
        488: sl_l3,
        579: sl_e1,
        821: sl_m3,
        107: sl_y1,
        389: sl_k1,
        44: sl_c1,
        218: sl_d1,
        489: sl_l3,
        580: sl_e1,
        822: sl_m3,
        108: sl_y1,
        390: sl_k1,
        45: sl_c1,
        219: sl_d1,
        490: sl_l3,
        581: sl_e1,
        823: sl_m3,
        109: sl_y1,
        391: sl_k1,
        46: sl_c1,
        220: sl_d1,
        491: sl_l3,
        582: sl_e1,
        824: sl_m3,
        110: sl_y1,
        392: sl_k1,
        47: sl_c1,
        221: sl_d1,
        492: sl_l3,
        583: sl_e1,
        825: sl_m3,
        111: sl_y1,
        393: sl_k1,
        48: sl_c1,
        222: sl_d1,
        493: sl_l3,
        584: sl_e1,
        826: sl_m3,
        112: sl_y1,
        394: sl_k1,
        49: sl_c1,
        223: sl_d1,
        494: sl_l3,
        585: sl_e1,
        827: sl_m3,
        113: sl_y1,
        395: sl_k1,
        50: sl_c1,
        224: sl_d1,
        495: sl_l3,
        586: sl_e1,
        828: sl_m3,
        114: sl_y1,
        396: sl_k1,
        51: sl_c1,
        225: sl_d1,
        496: sl_l3,
        587: sl_e1,
        829: sl_m3,
        115: sl_y1,
        397: sl_k1,
        52: sl_c1,
        226: sl_d1,
        497: sl_l3,
        588: sl_e1,
        830: sl_m3,
        116: sl_y1,
        398: sl_k1,
        53: sl_c1,
        227: sl_d1,
        498: sl_l3,
        589: sl_e1,
        831: sl_m3,
        117: sl_y1,
        399: sl_k1,
        54: sl_c1,
        228: sl_d1,
        499: sl_l3,
        590: sl_e1,
        832: sl_m3,
        118: sl_y1,
        400: sl_k1,
        55: sl_c1,
        229: sl_d1,
        500: sl_l3,
        591: sl_e1,
        833: sl_m3,
        119: sl_y1,
        401: sl_k1,
        56: sl_c1,
        230: sl_d1,
        501: sl_l3,
        592: sl_e1,
        834: sl_m3,
        120: sl_y1,
        402: sl_k1,
        57: sl_c1,
        231: sl_d1,
        502: sl_l3,
        593: sl_e1,
        835: sl_m3,
        121: sl_y1
    },
    2: {
        366: sl_b1,
        21: sl_c1,
        195: sl_d1,
        138: sl_i1,
        182: sl_j1,
        607: sl_n3,
        557: sl_e1,
        863: sl_u1,
        885: sl_u1,
        122: sl_g1,
        129: sl_h1,
        83: sl_y1,
        367: sl_b1,
        22: sl_c1,
        196: sl_d1,
        139: sl_i1,
        183: sl_j1,
        608: sl_n3,
        558: sl_e1,
        864: sl_u1,
        886: sl_u1,
        123: sl_g1,
        130: sl_h1,
        84: sl_y1,
        368: sl_b1,
        23: sl_c1,
        197: sl_d1,
        140: sl_i1,
        184: sl_j1,
        609: sl_n3,
        559: sl_e1,
        865: sl_u1,
        887: sl_u1,
        124: sl_g1,
        131: sl_h1,
        85: sl_y1,
        369: sl_b1,
        24: sl_c1,
        198: sl_d1,
        141: sl_i1,
        185: sl_j1,
        610: sl_n3,
        560: sl_e1,
        866: sl_u1,
        888: sl_u1,
        125: sl_g1,
        132: sl_h1,
        86: sl_y1,
        370: sl_b1,
        25: sl_c1,
        199: sl_d1,
        142: sl_i1,
        186: sl_j1,
        611: sl_n3,
        561: sl_e1,
        867: sl_u1,
        889: sl_u1,
        126: sl_g1,
        133: sl_h1,
        87: sl_y1,
        371: sl_b1,
        26: sl_c1,
        200: sl_d1,
        143: sl_i1,
        187: sl_j1,
        612: sl_n3,
        562: sl_e1,
        868: sl_u1,
        890: sl_u1,
        127: sl_g1,
        134: sl_h1,
        88: sl_y1,
        372: sl_b1,
        27: sl_c1,
        201: sl_d1,
        144: sl_i1,
        188: sl_j1,
        613: sl_n3,
        563: sl_e1,
        869: sl_u1,
        891: sl_u1,
        128: sl_g1,
        135: sl_h1,
        89: sl_y1
    },
    6: {
        1861: sl_o3,
        366: sl_b1,
        21: sl_c1,
        195: sl_d1,
        138: sl_i1,
        182: sl_j1,
        333: sl_p3,
        557: sl_q3,
        745: sl_r3,
        896: sl_s3,
        618: sl_t3,
        594: sl_u3,
        759: sl_v3,
        750: sl_w3,
        190: sl_x3,
        83: sl_y1,
        300: sl_y3,
        310: sl_z3,
        545: sl_a4,
        508: sl_b4,
        552: sl_c4,
        708: sl_d4,
        76: sl_e4,
        367: sl_b1,
        22: sl_c1,
        196: sl_d1,
        139: sl_i1,
        183: sl_j1,
        334: sl_p3,
        558: sl_q3,
        746: sl_r3,
        897: sl_s3,
        619: sl_t3,
        595: sl_u3,
        760: sl_v3,
        751: sl_w3,
        191: sl_x3,
        84: sl_y1,
        301: sl_y3,
        311: sl_z3,
        546: sl_a4,
        509: sl_b4,
        553: sl_c4,
        709: sl_d4,
        77: sl_e4,
        368: sl_b1,
        23: sl_c1,
        197: sl_d1,
        140: sl_i1,
        184: sl_j1,
        335: sl_p3,
        559: sl_q3,
        747: sl_r3,
        898: sl_s3,
        620: sl_t3,
        596: sl_u3,
        761: sl_v3,
        752: sl_w3,
        192: sl_x3,
        85: sl_y1,
        302: sl_y3,
        312: sl_z3,
        547: sl_a4,
        510: sl_b4,
        554: sl_c4,
        710: sl_d4,
        78: sl_e4,
        369: sl_b1,
        24: sl_c1,
        198: sl_d1,
        141: sl_i1,
        185: sl_j1,
        336: sl_p3,
        560: sl_q3,
        748: sl_r3,
        899: sl_s3,
        621: sl_t3,
        597: sl_u3,
        762: sl_v3,
        753: sl_w3,
        193: sl_x3,
        86: sl_y1,
        303: sl_y3,
        313: sl_z3,
        548: sl_a4,
        511: sl_b4,
        555: sl_c4,
        711: sl_d4,
        79: sl_e4,
        370: sl_b1,
        25: sl_c1,
        199: sl_d1,
        142: sl_i1,
        186: sl_j1,
        337: sl_p3,
        561: sl_q3,
        749: sl_r3,
        900: sl_s3,
        622: sl_t3,
        598: sl_u3,
        763: sl_v3,
        754: sl_w3,
        194: sl_x3,
        87: sl_y1,
        304: sl_y3,
        314: sl_z3,
        549: sl_a4,
        512: sl_b4,
        556: sl_c4,
        712: sl_d4,
        80: sl_e4
    },
    4: {
        366: sl_k1,
        21: sl_c1,
        195: sl_d1,
        138: sl_i1,
        182: sl_j1,
        896: sl_s3,
        557: sl_e1,
        836: sl_p1,
        909: sl_q1,
        914: sl_u1,
        920: sl_u1,
        83: sl_y1,
        903: sl_s1,
        607: sl_f4,
        367: sl_k1,
        22: sl_c1,
        196: sl_d1,
        139: sl_i1,
        183: sl_j1,
        897: sl_s3,
        558: sl_e1,
        837: sl_p1,
        910: sl_q1,
        915: sl_u1,
        921: sl_u1,
        84: sl_y1,
        904: sl_s1,
        608: sl_f4,
        368: sl_k1,
        23: sl_c1,
        197: sl_d1,
        140: sl_i1,
        184: sl_j1,
        898: sl_s3,
        559: sl_e1,
        838: sl_p1,
        911: sl_q1,
        916: sl_u1,
        922: sl_u1,
        85: sl_y1,
        905: sl_s1,
        609: sl_f4,
        369: sl_k1,
        24: sl_c1,
        198: sl_d1,
        141: sl_i1,
        185: sl_j1,
        899: sl_s3,
        560: sl_e1,
        839: sl_p1,
        912: sl_q1,
        917: sl_u1,
        923: sl_u1,
        86: sl_y1,
        906: sl_s1,
        610: sl_f4,
        370: sl_k1,
        25: sl_c1,
        199: sl_d1,
        142: sl_i1,
        186: sl_j1,
        900: sl_s3,
        561: sl_e1,
        840: sl_p1,
        913: sl_q1,
        918: sl_u1,
        924: sl_u1,
        87: sl_y1,
        907: sl_s1,
        611: sl_f4,
        26: sl_c1,
        200: sl_d1,
        143: sl_i1,
        187: sl_j1,
        371: sl_k1,
        562: sl_e1,
        919: sl_u1,
        925: sl_u1,
        901: sl_x1,
        908: sl_s1,
        88: sl_y1,
        362: sl_b1,
        17: sl_c1,
        176: sl_d1,
        358: sl_b1,
        13: sl_c1,
        172: sl_d1,
        363: sl_b1,
        18: sl_c1,
        177: sl_d1,
        359: sl_b1,
        14: sl_c1,
        173: sl_d1,
        364: sl_b1,
        19: sl_c1,
        178: sl_d1,
        360: sl_b1,
        15: sl_c1,
        174: sl_d1,
        365: sl_b1,
        20: sl_c1,
        179: sl_d1,
        361: sl_b1,
        16: sl_c1,
        175: sl_d1
    },
    8: {
        664: sl_k1,
        195: sl_d1,
        665: sl_k1,
        196: sl_d1,
        666: sl_k1,
        197: sl_d1,
        667: sl_k1,
        198: sl_d1
    }
};

let baseOutcomeConfig = {
    11: {
        74: bo_b1,
        349: bo_c1,
        256: bo_d1,
        306: bo_e1,
        103: bo_f1,
        403: bo_g1,
        443: bo_h1,
        608: bo_i1
    },
    32: {
        73: bo_b1,
        318: bo_j1,
        21: bo_k1,
        22: bo_l1,
        23: bo_m1,
        195: bo_n1,
        196: bo_o1,
        197: bo_p1,
        352: bo_q1,
        748: bo_r1,
        102: bo_s1,
        403: bo_g1,
        366: bo_t1,
        367: bo_u1,
        368: bo_v1,
        138: bo_w1,
        139: bo_x1,
        140: bo_y1,
        182: bo_z1,
        183: bo_a2,
        184: bo_b2,
        122: bo_c2,
        123: bo_d2,
        124: bo_e2,
        129: bo_f2,
        130: bo_g2,
        131: bo_h2,
        566: bo_i2,
        567: bo_j2,
        568: bo_k2,
        616: bo_l2,
        617: bo_m2,
        618: bo_n2,
        257: bo_o2,
        307: bo_p2,
        443: bo_h1,
        608: bo_i1,
        362: bo_q2,
        363: bo_r2,
        364: bo_s2,
        17: bo_t2,
        18: bo_u2,
        19: bo_v2,
        176: bo_w2,
        177: bo_x2,
        178: bo_y2,
        358: bo_z2,
        359: bo_a3,
        360: bo_b3,
        13: bo_c3,
        14: bo_d3,
        15: bo_e3,
        172: bo_f3,
        173: bo_g3,
        174: bo_h3,
        256: bo_d1,
        306: bo_e1
    },
    35: {
        138: bo_i3,
        256: bo_d1,
        21: bo_j3,
        673: bo_k3,
        182: bo_l3,
        306: bo_e1,
        698: bo_g1,
        731: bo_m3,
        656: bo_n3,
        195: bo_o3,
        74: bo_b1,
        349: bo_j1,
        443: bo_h1,
        608: bo_i1,
        911: bo_p3,
        426: bo_q3,
        535: bo_r3,
        871: bo_s3,
        710: bo_t3,
        742: bo_u3
    },
    10: {
        74: bo_b1,
        349: bo_c1,
        256: bo_d1,
        306: bo_e1,
        103: bo_f1,
        403: bo_g1,
        1: bo_v3,
        443: bo_h1,
        608: bo_i1
    },
    31: {
        74: bo_b1,
        349: bo_c1,
        21: bo_w3,
        22: bo_x3,
        23: bo_y3,
        24: bo_z3,
        256: bo_d1,
        306: bo_e1,
        195: bo_a4,
        196: bo_b4,
        197: bo_c4,
        198: bo_d4,
        673: bo_e4,
        674: bo_f4,
        675: bo_g4,
        676: bo_h4,
        103: bo_i4,
        403: bo_g1,
        138: bo_j4,
        139: bo_k4,
        140: bo_l4,
        141: bo_m4,
        182: bo_n4,
        183: bo_o4,
        184: bo_p4,
        185: bo_q4,
        238: bo_o3,
        682: bo_r4,
        239: bo_s4,
        58: bo_j3,
        59: bo_t4,
        681: bo_k3,
        234: bo_i3,
        235: bo_u4,
        236: bo_l3,
        237: bo_v4,
        725: bo_w4,
        726: bo_x4,
        727: bo_y4,
        728: bo_z4,
        782: bo_a5,
        778: bo_b5,
        779: bo_c5,
        780: bo_d5,
        781: bo_e5,
        783: bo_f5,
        773: bo_g5,
        474: bo_h5,
        421: bo_i5,
        530: bo_j5,
        422: bo_k5,
        531: bo_l5,
        444: bo_m5,
        888: bo_n5,
        280: bo_o5,
        317: bo_p5,
        424: bo_q5,
        533: bo_r5,
        423: bo_s5,
        532: bo_t5,
        637: bo_u5,
        788: bo_v5,
        784: bo_w5,
        785: bo_x5,
        786: bo_y5,
        787: bo_z5,
        774: bo_a6,
        775: bo_b6,
        776: bo_c6,
        777: bo_d6,
        281: bo_e6,
        137: bo_f6,
        246: bo_g6,
        248: bo_h6,
        240: bo_i6,
        232: bo_j6,
        241: bo_k6,
        233: bo_l6,
        61: bo_m6,
        62: bo_n6,
        684: bo_o6,
        685: bo_p6,
        443: bo_h1,
        608: bo_i1,
        890: bo_q6,
        242: bo_r6,
        245: bo_s6,
        243: bo_t6,
        60: bo_u6,
        683: bo_v6,
        406: bo_w6,
        405: bo_x6,
        404: bo_y6,
        700: bo_z6,
        408: bo_a7,
        407: bo_b7,
        247: bo_c7,
        244: bo_d7,
        638: bo_e7,
        639: bo_f7,
        640: bo_g7,
        641: bo_h7,
        646: bo_i7,
        642: bo_j7,
        643: bo_k7,
        644: bo_l7,
        645: bo_m7
    },
    41: {
        74: bo_b1,
        349: bo_c1,
        21: bo_j3,
        22: bo_t4,
        403: bo_g1,
        673: bo_k3,
        674: bo_r4,
        195: bo_o3,
        196: bo_s4,
        791: bo_n7,
        792: bo_o7,
        637: bo_u5,
        796: bo_v5,
        794: bo_p7,
        795: bo_q7,
        789: bo_r7,
        790: bo_s7,
        725: bo_t7,
        726: bo_u7,
        793: bo_a5,
        411: bo_v7,
        701: bo_m5,
        251: bo_w7,
        252: bo_x7,
        409: bo_k5,
        430: bo_l5,
        410: bo_s5,
        431: bo_t5,
        281: bo_e6,
        137: bo_f6,
        249: bo_g6,
        250: bo_h6,
        63: bo_m6,
        64: bo_n6,
        686: bo_o6,
        687: bo_p6,
        103: bo_i4,
        256: bo_d1,
        306: bo_e1,
        138: bo_i3,
        139: bo_u4,
        182: bo_l3,
        183: bo_v4,
        443: bo_h1,
        608: bo_i1,
        648: bo_y7,
        649: bo_z7
    },
    18: {
        74: bo_b1,
        349: bo_j1,
        656: bo_n3,
        698: bo_g1,
        256: bo_d1,
        306: bo_e1,
        195: bo_a8,
        196: bo_b8,
        197: bo_c8,
        673: bo_d8,
        674: bo_e8,
        675: bo_f8,
        610: bo_g8,
        443: bo_h1,
        608: bo_i1,
        806: bo_v5,
        893: bo_v5,
        707: bo_h8,
        708: bo_i8,
        709: bo_j8,
        889: bo_a5,
        904: bo_k8,
        253: bo_l8,
        688: bo_m8,
        65: bo_n8,
        751: bo_o8,
        21: bo_p8,
        22: bo_q8,
        23: bo_r8,
        743: bo_s8,
        744: bo_t8,
        745: bo_u8,
        615: bo_v8,
        350: bo_l8
    },
    3: {
        73: bo_b1,
        318: bo_j1,
        21: bo_w8,
        22: bo_x8,
        23: bo_y8,
        195: bo_z8,
        196: bo_a9,
        197: bo_b9,
        352: bo_c9,
        746: bo_r1,
        102: bo_s1,
        403: bo_g1,
        138: bo_d9,
        139: bo_e9,
        140: bo_f9,
        182: bo_g9,
        183: bo_h9,
        184: bo_i9,
        366: bo_j9,
        367: bo_k9,
        368: bo_l9,
        566: bo_m9,
        567: bo_n9,
        568: bo_o9,
        74: bo_p9,
        854: bo_q9,
        855: bo_r9,
        856: bo_s9,
        857: bo_q9,
        858: bo_r9,
        859: bo_s9,
        797: bo_t9,
        798: bo_u9,
        799: bo_v9,
        851: bo_w9,
        852: bo_x9,
        853: bo_y9,
        83: bo_z9,
        84: bo_a10,
        85: bo_b10,
        905: bo_c10,
        906: bo_d10,
        907: bo_e10,
        443: bo_h1,
        608: bo_i1,
        362: bo_q2,
        363: bo_r2,
        17: bo_t2,
        18: bo_u2,
        176: bo_w2,
        177: bo_x2,
        358: bo_z2,
        359: bo_a3,
        13: bo_c3,
        14: bo_d3,
        172: bo_f3,
        173: bo_g3,
        616: bo_f10,
        617: bo_g10,
        618: bo_h10,
        891: bo_i10,
        257: bo_d1,
        307: bo_e1,
        800: bo_j10,
        801: bo_k10,
        802: bo_l10
    },
    20: {
        74: bo_b1,
        349: bo_m10,
        256: bo_d1,
        306: bo_e1,
        698: bo_g1,
        195: bo_n10,
        196: bo_o10,
        197: bo_p10,
        198: bo_q10,
        199: bo_r10,
        200: bo_s10,
        201: bo_t10,
        202: bo_u10,
        138: bo_v10,
        139: bo_w10,
        140: bo_x10,
        141: bo_y10,
        142: bo_z10,
        143: bo_a11,
        144: bo_b11,
        145: bo_c11,
        182: bo_d11,
        183: bo_e11,
        184: bo_f11,
        185: bo_g11,
        186: bo_h11,
        187: bo_i11,
        188: bo_j11,
        189: bo_k11,
        21: bo_l11,
        22: bo_m11,
        23: bo_n11,
        24: bo_o11,
        25: bo_p11,
        26: bo_q11,
        27: bo_r11,
        28: bo_s11,
        673: bo_t11,
        674: bo_u11,
        675: bo_v11,
        676: bo_w11,
        677: bo_x11,
        678: bo_y11,
        679: bo_z11,
        680: bo_a12,
        860: bo_b12,
        861: bo_c12,
        862: bo_d12,
        863: bo_e12,
        864: bo_f12,
        865: bo_g12,
        866: bo_h12,
        867: bo_i12,
        443: bo_h1,
        608: bo_i1
    },
    5: {
        349: bo_j1,
        698: bo_g1,
        443: bo_h1,
        608: bo_i1,
        945: bo_j12,
        948: bo_k12,
        949: bo_l12
    },
    40: {
        656: bo_m12,
        698: bo_g1,
        443: bo_h1,
        608: bo_i1
    },
    37: {
        443: bo_h1,
        608: bo_i1
    },
    38: {
        403: bo_g1,
        443: bo_h1,
        608: bo_i1,
        74: bo_b1,
        349: bo_n12,
        615: bo_o12,
        413: bo_p12,
        414: bo_q12
    },
    42: {
        403: bo_g1,
        443: bo_h1,
        608: bo_i1,
        74: bo_b1,
        349: bo_n12,
        615: bo_r12,
        413: bo_p12,
        414: bo_s12,
        566: bo_t12,
        567: bo_u12,
        568: bo_v12,
        569: bo_w12,
        570: bo_x12,
        698: bo_g1,
        366: bo_y12,
        367: bo_z12,
        368: bo_a13,
        369: bo_b13,
        370: bo_c13,
        940: bo_d13,
        941: bo_e13,
        942: bo_f13,
        943: bo_g13,
        944: bo_h13
    },
    26: {
        443: bo_h1,
        608: bo_i1
    },
    25: {
        443: bo_h1,
        608: bo_i1
    },
    16: {
        443: bo_h1,
        608: bo_i1
    },
    12: {
        74: bo_b1,
        349: bo_c1,
        656: bo_n3,
        698: bo_g1,
        256: bo_d1,
        306: bo_e1,
        103: bo_f1,
        443: bo_h1,
        608: bo_i1
    },
    36: {
        610: bo_i13,
        698: bo_g1,
        656: bo_n3,
        74: bo_b1,
        349: bo_c1,
        615: bo_v8,
        256: bo_d1,
        306: bo_e1,
        673: bo_d8,
        21: bo_p8,
        195: bo_a8,
        443: bo_h1,
        608: bo_i1
    },
    7: {
        425: bo_k5,
        534: bo_l5,
        540: bo_j13,
        343: bo_k13,
        345: bo_w7,
        260: bo_l13,
        261: bo_m13,
        83: bo_n13,
        84: bo_o13,
        803: bo_p13,
        868: bo_q13,
        869: bo_r13,
        870: bo_s13,
        805: bo_t13,
        892: bo_u13,
        346: bo_v13,
        419: bo_w13,
        528: bo_x13,
        420: bo_y13,
        529: bo_z13,
        707: bo_a14,
        708: bo_b14,
        706: bo_c14,
        804: bo_d14,
        474: bo_e14,
        614: bo_f14,
        609: bo_g14,
        416: bo_h14,
        732: bo_i14,
        525: bo_j14,
        850: bo_k14,
        473: bo_l14,
        442: bo_m14,
        729: bo_n14,
        538: bo_o14,
        542: bo_p14,
        730: bo_q14,
        471: bo_r14,
        635: bo_s14,
        714: bo_t14,
        624: bo_u14,
        625: bo_v14,
        715: bo_w14,
        650: bo_x14,
        651: bo_y14,
        652: bo_z14,
        653: bo_a15,
        654: bo_b15,
        655: bo_c15,
        634: bo_d15,
        626: bo_e15,
        733: bo_f15,
        734: bo_g15,
        258: bo_h15,
        259: bo_i15,
        66: bo_j15,
        67: bo_k15,
        81: bo_l15,
        68: bo_m15,
        689: bo_n15,
        690: bo_o15,
        699: bo_p15,
        691: bo_q15,
        723: bo_r15,
        633: bo_s15,
        74: bo_b1,
        349: bo_t15,
        656: bo_n3,
        698: bo_g1,
        322: bo_u15,
        904: bo_v15,
        1: bo_v3,
        136: bo_w15,
        747: bo_u3,
        871: bo_s3,
        255: bo_x15,
        705: bo_y15,
        323: bo_z15,
        324: bo_a16,
        702: bo_b16,
        278: bo_c16,
        256: bo_d1,
        306: bo_e1,
        195: bo_o3,
        196: bo_s4,
        21: bo_j3,
        22: bo_t4,
        282: bo_d16,
        911: bo_i10,
        353: bo_e16,
        673: bo_k3,
        674: bo_r4,
        2: bo_f16,
        5: bo_g16,
        7: bo_h16,
        939: bo_i16,
        9: bo_j16,
        12: bo_k16,
        417: bo_l16,
        526: bo_m16,
        325: bo_n16,
        103: bo_o16,
        160: bo_p16,
        163: bo_q16,
        165: bo_r16,
        166: bo_s16,
        168: bo_t16,
        171: bo_u16,
        148: bo_v16,
        149: bo_w16,
        150: bo_x16,
        151: bo_y16,
        152: bo_z16,
        153: bo_a17,
        154: bo_b17,
        155: bo_c17,
        156: bo_d17,
        157: bo_e17,
        158: bo_f17,
        159: bo_g17,
        731: bo_v8,
        765: bo_h17,
        766: bo_i17,
        415: bo_j17,
        524: bo_k17,
        418: bo_l17,
        527: bo_m17,
        743: bo_n17,
        744: bo_o17,
        710: bo_t3,
        321: bo_p17,
        326: bo_q17,
        327: bo_r17,
        724: bo_s17,
        661: bo_t17,
        664: bo_u17,
        666: bo_v17,
        667: bo_w17,
        669: bo_x17,
        672: bo_y17,
        426: bo_q3,
        535: bo_r3,
        537: bo_z17,
        541: bo_a18,
        539: bo_b18,
        138: bo_i3,
        139: bo_u4,
        182: bo_l3,
        183: bo_v4,
        437: bo_c18,
        436: bo_d18,
        694: bo_e18,
        71: bo_f18,
        271: bo_g18,
        268: bo_h18,
        265: bo_i18,
        267: bo_j18,
        270: bo_k18,
        272: bo_l18,
        269: bo_m18,
        266: bo_n18,
        264: bo_o18,
        281: bo_e6,
        137: bo_f6,
        660: bo_n3,
        880: bo_p18,
        879: bo_q18,
        429: bo_r18,
        433: bo_s18,
        443: bo_h1,
        608: bo_i1,
        881: bo_t18,
        273: bo_u18,
        274: bo_v18,
        435: bo_w18,
        704: bo_x18,
        432: bo_y18,
        428: bo_z18,
        434: bo_a19,
        439: bo_b19,
        440: bo_c19,
        441: bo_d19,
        438: bo_e19,
        623: bo_f19,
        180: bo_g19,
        146: bo_h19,
        659: bo_i19,
        749: bo_j19,
        69: bo_k19,
        262: bo_l19,
        692: bo_m19,
        703: bo_n19,
        70: bo_o19,
        263: bo_p19,
        693: bo_q19,
        72: bo_r19,
        277: bo_s19,
        695: bo_t19,
        750: bo_u19,
        181: bo_v19,
        147: bo_w19,
        276: bo_x19,
        275: bo_y19,
        735: bo_z19,
        736: bo_a20,
        737: bo_b20,
        738: bo_c20,
        739: bo_d20,
        740: bo_e20,
        356: bo_f20,
        357: bo_g20,
        354: bo_h20,
        355: bo_i20,
        937: bo_b16,
        657: bo_j20,
        658: bo_k20,
        412: bo_l20
    },
    14: {
        443: bo_h1,
        608: bo_i1
    },
    34: {
        425: bo_k5,
        534: bo_l5,
        540: bo_m20,
        343: bo_k13,
        345: bo_w7,
        260: bo_l13,
        261: bo_m13,
        83: bo_n20,
        84: bo_o20,
        803: bo_p20,
        868: bo_q20,
        869: bo_r20,
        870: bo_s20,
        346: bo_v13,
        419: bo_w13,
        528: bo_x13,
        420: bo_y13,
        529: bo_z13,
        707: bo_a14,
        708: bo_b14,
        706: bo_t20,
        538: bo_u20,
        74: bo_b1,
        349: bo_v20,
        656: bo_m12,
        698: bo_g1,
        322: bo_u15,
        904: bo_w20,
        1: bo_v3,
        136: bo_w15,
        747: bo_x20,
        871: bo_y20,
        255: bo_x15,
        705: bo_z20,
        323: bo_a21,
        324: bo_b21,
        702: bo_b16,
        278: bo_c21,
        256: bo_d1,
        306: bo_e1,
        195: bo_o3,
        196: bo_s4,
        21: bo_j3,
        22: bo_t4,
        282: bo_d16,
        911: bo_p3,
        353: bo_d21,
        673: bo_k3,
        674: bo_r4,
        2: bo_e21,
        5: bo_f21,
        7: bo_h16,
        939: bo_g21,
        9: bo_h21,
        12: bo_k16,
        417: bo_i21,
        526: bo_j21,
        325: bo_k21,
        103: bo_l21,
        160: bo_m21,
        163: bo_n21,
        165: bo_r16,
        166: bo_o21,
        168: bo_p21,
        171: bo_u16,
        148: bo_q21,
        149: bo_r21,
        150: bo_x16,
        151: bo_s21,
        152: bo_t21,
        153: bo_a17,
        154: bo_u21,
        155: bo_v21,
        156: bo_d17,
        157: bo_w21,
        158: bo_x21,
        159: bo_g17,
        731: bo_v8,
        765: bo_h17,
        766: bo_i17,
        415: bo_j17,
        524: bo_k17,
        418: bo_l17,
        527: bo_y21,
        743: bo_n17,
        744: bo_o17,
        710: bo_t3,
        321: bo_z21,
        326: bo_q17,
        327: bo_r17,
        724: bo_s17,
        661: bo_a22,
        664: bo_b22,
        666: bo_c22,
        667: bo_d22,
        669: bo_e22,
        672: bo_f22,
        426: bo_q3,
        535: bo_r3,
        537: bo_z17,
        541: bo_a18,
        539: bo_g22,
        138: bo_i3,
        139: bo_u4,
        182: bo_l3,
        183: bo_v4,
        443: bo_h1,
        608: bo_i1
    },
    19: {
        74: bo_b1,
        349: bo_j1,
        698: bo_g1,
        256: bo_d1,
        306: bo_e1,
        195: bo_a8,
        196: bo_b8,
        103: bo_s1,
        615: bo_h22,
        886: bo_i22,
        887: bo_j22,
        911: bo_k22,
        884: bo_l22,
        885: bo_m22,
        882: bo_n22,
        883: bo_o22,
        723: bo_p22,
        673: bo_d8,
        674: bo_e8,
        21: bo_j3,
        22: bo_t4,
        138: bo_i3,
        182: bo_l3,
        443: bo_h1,
        608: bo_i1
    },
    30: {
        74: bo_b1,
        349: bo_c1,
        656: bo_n3,
        698: bo_g1,
        21: bo_p8,
        22: bo_q8,
        23: bo_r8,
        279: bo_q22,
        610: bo_r22,
        256: bo_d1,
        306: bo_e1,
        195: bo_a8,
        196: bo_b8,
        197: bo_c8,
        673: bo_d8,
        674: bo_e8,
        675: bo_f8,
        350: bo_l8,
        103: bo_i4,
        415: bo_j17,
        524: bo_k17,
        743: bo_s8,
        744: bo_t8,
        745: bo_u8,
        710: bo_t3,
        403: bo_g1,
        426: bo_s22,
        535: bo_t22,
        706: bo_u22,
        343: bo_k13,
        346: bo_v13,
        83: bo_v22,
        84: bo_w22,
        85: bo_x22,
        344: bo_y22,
        347: bo_z22,
        765: bo_i22,
        766: bo_j22,
        767: bo_a23,
        138: bo_b23,
        139: bo_c23,
        140: bo_d23,
        182: bo_e23,
        183: bo_f23,
        184: bo_g23,
        751: bo_o8,
        911: bo_p3,
        889: bo_a5,
        637: bo_h23,
        615: bo_v8,
        412: bo_i23,
        634: bo_j23,
        626: bo_k23,
        611: bo_l23,
        443: bo_h1,
        608: bo_i1,
        904: bo_k8,
        449: bo_m23,
        446: bo_n23,
        451: bo_o23,
        711: bo_p23,
        712: bo_p23,
        713: bo_p23,
        450: bo_q23,
        447: bo_r23,
        448: bo_s23,
        662: bo_t23,
        663: bo_u23,
        665: bo_v23,
        668: bo_w23,
        670: bo_x23,
        671: bo_y23,
        3: bo_z23,
        4: bo_a24,
        6: bo_b24,
        8: bo_c24,
        10: bo_d24,
        11: bo_e24,
        161: bo_f24,
        162: bo_g24,
        164: bo_h24,
        167: bo_i24,
        169: bo_j24,
        170: bo_k24,
        707: bo_h8,
        708: bo_i8,
        709: bo_j8,
        946: bo_h14,
        947: bo_j14
    },
    23: {
        443: bo_h1,
        608: bo_i1
    },
    13: {
        468: bo_l24,
        470: bo_m24,
        467: bo_n24,
        469: bo_o24,
        464: bo_p24,
        466: bo_q24,
        465: bo_r24,
        463: bo_s24,
        289: bo_t24,
        288: bo_u24,
        292: bo_v24,
        461: bo_w24,
        283: bo_x24,
        295: bo_y24,
        293: bo_z24,
        284: bo_a25,
        285: bo_b25,
        316: bo_c25,
        286: bo_d25,
        287: bo_e25,
        290: bo_f25,
        291: bo_g25,
        462: bo_h25,
        294: bo_i25
    },
    39: {
        403: bo_g1,
        443: bo_h1,
        608: bo_i1,
        698: bo_g1,
        349: bo_j1,
        950: bo_l12,
        955: bo_j12,
        951: bo_j25,
        952: bo_k25,
        953: bo_l25,
        954: bo_m25
    },
    33: {
        348: bo_n25,
        443: bo_h1,
        608: bo_i1
    },
    24: {
        443: bo_h1,
        608: bo_i1
    },
    9: {
        74: bo_b1,
        349: bo_j1,
        656: bo_n3,
        698: bo_g1,
        256: bo_d1,
        306: bo_e1,
        195: bo_o3,
        196: bo_s4,
        673: bo_k3,
        674: bo_r4,
        443: bo_h1,
        608: bo_i1
    },
    21: {
        443: bo_h1,
        608: bo_i1
    },
    29: {
        394: bo_o25,
        395: bo_p25,
        396: bo_q25,
        397: bo_r25,
        398: bo_s25,
        399: bo_t25,
        400: bo_u25,
        401: bo_v25,
        402: bo_w25,
        100: bo_x25,
        101: bo_y25,
        104: bo_z25,
        105: bo_a26,
        106: bo_b26,
        107: bo_c26,
        108: bo_d26,
        109: bo_e26,
        110: bo_f26,
        111: bo_g26,
        112: bo_h26,
        113: bo_i26,
        114: bo_j26,
        115: bo_k26,
        116: bo_l26,
        117: bo_m26,
        118: bo_n26,
        119: bo_o26,
        120: bo_p26,
        121: bo_q26,
        808: bo_r26,
        809: bo_s26,
        810: bo_t26,
        811: bo_u26,
        812: bo_v26,
        813: bo_w26,
        814: bo_x26,
        815: bo_y26,
        816: bo_z26,
        817: bo_a27,
        818: bo_b27,
        819: bo_c27,
        820: bo_d27,
        821: bo_e27,
        822: bo_f27,
        823: bo_g27,
        824: bo_h27,
        825: bo_i27,
        826: bo_j27,
        827: bo_k27,
        828: bo_l27,
        829: bo_m27,
        830: bo_n27,
        831: bo_o27,
        832: bo_p27,
        833: bo_q27,
        834: bo_r27,
        835: bo_s27,
        836: bo_t27,
        837: bo_u27,
        838: bo_v27,
        839: bo_w27,
        840: bo_x27,
        841: bo_y27,
        842: bo_z27,
        843: bo_a28,
        844: bo_b28,
        366: bo_c28,
        367: bo_d28,
        368: bo_e28,
        369: bo_f28,
        370: bo_g28,
        371: bo_h28,
        372: bo_i28,
        373: bo_j28,
        374: bo_k28,
        375: bo_l28,
        376: bo_m28,
        377: bo_n28,
        378: bo_o28,
        379: bo_p28,
        380: bo_q28,
        381: bo_r28,
        382: bo_s28,
        383: bo_t28,
        384: bo_u28,
        385: bo_v28,
        386: bo_w28,
        387: bo_x28,
        388: bo_y28,
        389: bo_z28,
        390: bo_a29,
        391: bo_b29,
        392: bo_c29,
        393: bo_d29,
        481: bo_e29,
        482: bo_f29,
        483: bo_g29,
        484: bo_h29,
        485: bo_i29,
        486: bo_j29,
        487: bo_k29,
        488: bo_l29,
        489: bo_m29,
        490: bo_n29,
        491: bo_o29,
        492: bo_p29,
        493: bo_q29,
        494: bo_r29,
        495: bo_s29,
        496: bo_t29,
        497: bo_u29,
        498: bo_v29,
        499: bo_w29,
        500: bo_x29,
        501: bo_y29,
        502: bo_z29,
        503: bo_a30,
        504: bo_b30,
        505: bo_c30,
        506: bo_d30,
        507: bo_e30,
        508: bo_f30,
        509: bo_g30,
        510: bo_h30,
        511: bo_i30,
        566: bo_j30,
        567: bo_k30,
        568: bo_l30,
        569: bo_m30,
        570: bo_n30,
        571: bo_o30,
        572: bo_p30,
        573: bo_q30,
        574: bo_r30,
        575: bo_s30,
        576: bo_t30,
        577: bo_u30,
        578: bo_v30,
        579: bo_w30,
        580: bo_x30,
        581: bo_y30,
        582: bo_z30,
        583: bo_a31,
        584: bo_b31,
        585: bo_c31,
        586: bo_d31,
        587: bo_e31,
        588: bo_f31,
        589: bo_g31,
        590: bo_h31,
        591: bo_i31,
        592: bo_j31,
        593: bo_k31,
        594: bo_l31,
        595: bo_m31,
        596: bo_n31,
        597: bo_o31,
        598: bo_p31,
        599: bo_q31,
        600: bo_r31,
        601: bo_s31,
        602: bo_t31,
        83: bo_u31,
        84: bo_v31,
        85: bo_w31,
        86: bo_x31,
        87: bo_y31,
        88: bo_z31,
        89: bo_a32,
        90: bo_b32,
        91: bo_c32,
        92: bo_d32,
        93: bo_e32,
        94: bo_f32,
        95: bo_g32,
        96: bo_h32,
        97: bo_i32,
        98: bo_j32,
        99: bo_k32,
        74: bo_b1,
        349: bo_j1,
        254: bo_l32,
        403: bo_g1,
        21: bo_m32,
        22: bo_n32,
        23: bo_o32,
        24: bo_p32,
        25: bo_q32,
        26: bo_r32,
        27: bo_s32,
        28: bo_t32,
        29: bo_u32,
        30: bo_v32,
        31: bo_w32,
        32: bo_x32,
        33: bo_y32,
        34: bo_z32,
        35: bo_a33,
        36: bo_b33,
        37: bo_c33,
        38: bo_d33,
        39: bo_e33,
        40: bo_f33,
        41: bo_g33,
        42: bo_h33,
        43: bo_i33,
        44: bo_j33,
        45: bo_k33,
        46: bo_l33,
        47: bo_m33,
        48: bo_n33,
        49: bo_o33,
        50: bo_p33,
        51: bo_q33,
        52: bo_r33,
        53: bo_s33,
        54: bo_t33,
        55: bo_u33,
        56: bo_v33,
        57: bo_w33,
        195: bo_x33,
        196: bo_y33,
        197: bo_z33,
        198: bo_a34,
        199: bo_b34,
        200: bo_c34,
        201: bo_d34,
        202: bo_e34,
        203: bo_f34,
        204: bo_g34,
        205: bo_h34,
        206: bo_i34,
        207: bo_j34,
        208: bo_k34,
        209: bo_l34,
        210: bo_m34,
        211: bo_n34,
        212: bo_o34,
        213: bo_p34,
        214: bo_q34,
        215: bo_r34,
        216: bo_s34,
        217: bo_t34,
        218: bo_u34,
        219: bo_v34,
        220: bo_w34,
        221: bo_x34,
        222: bo_y34,
        223: bo_z34,
        224: bo_a35,
        225: bo_b35,
        226: bo_c35,
        227: bo_d35,
        228: bo_e35,
        229: bo_f35,
        230: bo_g35,
        231: bo_h35,
        475: bo_i35,
        476: bo_j35,
        477: bo_k35,
        478: bo_l35,
        479: bo_m35,
        480: bo_n35,
        443: bo_h1,
        608: bo_i1
    },
    15: {
        443: bo_h1,
        608: bo_i1
    },
    2: {
        73: bo_b1,
        318: bo_j1,
        21: bo_k1,
        22: bo_l1,
        23: bo_m1,
        24: bo_o35,
        25: bo_p35,
        26: bo_q35,
        27: bo_r35,
        195: bo_n1,
        196: bo_o1,
        197: bo_p1,
        198: bo_s35,
        199: bo_t35,
        200: bo_u35,
        201: bo_v35,
        352: bo_w35,
        102: bo_s1,
        403: bo_g1,
        138: bo_w1,
        139: bo_x1,
        140: bo_y1,
        141: bo_x35,
        142: bo_y35,
        143: bo_z35,
        144: bo_a36,
        182: bo_z1,
        183: bo_a2,
        184: bo_b2,
        185: bo_b36,
        186: bo_c36,
        187: bo_d36,
        188: bo_e36,
        566: bo_i2,
        567: bo_j2,
        568: bo_k2,
        569: bo_f36,
        570: bo_g36,
        571: bo_h36,
        572: bo_i36,
        366: bo_t1,
        367: bo_u1,
        368: bo_v1,
        369: bo_j36,
        370: bo_k36,
        371: bo_l36,
        372: bo_m36,
        122: bo_n36,
        123: bo_o36,
        124: bo_p36,
        125: bo_q36,
        126: bo_r36,
        127: bo_s36,
        128: bo_t36,
        129: bo_u36,
        130: bo_v36,
        131: bo_w36,
        132: bo_x36,
        133: bo_y36,
        134: bo_z36,
        135: bo_a37,
        872: bo_b37,
        873: bo_c37,
        874: bo_d37,
        875: bo_e37,
        876: bo_f37,
        877: bo_g37,
        878: bo_h37,
        616: bo_i37,
        617: bo_j37,
        618: bo_k37,
        619: bo_l37,
        620: bo_m37,
        621: bo_n37,
        622: bo_o37,
        894: bo_b37,
        895: bo_c37,
        896: bo_d37,
        897: bo_e37,
        898: bo_f37,
        899: bo_g37,
        900: bo_h37,
        443: bo_h1,
        608: bo_i1,
        83: bo_z9,
        84: bo_a10,
        85: bo_b10,
        86: bo_p37,
        87: bo_q37,
        88: bo_r37,
        89: bo_s37,
        257: bo_d1,
        307: bo_e1,
        752: bo_t37,
        753: bo_t37
    },
    6: {
        553: bo_u37,
        339: bo_v37,
        547: bo_w37,
        138: bo_d9,
        139: bo_e9,
        140: bo_f9,
        141: bo_x37,
        142: bo_y37,
        182: bo_g9,
        183: bo_h9,
        184: bo_i9,
        185: bo_z37,
        186: bo_a38,
        83: bo_z9,
        84: bo_a10,
        85: bo_b10,
        86: bo_p37,
        87: bo_q37,
        807: bo_b38,
        636: bo_c38,
        334: bo_d38,
        335: bo_e38,
        336: bo_f38,
        337: bo_g38,
        906: bo_h38,
        907: bo_i38,
        908: bo_j38,
        909: bo_k38,
        300: bo_l38,
        301: bo_m38,
        302: bo_n38,
        303: bo_o38,
        304: bo_p38,
        310: bo_q38,
        311: bo_r38,
        312: bo_s38,
        313: bo_t38,
        314: bo_u38,
        554: bo_v38,
        555: bo_w38,
        556: bo_x38,
        557: bo_y38,
        558: bo_z38,
        517: bo_a39,
        518: bo_a39,
        519: bo_b39,
        520: bo_c39,
        521: bo_d39,
        561: bo_e39,
        562: bo_f39,
        563: bo_g39,
        564: bo_h39,
        565: bo_i39,
        73: bo_j39,
        318: bo_j1,
        21: bo_w8,
        22: bo_x8,
        23: bo_y8,
        24: bo_k39,
        25: bo_l39,
        195: bo_z8,
        196: bo_a9,
        197: bo_b9,
        198: bo_m39,
        199: bo_n39,
        352: bo_o39,
        748: bo_r1,
        102: bo_s1,
        403: bo_g1,
        903: bo_p39,
        445: bo_q39,
        754: bo_r39,
        755: bo_s39,
        756: bo_t39,
        757: bo_u39,
        758: bo_v39,
        452: bo_w39,
        453: bo_x39,
        454: bo_y39,
        566: bo_z39,
        567: bo_a40,
        568: bo_b40,
        569: bo_c40,
        570: bo_d40,
        366: bo_j9,
        367: bo_k9,
        368: bo_l9,
        369: bo_e40,
        370: bo_f40,
        522: bo_g40,
        627: bo_h40,
        628: bo_i40,
        629: bo_j40,
        630: bo_k40,
        631: bo_l40,
        632: bo_m40,
        190: bo_n40,
        191: bo_o40,
        192: bo_p40,
        193: bo_q40,
        194: bo_r40,
        759: bo_s40,
        760: bo_t40,
        761: bo_u40,
        762: bo_v40,
        763: bo_w40,
        768: bo_x40,
        769: bo_y40,
        770: bo_z40,
        771: bo_a41,
        772: bo_b41,
        603: bo_c41,
        604: bo_d41,
        605: bo_e41,
        606: bo_f41,
        607: bo_g41,
        257: bo_d1,
        307: bo_e1,
        696: bo_g1,
        333: bo_h41,
        341: bo_i41,
        427: bo_j41,
        536: bo_k41,
        905: bo_l41,
        320: bo_m41,
        514: bo_n41,
        516: bo_o41,
        305: bo_p41,
        315: bo_q41,
        523: bo_r41,
        299: bo_s41,
        309: bo_t41,
        697: bo_u41,
        298: bo_v41,
        308: bo_w41,
        515: bo_x41,
        549: bo_y41,
        548: bo_z41,
        443: bo_h1,
        608: bo_i1,
        550: bo_a42,
        551: bo_a42,
        455: bo_b42,
        456: bo_b42,
        457: bo_c42,
        458: bo_c42,
        459: bo_d42,
        460: bo_d42,
        512: bo_g40,
        513: bo_g40,
        901: bo_e42,
        902: bo_e42,
        340: bo_f42,
        328: bo_g42,
        329: bo_h42,
        342: bo_i42,
        330: bo_j42,
        331: bo_k42,
        722: bo_l42,
        560: bo_m42,
        543: bo_n42,
        544: bo_o42,
        545: bo_p42,
        546: bo_q42,
        332: bo_r42,
        559: bo_s42,
        296: bo_t42,
        297: bo_u42,
        717: bo_v42,
        718: bo_w42,
        719: bo_x42,
        720: bo_y42,
        721: bo_z42,
        552: bo_a43,
        76: bo_b43,
        77: bo_c43,
        78: bo_d43,
        79: bo_e43,
        80: bo_f43,
        647: bo_g43,
        741: bo_h43,
        82: bo_i43,
        338: bo_j43
    },
    17: {
        348: bo_n25,
        443: bo_h1,
        608: bo_i1
    },
    4: {
        73: bo_b1,
        318: bo_j1,
        21: bo_w8,
        22: bo_x8,
        23: bo_y8,
        24: bo_k39,
        25: bo_l39,
        195: bo_z8,
        196: bo_a9,
        197: bo_b9,
        198: bo_m39,
        199: bo_n39,
        352: bo_c9,
        764: bo_t37,
        102: bo_s1,
        403: bo_g1,
        138: bo_d9,
        139: bo_e9,
        140: bo_f9,
        141: bo_x37,
        142: bo_y37,
        182: bo_g9,
        183: bo_h9,
        184: bo_i9,
        185: bo_z37,
        186: bo_a38,
        366: bo_k43,
        367: bo_l43,
        368: bo_m43,
        369: bo_n43,
        370: bo_o43,
        566: bo_m9,
        567: bo_n9,
        568: bo_o9,
        569: bo_p43,
        570: bo_q43,
        74: bo_r43,
        923: bo_s43,
        924: bo_t43,
        925: bo_u43,
        926: bo_v43,
        927: bo_w43,
        929: bo_s43,
        930: bo_t43,
        931: bo_u43,
        932: bo_v43,
        933: bo_w43,
        845: bo_t9,
        846: bo_u9,
        847: bo_v9,
        848: bo_x43,
        849: bo_y43,
        918: bo_w9,
        919: bo_x9,
        920: bo_y9,
        921: bo_z43,
        922: bo_a44,
        83: bo_z9,
        84: bo_a10,
        85: bo_b10,
        86: bo_p37,
        87: bo_q37,
        905: bo_b44,
        906: bo_d10,
        907: bo_e10,
        908: bo_c44,
        909: bo_d44,
        807: bo_e44,
        319: bo_f44,
        320: bo_m41,
        912: bo_j10,
        913: bo_k10,
        914: bo_l10,
        915: bo_g44,
        916: bo_h44,
        443: bo_h1,
        608: bo_i1,
        257: bo_d1,
        307: bo_e1,
        362: bo_q2,
        363: bo_r2,
        364: bo_s2,
        365: bo_i44,
        17: bo_t2,
        18: bo_u2,
        19: bo_v2,
        20: bo_j44,
        176: bo_w2,
        177: bo_x2,
        178: bo_y2,
        179: bo_k44,
        358: bo_z2,
        359: bo_a3,
        360: bo_b3,
        361: bo_l44,
        13: bo_c3,
        14: bo_d3,
        15: bo_e3,
        16: bo_m44,
        172: bo_f3,
        173: bo_g3,
        174: bo_h3,
        175: bo_n44,
        281: bo_e6,
        137: bo_f6,
        616: bo_o44,
        617: bo_p44,
        618: bo_q44,
        619: bo_r44,
        620: bo_s44,
        891: bo_t44,
        26: bo_u44,
        200: bo_v44,
        143: bo_w44,
        187: bo_x44,
        371: bo_y44,
        571: bo_z44,
        928: bo_a45,
        934: bo_a45,
        88: bo_b45,
        910: bo_c45,
        917: bo_d45,
        936: bo_e45
    },
    8: {
        74: bo_b1,
        349: bo_j1,
        656: bo_n3,
        698: bo_g1,
        256: bo_d1,
        306: bo_e1,
        195: bo_a4,
        196: bo_b4,
        197: bo_c4,
        198: bo_d4,
        673: bo_e4,
        674: bo_f4,
        675: bo_g4,
        676: bo_h4,
        103: bo_s1,
        443: bo_h1,
        608: bo_i1
    },
    27: {
        443: bo_h1,
        608: bo_i1
    },
    28: {
        403: bo_g1,
        615: bo_f45,
        74: bo_g45,
        349: bo_c1,
        256: bo_d1,
        306: bo_e1,
        103: bo_f1,
        935: bo_h45,
        612: bo_i45,
        613: bo_j45,
        443: bo_h1,
        608: bo_i1
    }
};

let outcomeConfig = {
    7: {
        426: (match, outcome) => `${match.homeTeam} to win by ${outcome.condition} ${plural(outcome.condition, ['goal', 'goals'])}`,
        535: (match, outcome) => `${match.awayTeam} to win by ${outcome.condition} ${plural(outcome.condition, ['goal', 'goals'])}`
    },
    6: {
        455: (match, outcome) => `To Be 15x15 In ${outcome.condition} game?`,
        456: (match, outcome) => `To Be 15x15 In ${outcome.condition} game?`,
        457: (match, outcome) => `To Be 30x30 In ${outcome.condition} game?`,
        458: (match, outcome) => `To Be 30x30 In ${outcome.condition} game?`,
        459: (match, outcome) => `To Be 40x40 In ${outcome.condition} game?`,
        460: (match, outcome) => `To Be 40x40 In ${outcome.condition} game?`
    }
};

let baseFactorNameConfig = {
    11: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        403: {
            1: fa_h1,
            2: fa_i1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    32: {
        73: {
            1: fa_b1,
            2: fa_c1
        },
        318: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        352: {
            1: fa_d1,
            2: fa_e1
        },
        748: {
            1: fa_n1,
            2: fa_o1,
            3: fa_p1,
            4: fa_q1,
            5: fa_r1,
            6: fa_s1,
            7: fa_t1,
            8: fa_u1,
            9: fa_v1,
            10: fa_w1
        },
        102: {
            1: fa_f1,
            2: fa_g1
        },
        403: {
            1: fa_x1,
            2: fa_y1
        },
        366: {
            1: fa_x1,
            2: fa_y1
        },
        367: {
            1: fa_x1,
            2: fa_y1
        },
        368: {
            1: fa_x1,
            2: fa_y1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        140: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        184: {
            1: fa_d1,
            2: fa_e1
        },
        122: {
            1: fa_l1,
            2: fa_m1
        },
        123: {
            1: fa_l1,
            2: fa_m1
        },
        124: {
            1: fa_l1,
            2: fa_m1
        },
        129: {
            1: fa_l1,
            2: fa_m1
        },
        130: {
            1: fa_l1,
            2: fa_m1
        },
        131: {
            1: fa_l1,
            2: fa_m1
        },
        566: {
            1: fa_h1,
            2: fa_i1
        },
        567: {
            1: fa_h1,
            2: fa_i1
        },
        568: {
            1: fa_h1,
            2: fa_i1
        },
        616: {
            1: fa_h1,
            2: fa_i1
        },
        617: {
            1: fa_h1,
            2: fa_i1
        },
        618: {
            1: fa_h1,
            2: fa_i1
        },
        257: {
            1: fa_d1,
            2: fa_e1
        },
        307: {
            1: fa_d1,
            2: fa_e1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        362: {
            1: fa_x1,
            2: fa_y1
        },
        363: {
            1: fa_x1,
            2: fa_y1
        },
        364: {
            1: fa_x1,
            2: fa_y1
        },
        17: {
            1: fa_b1,
            2: fa_c1
        },
        18: {
            1: fa_b1,
            2: fa_c1
        },
        19: {
            1: fa_b1,
            2: fa_c1
        },
        176: {
            1: fa_d1,
            2: fa_e1
        },
        177: {
            1: fa_d1,
            2: fa_e1
        },
        178: {
            1: fa_d1,
            2: fa_e1
        },
        358: {
            1: fa_x1,
            2: fa_y1
        },
        359: {
            1: fa_x1,
            2: fa_y1
        },
        360: {
            1: fa_x1,
            2: fa_y1
        },
        13: {
            1: fa_b1,
            2: fa_c1
        },
        14: {
            1: fa_b1,
            2: fa_c1
        },
        15: {
            1: fa_b1,
            2: fa_c1
        },
        172: {
            1: fa_d1,
            2: fa_e1
        },
        173: {
            1: fa_d1,
            2: fa_e1
        },
        174: {
            1: fa_d1,
            2: fa_e1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        }
    },
    35: {
        138: {
            1: fa_d1,
            2: fa_e1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        673: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        698: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        731: {
            1: fa_h1,
            2: fa_a2,
            3: fa_i1
        },
        656: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        911: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2,
            4: fa_h2,
            5: fa_i2,
            6: fa_j2
        },
        426: {
            1: fa_l1,
            2: fa_m1
        },
        535: {
            1: fa_l1,
            2: fa_m1
        },
        871: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        710: {
            1: fa_q2,
            2: fa_r2,
            3: fa_s2
        },
        742: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_v2,
            6: fa_w2,
            7: fa_x2,
            8: fa_y2,
            9: fa_p1,
            10: fa_q1,
            11: fa_z2,
            12: fa_a3,
            13: fa_r1,
            14: fa_s1,
            15: fa_b3,
            16: fa_t1,
            17: fa_c3,
            18: fa_d3,
            19: fa_e3,
            20: fa_u1,
            21: fa_v1,
            22: fa_w1,
            23: fa_f3,
            24: fa_g3,
            25: fa_h3,
            26: fa_i3,
            27: fa_j3,
            28: fa_k3,
            29: fa_l3,
            30: fa_m3,
            31: fa_n3,
            32: fa_o3,
            33: fa_p3,
            34: fa_q3,
            35: fa_r3
        }
    },
    10: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        403: {
            1: fa_x1,
            2: fa_y1
        },
        1: {
            1: fa_b1,
            2: fa_c1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    31: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        24: {
            1: fa_b1,
            2: fa_c1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        198: {
            1: fa_d1,
            2: fa_e1
        },
        673: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        674: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        675: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        676: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        403: {
            1: fa_x1,
            2: fa_y1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        140: {
            1: fa_d1,
            2: fa_e1
        },
        141: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        184: {
            1: fa_d1,
            2: fa_e1
        },
        185: {
            1: fa_d1,
            2: fa_e1
        },
        238: {
            1: fa_d1,
            2: fa_e1
        },
        682: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        239: {
            1: fa_d1,
            2: fa_e1
        },
        58: {
            1: fa_b1,
            2: fa_c1
        },
        59: {
            1: fa_b1,
            2: fa_c1
        },
        681: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        234: {
            1: fa_d1,
            2: fa_e1
        },
        235: {
            1: fa_d1,
            2: fa_e1
        },
        236: {
            1: fa_d1,
            2: fa_e1
        },
        237: {
            1: fa_d1,
            2: fa_e1
        },
        725: {
            1: fa_h1,
            2: fa_a2,
            3: fa_i1
        },
        726: {
            1: fa_h1,
            2: fa_a2,
            3: fa_i1
        },
        727: {
            1: fa_h1,
            2: fa_a2,
            3: fa_i1
        },
        728: {
            1: fa_h1,
            2: fa_a2,
            3: fa_i1
        },
        782: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_w3,
            6: fa_x3
        },
        778: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_w3,
            6: fa_x3
        },
        779: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_w3,
            6: fa_x3
        },
        780: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_w3,
            6: fa_x3
        },
        781: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_w3,
            6: fa_x3
        },
        783: {
            1: fa_p1,
            2: fa_h3,
            3: fa_y3,
            4: fa_z3,
            5: fa_a4,
            6: fa_b4,
            7: fa_c4,
            8: fa_y1
        },
        773: {
            1: fa_p1,
            2: fa_h3,
            3: fa_y3,
            4: fa_z3,
            5: fa_a4,
            6: fa_b4,
            7: fa_c4,
            8: fa_x1
        },
        474: {
            1: fa_h1,
            2: fa_i1
        },
        421: {
            1: fa_l1,
            2: fa_m1
        },
        530: {
            1: fa_l1,
            2: fa_m1
        },
        422: {
            1: fa_l1,
            2: fa_m1
        },
        531: {
            1: fa_l1,
            2: fa_m1
        },
        444: {
            1: fa_d4,
            2: fa_e4
        },
        888: {
            1: fa_f4,
            2: fa_g4,
            3: fa_h4,
            4: fa_i4
        },
        280: {
            1: fa_d1,
            2: fa_e1
        },
        317: {
            1: fa_d1,
            2: fa_e1
        },
        424: {
            1: fa_l1,
            2: fa_m1
        },
        533: {
            1: fa_l1,
            2: fa_m1
        },
        423: {
            1: fa_l1,
            2: fa_m1
        },
        532: {
            1: fa_l1,
            2: fa_m1
        },
        637: {
            1: fa_l1,
            2: fa_m1
        },
        788: {
            1: fa_j4,
            2: fa_k4,
            3: fa_l4,
            4: fa_m4,
            5: fa_n4,
            6: fa_o4,
            7: fa_p4,
            8: fa_q4,
            9: fa_r4,
            10: fa_s4,
            11: fa_t4,
            12: fa_u4,
            13: fa_v4,
            14: fa_w4
        },
        784: {
            1: fa_j4,
            2: fa_x4,
            3: fa_y4,
            4: fa_z4,
            5: fa_a5
        },
        785: {
            1: fa_j4,
            2: fa_x4,
            3: fa_y4,
            4: fa_z4,
            5: fa_a5
        },
        786: {
            1: fa_j4,
            2: fa_x4,
            3: fa_y4,
            4: fa_z4,
            5: fa_a5
        },
        787: {
            1: fa_j4,
            2: fa_x4,
            3: fa_y4,
            4: fa_z4,
            5: fa_a5
        },
        774: {
            1: fa_q4,
            2: fa_b5,
            3: fa_c5,
            4: fa_d5,
            5: fa_e5
        },
        775: {
            1: fa_q4,
            2: fa_b5,
            3: fa_c5,
            4: fa_d5,
            5: fa_e5
        },
        776: {
            1: fa_q4,
            2: fa_b5,
            3: fa_c5,
            4: fa_d5,
            5: fa_e5
        },
        777: {
            1: fa_q4,
            2: fa_b5,
            3: fa_c5,
            4: fa_d5,
            5: fa_e5
        },
        281: {
            1: fa_d1,
            2: fa_e1
        },
        137: {
            1: fa_d1,
            2: fa_e1
        },
        246: {
            1: fa_d1,
            2: fa_e1
        },
        248: {
            1: fa_d1,
            2: fa_e1
        },
        240: {
            1: fa_d1,
            2: fa_e1
        },
        232: {
            1: fa_d1,
            2: fa_e1
        },
        241: {
            1: fa_d1,
            2: fa_e1
        },
        233: {
            1: fa_d1,
            2: fa_e1
        },
        61: {
            1: fa_b1,
            2: fa_c1
        },
        62: {
            1: fa_b1,
            2: fa_c1
        },
        684: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        685: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        890: {
            1: fa_f4,
            2: fa_g4,
            3: fa_h4,
            4: fa_i4
        },
        242: {
            1: fa_d1,
            2: fa_e1
        },
        245: {
            1: fa_d1,
            2: fa_e1
        },
        243: {
            1: fa_d1,
            2: fa_e1
        },
        60: {
            1: fa_b1,
            2: fa_c1
        },
        683: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        406: {
            1: fa_h1,
            2: fa_i1
        },
        405: {
            1: fa_h1,
            2: fa_i1
        },
        404: {
            1: fa_h1,
            2: fa_i1
        },
        700: {
            1: fa_f5,
            2: fa_g5,
            3: fa_h5
        },
        408: {
            1: fa_h1,
            2: fa_i1
        },
        407: {
            1: fa_h1,
            2: fa_i1
        },
        247: {
            1: fa_d1,
            2: fa_e1
        },
        244: {
            1: fa_d1,
            2: fa_e1
        },
        638: {
            1: fa_h1,
            2: fa_i1
        },
        639: {
            1: fa_h1,
            2: fa_i1
        },
        640: {
            1: fa_h1,
            2: fa_i1
        },
        641: {
            1: fa_h1,
            2: fa_i1
        },
        646: {
            1: fa_i5,
            2: fa_j5,
            3: fa_k5
        },
        642: {
            1: fa_i5,
            2: fa_j5,
            3: fa_k5
        },
        643: {
            1: fa_i5,
            2: fa_j5,
            3: fa_k5
        },
        644: {
            1: fa_i5,
            2: fa_j5,
            3: fa_k5
        },
        645: {
            1: fa_i5,
            2: fa_j5,
            3: fa_k5
        }
    },
    41: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        403: {
            1: fa_x1,
            2: fa_y1
        },
        673: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        674: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        791: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_w3,
            6: fa_x3
        },
        792: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_w3,
            6: fa_x3
        },
        637: {
            1: fa_l1,
            2: fa_m1
        },
        796: {
            1: fa_j4,
            2: fa_k4,
            3: fa_l4,
            4: fa_m4,
            5: fa_n4,
            6: fa_o4,
            7: fa_p4,
            8: fa_q4,
            9: fa_r4,
            10: fa_s4,
            11: fa_t4,
            12: fa_u4,
            13: fa_v4,
            14: fa_w4
        },
        794: {
            1: fa_j4,
            2: fa_x4,
            3: fa_y4,
            4: fa_z4,
            5: fa_a5
        },
        795: {
            1: fa_j4,
            2: fa_x4,
            3: fa_y4,
            4: fa_z4,
            5: fa_a5
        },
        789: {
            1: fa_q4,
            2: fa_b5,
            3: fa_c5,
            4: fa_d5,
            5: fa_e5
        },
        790: {
            1: fa_q4,
            2: fa_b5,
            3: fa_c5,
            4: fa_d5,
            5: fa_e5
        },
        725: {
            1: fa_h1,
            2: fa_a2,
            3: fa_i1
        },
        726: {
            1: fa_h1,
            2: fa_a2,
            3: fa_i1
        },
        793: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_w3,
            6: fa_x3
        },
        411: {
            1: fa_h1,
            2: fa_i1
        },
        701: {
            1: fa_d4,
            2: fa_e4,
            3: fa_l5
        },
        251: {
            1: fa_d1,
            2: fa_e1
        },
        252: {
            1: fa_d1,
            2: fa_e1
        },
        409: {
            1: fa_l1,
            2: fa_m1
        },
        430: {
            1: fa_l1,
            2: fa_m1
        },
        410: {
            1: fa_l1,
            2: fa_m1
        },
        431: {
            1: fa_l1,
            2: fa_m1
        },
        281: {
            1: fa_d1,
            2: fa_e1
        },
        137: {
            1: fa_d1,
            2: fa_e1
        },
        249: {
            1: fa_d1,
            2: fa_e1
        },
        250: {
            1: fa_d1,
            2: fa_e1
        },
        63: {
            1: fa_b1,
            2: fa_c1
        },
        64: {
            1: fa_b1,
            2: fa_c1
        },
        686: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        687: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        648: {
            1: fa_h1,
            2: fa_i1
        },
        649: {
            1: fa_h1,
            2: fa_i1
        }
    },
    18: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        656: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        698: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        673: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        674: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        675: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        610: {
            1: fa_x1,
            2: fa_y1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        806: {
            1: fa_m5,
            2: fa_n5,
            3: fa_o5,
            4: fa_p5,
            5: fa_q5,
            6: fa_a5
        },
        893: {
            1: fa_r5,
            2: fa_s5,
            3: fa_t5,
            4: fa_u5,
            5: fa_v5,
            6: fa_w5
        },
        707: {
            1: fa_q2,
            2: fa_r2,
            3: fa_l5
        },
        708: {
            1: fa_q2,
            2: fa_r2,
            3: fa_l5
        },
        709: {
            1: fa_q2,
            2: fa_r2,
            3: fa_l5
        },
        889: {
            1: fa_x5,
            2: fa_m2,
            3: fa_n2,
            4: fa_o2,
            5: fa_y5,
            6: fa_z5,
            7: fa_a6,
            8: fa_b6
        },
        904: {
            1: fa_c6,
            2: fa_d6,
            3: fa_e6,
            4: fa_f6,
            5: fa_g6,
            6: fa_h6,
            7: fa_i6,
            8: fa_j6,
            9: fa_k6
        },
        253: {
            1: fa_d1,
            2: fa_e1
        },
        688: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        65: {
            1: fa_b1,
            2: fa_c1
        },
        751: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_v2,
            6: fa_w2,
            7: fa_x2,
            8: fa_y2,
            9: fa_p1,
            10: fa_q1,
            11: fa_z2,
            12: fa_a3,
            13: fa_r1,
            14: fa_s1,
            15: fa_b3,
            16: fa_t1,
            17: fa_c3,
            18: fa_d3,
            19: fa_e3,
            20: fa_u1,
            21: fa_v1,
            22: fa_w1,
            23: fa_f3,
            24: fa_g3,
            25: fa_h3,
            26: fa_i3,
            27: fa_j3,
            28: fa_k3,
            29: fa_l3,
            30: fa_m3,
            31: fa_n3,
            32: fa_o3,
            33: fa_p3,
            34: fa_q3,
            35: fa_r3
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        743: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_r3
        },
        744: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_r3
        },
        745: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_r3
        },
        615: {
            1: fa_h1,
            2: fa_i1
        },
        350: {
            1: fa_d1,
            2: fa_e1
        }
    },
    3: {
        73: {
            1: fa_b1,
            2: fa_c1
        },
        318: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        352: {
            1: fa_d1,
            2: fa_e1
        },
        746: {
            1: fa_r1,
            2: fa_s1,
            3: fa_p1,
            4: fa_n1
        },
        102: {
            1: fa_f1,
            2: fa_g1
        },
        403: {
            1: fa_x1,
            2: fa_y1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        140: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        184: {
            1: fa_d1,
            2: fa_e1
        },
        366: {
            1: fa_x1,
            2: fa_y1
        },
        367: {
            1: fa_x1,
            2: fa_y1
        },
        368: {
            1: fa_x1,
            2: fa_y1
        },
        566: {
            1: fa_h1,
            2: fa_i1
        },
        567: {
            1: fa_h1,
            2: fa_i1
        },
        568: {
            1: fa_h1,
            2: fa_i1
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        854: {
            1: fa_s3,
            2: fa_l6,
            3: fa_m6,
            4: fa_n6,
            5: fa_o6,
            6: fa_p6,
            7: fa_q6,
            8: fa_r6
        },
        855: {
            1: fa_s3,
            2: fa_l6,
            3: fa_m6,
            4: fa_n6,
            5: fa_o6,
            6: fa_p6,
            7: fa_q6,
            8: fa_r6
        },
        856: {
            1: fa_s3,
            2: fa_l6,
            3: fa_m6,
            4: fa_n6,
            5: fa_o6,
            6: fa_p6,
            7: fa_q6,
            8: fa_r6
        },
        857: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_r6
        },
        858: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_r6
        },
        859: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_r6
        },
        797: {
            1: fa_t1,
            2: fa_s6,
            3: fa_t6,
            4: fa_y1
        },
        798: {
            1: fa_t1,
            2: fa_s6,
            3: fa_t6,
            4: fa_y1
        },
        799: {
            1: fa_t1,
            2: fa_s6,
            3: fa_u6,
            4: fa_y1
        },
        851: {
            1: fa_t1,
            2: fa_s6,
            3: fa_u6,
            4: fa_x1
        },
        852: {
            1: fa_t1,
            2: fa_s6,
            3: fa_u6,
            4: fa_x1
        },
        853: {
            1: fa_t1,
            2: fa_s6,
            3: fa_v6,
            4: fa_x1
        },
        83: {
            1: fa_f1,
            2: fa_g1
        },
        84: {
            1: fa_f1,
            2: fa_g1
        },
        85: {
            1: fa_f1,
            2: fa_g1
        },
        905: {
            1: fa_w6,
            2: fa_x6,
            3: fa_y6,
            4: fa_z6
        },
        906: {
            1: fa_w6,
            2: fa_x6,
            3: fa_y6,
            4: fa_z6
        },
        907: {
            1: fa_w6,
            2: fa_x6,
            3: fa_y6,
            4: fa_z6
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        362: {
            1: fa_x1,
            2: fa_y1
        },
        363: {
            1: fa_x1,
            2: fa_y1
        },
        17: {
            1: fa_b1,
            2: fa_c1
        },
        18: {
            1: fa_b1,
            2: fa_c1
        },
        176: {
            1: fa_d1,
            2: fa_e1
        },
        177: {
            1: fa_d1,
            2: fa_e1
        },
        358: {
            1: fa_x1,
            2: fa_y1
        },
        359: {
            1: fa_x1,
            2: fa_y1
        },
        13: {
            1: fa_b1,
            2: fa_c1
        },
        14: {
            1: fa_b1,
            2: fa_c1
        },
        172: {
            1: fa_d1,
            2: fa_e1
        },
        173: {
            1: fa_d1,
            2: fa_e1
        },
        616: {
            1: fa_h1,
            2: fa_i1
        },
        617: {
            1: fa_h1,
            2: fa_i1
        },
        618: {
            1: fa_h1,
            2: fa_i1
        },
        891: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2,
            4: fa_h2
        },
        257: {
            1: fa_d1,
            2: fa_e1
        },
        307: {
            1: fa_d1,
            2: fa_e1
        },
        800: {
            1: fa_a7,
            2: fa_b7,
            3: fa_c7,
            4: fa_d7,
            5: fa_e7,
            6: fa_f7
        },
        801: {
            1: fa_a7,
            2: fa_b7,
            3: fa_c7,
            4: fa_d7,
            5: fa_e7,
            6: fa_f7
        },
        802: {
            1: fa_a7,
            2: fa_b7,
            3: fa_c7,
            4: fa_d7,
            5: fa_e7,
            6: fa_f7
        }
    },
    20: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        698: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        198: {
            1: fa_d1,
            2: fa_e1
        },
        199: {
            1: fa_d1,
            2: fa_e1
        },
        200: {
            1: fa_d1,
            2: fa_e1
        },
        201: {
            1: fa_d1,
            2: fa_e1
        },
        202: {
            1: fa_d1,
            2: fa_e1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        140: {
            1: fa_d1,
            2: fa_e1
        },
        141: {
            1: fa_d1,
            2: fa_e1
        },
        142: {
            1: fa_d1,
            2: fa_e1
        },
        143: {
            1: fa_d1,
            2: fa_e1
        },
        144: {
            1: fa_d1,
            2: fa_e1
        },
        145: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        184: {
            1: fa_d1,
            2: fa_e1
        },
        185: {
            1: fa_d1,
            2: fa_e1
        },
        186: {
            1: fa_d1,
            2: fa_e1
        },
        187: {
            1: fa_d1,
            2: fa_e1
        },
        188: {
            1: fa_d1,
            2: fa_e1
        },
        189: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        24: {
            1: fa_b1,
            2: fa_c1
        },
        25: {
            1: fa_b1,
            2: fa_c1
        },
        26: {
            1: fa_b1,
            2: fa_c1
        },
        27: {
            1: fa_b1,
            2: fa_c1
        },
        28: {
            1: fa_b1,
            2: fa_c1
        },
        673: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        674: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        675: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        676: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        677: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        678: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        679: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        680: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        860: {
            1: fa_g7,
            2: fa_l6,
            3: fa_m6,
            4: fa_n6,
            5: fa_o6,
            6: fa_p6,
            7: fa_h7
        },
        861: {
            1: fa_g7,
            2: fa_l6,
            3: fa_m6,
            4: fa_n6,
            5: fa_o6,
            6: fa_p6,
            7: fa_h7
        },
        862: {
            1: fa_g7,
            2: fa_l6,
            3: fa_m6,
            4: fa_n6,
            5: fa_o6,
            6: fa_p6,
            7: fa_h7
        },
        863: {
            1: fa_g7,
            2: fa_l6,
            3: fa_m6,
            4: fa_n6,
            5: fa_o6,
            6: fa_p6,
            7: fa_h7
        },
        864: {
            1: fa_g7,
            2: fa_l6,
            3: fa_m6,
            4: fa_n6,
            5: fa_o6,
            6: fa_p6,
            7: fa_h7
        },
        865: {
            1: fa_g7,
            2: fa_l6,
            3: fa_m6,
            4: fa_n6,
            5: fa_o6,
            6: fa_p6,
            7: fa_h7
        },
        866: {
            1: fa_g7,
            2: fa_l6,
            3: fa_m6,
            4: fa_n6,
            5: fa_o6,
            6: fa_p6,
            7: fa_h7
        },
        867: {
            1: fa_g7,
            2: fa_l6,
            3: fa_m6,
            4: fa_n6,
            5: fa_o6,
            6: fa_p6,
            7: fa_h7
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    5: {
        349: {
            1: fa_d1,
            2: fa_e1
        },
        698: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        945: {
            1: fa_l1,
            2: fa_m1
        },
        948: {
            1: fa_i7,
            2: fa_j7,
            3: fa_k7,
            4: fa_l7,
            5: fa_m7
        },
        949: {
            1: fa_n7,
            2: fa_o7,
            3: fa_p7,
            4: fa_q7,
            5: fa_r7,
            6: fa_s7,
            7: fa_t7,
            8: fa_u7,
            9: fa_v7,
            10: fa_w7,
            11: fa_x7,
            12: fa_y7,
            13: fa_j7,
            14: fa_k7,
            15: fa_z7,
            16: fa_a8,
            17: fa_b8,
            18: fa_c8,
            19: fa_d8,
            20: fa_e8,
            21: fa_f8,
            22: fa_g8,
            23: fa_h8,
            24: fa_i8,
            25: fa_j8,
            26: fa_k8,
            27: fa_m7
        }
    },
    40: {
        656: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        698: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    37: {
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    38: {
        403: {
            1: fa_x1,
            2: fa_y1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        74: {
            1: fa_l8,
            2: fa_m8
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        615: {
            1: fa_h1,
            2: fa_i1
        },
        413: {
            1: fa_h1,
            2: fa_i1
        },
        414: {
            1: fa_h1,
            2: fa_i1
        }
    },
    42: {
        403: {
            1: fa_x1,
            2: fa_y1
        },
        443: {
            1: fa_n8,
            2: fa_o8
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        74: {
            1: fa_l8,
            2: fa_m8
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        615: {
            1: fa_h1,
            2: fa_i1
        },
        413: {
            1: fa_h1,
            2: fa_i1
        },
        414: {
            1: fa_h1,
            2: fa_i1
        },
        566: {
            1: fa_h1,
            2: fa_i1
        },
        567: {
            1: fa_h1,
            2: fa_i1
        },
        568: {
            1: fa_h1,
            2: fa_i1
        },
        569: {
            1: fa_h1,
            2: fa_i1
        },
        570: {
            1: fa_h1,
            2: fa_i1
        },
        698: {
            1: fa_h1,
            2: fa_p8,
            3: fa_i1
        },
        366: {
            1: fa_h1,
            2: fa_i1
        },
        367: {
            1: fa_h1,
            2: fa_i1
        },
        368: {
            1: fa_h1,
            2: fa_i1
        },
        369: {
            1: fa_h1,
            2: fa_i1
        },
        370: {
            1: fa_h1,
            2: fa_i1
        },
        940: {
            1: fa_h1,
            2: fa_i1
        },
        941: {
            1: fa_h1,
            2: fa_i1
        },
        942: {
            1: fa_h1,
            2: fa_i1
        },
        943: {
            1: fa_h1,
            2: fa_i1
        },
        944: {
            1: fa_h1,
            2: fa_i1
        }
    },
    26: {
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    25: {
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    16: {
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    12: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        656: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        698: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    36: {
        610: {
            1: fa_x1,
            2: fa_y1
        },
        698: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        656: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        615: {
            1: fa_h1,
            2: fa_i1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        673: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    7: {
        425: {
            1: fa_l1,
            2: fa_m1
        },
        534: {
            1: fa_l1,
            2: fa_m1
        },
        540: {
            1: fa_d1,
            2: fa_e1
        },
        343: {
            1: fa_d1,
            2: fa_e1
        },
        345: {
            1: fa_d1,
            2: fa_e1
        },
        260: {
            1: fa_l1,
            2: fa_m1
        },
        261: {
            1: fa_l1,
            2: fa_m1
        },
        83: {
            1: fa_f1,
            2: fa_g1
        },
        84: {
            1: fa_f1,
            2: fa_g1
        },
        803: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        868: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        869: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        870: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        805: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        892: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        346: {
            1: fa_d1,
            2: fa_e1
        },
        419: {
            1: fa_l1,
            2: fa_m1
        },
        528: {
            1: fa_l1,
            2: fa_m1
        },
        420: {
            1: fa_l1,
            2: fa_m1
        },
        529: {
            1: fa_l1,
            2: fa_m1
        },
        707: {
            1: fa_q2,
            2: fa_q8,
            3: fa_l5
        },
        708: {
            1: fa_q2,
            2: fa_q8,
            3: fa_l5
        },
        706: {
            1: fa_r8,
            2: fa_s8,
            3: fa_l5
        },
        804: {
            1: fa_t8,
            2: fa_u8,
            3: fa_v8,
            4: fa_w8
        },
        474: {
            1: fa_x8,
            2: fa_y8
        },
        614: {
            1: fa_h1,
            2: fa_i1
        },
        609: {
            1: fa_l1,
            2: fa_m1
        },
        416: {
            1: fa_l1,
            2: fa_m1
        },
        732: {
            1: fa_h1,
            2: fa_z8,
            3: fa_i1
        },
        525: {
            1: fa_l1,
            2: fa_m1
        },
        850: {
            1: fa_a9,
            2: fa_b9,
            3: fa_c9,
            4: fa_d9
        },
        473: {
            1: fa_l1,
            2: fa_m1
        },
        442: {
            1: fa_l1,
            2: fa_m1
        },
        729: {
            1: fa_h1,
            2: fa_l5,
            3: fa_i1
        },
        538: {
            1: fa_d1,
            2: fa_e1
        },
        542: {
            1: fa_l1,
            2: fa_m1
        },
        730: {
            1: fa_h1,
            2: fa_s2,
            3: fa_i1
        },
        471: {
            1: fa_l1,
            2: fa_m1
        },
        635: {
            1: fa_l1,
            2: fa_m1
        },
        714: {
            1: fa_e9,
            2: fa_s2,
            3: fa_f9
        },
        624: {
            1: fa_h1,
            2: fa_i1
        },
        625: {
            1: fa_h1,
            2: fa_i1
        },
        715: {
            1: fa_g9,
            2: fa_h9,
            3: fa_s2
        },
        650: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        651: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        652: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        653: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        654: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        655: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        634: {
            1: fa_l1,
            2: fa_m1
        },
        626: {
            1: fa_l1,
            2: fa_m1
        },
        733: {
            1: fa_i9,
            2: fa_j9,
            3: fa_k9
        },
        734: {
            1: fa_i9,
            2: fa_j9,
            3: fa_k9
        },
        258: {
            1: fa_d1,
            2: fa_e1
        },
        259: {
            1: fa_d1,
            2: fa_e1
        },
        66: {
            1: fa_b1,
            2: fa_c1
        },
        67: {
            1: fa_b1,
            2: fa_c1
        },
        81: {
            1: fa_b1,
            2: fa_c1
        },
        68: {
            1: fa_b1,
            2: fa_c1
        },
        689: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        690: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        699: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        691: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        723: {
            1: fa_h1,
            2: fa_l9,
            3: fa_i1
        },
        633: {
            1: fa_m1,
            2: fa_l1
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        656: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        698: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        322: {
            1: fa_d1,
            2: fa_e1
        },
        904: {
            1: fa_m9,
            2: fa_n9,
            3: fa_o9,
            4: fa_p9,
            5: fa_g6,
            6: fa_q9,
            7: fa_r9,
            8: fa_s9,
            9: fa_t9
        },
        1: {
            1: fa_b1,
            2: fa_c1
        },
        136: {
            1: fa_d1,
            2: fa_e1
        },
        747: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_v2,
            6: fa_w2,
            7: fa_u9,
            8: fa_x2,
            9: fa_y2,
            10: fa_p1,
            11: fa_q1,
            12: fa_z2,
            13: fa_a3,
            14: fa_v9,
            15: fa_r1,
            16: fa_s1,
            17: fa_b3,
            18: fa_t1,
            19: fa_c3,
            20: fa_u1,
            21: fa_v1,
            22: fa_w1,
            23: fa_f3,
            24: fa_i3,
            25: fa_j3,
            26: fa_k3,
            27: fa_n3,
            28: fa_o3,
            29: fa_w9,
            30: fa_x9,
            31: fa_r3
        },
        871: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        255: {
            1: fa_d1,
            2: fa_e1
        },
        705: {
            1: fa_y9,
            2: fa_z9,
            3: fa_a10
        },
        323: {
            1: fa_d1,
            2: fa_e1
        },
        324: {
            1: fa_d1,
            2: fa_e1
        },
        702: {
            1: fa_e9,
            2: fa_s2,
            3: fa_f9
        },
        278: {
            1: fa_d1,
            2: fa_e1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        282: {
            1: fa_d1,
            2: fa_e1
        },
        911: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2,
            4: fa_h2,
            5: fa_i2,
            6: fa_j2
        },
        353: {
            1: fa_d1,
            2: fa_e1
        },
        673: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        674: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        2: {
            1: fa_b1,
            2: fa_c1
        },
        5: {
            1: fa_b1,
            2: fa_c1
        },
        7: {
            1: fa_b1,
            2: fa_c1
        },
        939: {
            1: fa_b1,
            2: fa_c1
        },
        9: {
            1: fa_b1,
            2: fa_c1
        },
        12: {
            1: fa_b1,
            2: fa_c1
        },
        417: {
            1: fa_m1,
            2: fa_l1
        },
        526: {
            1: fa_m1,
            2: fa_l1
        },
        325: {
            1: fa_d1,
            2: fa_e1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        160: {
            1: fa_d1,
            2: fa_e1
        },
        163: {
            1: fa_d1,
            2: fa_e1
        },
        165: {
            1: fa_d1,
            2: fa_e1
        },
        166: {
            1: fa_d1,
            2: fa_e1
        },
        168: {
            1: fa_d1,
            2: fa_e1
        },
        171: {
            1: fa_d1,
            2: fa_e1
        },
        148: {
            1: fa_d1,
            2: fa_e1
        },
        149: {
            1: fa_d1,
            2: fa_e1
        },
        150: {
            1: fa_d1,
            2: fa_e1
        },
        151: {
            1: fa_d1,
            2: fa_e1
        },
        152: {
            1: fa_d1,
            2: fa_e1
        },
        153: {
            1: fa_d1,
            2: fa_e1
        },
        154: {
            1: fa_d1,
            2: fa_e1
        },
        155: {
            1: fa_d1,
            2: fa_e1
        },
        156: {
            1: fa_d1,
            2: fa_e1
        },
        157: {
            1: fa_d1,
            2: fa_e1
        },
        158: {
            1: fa_d1,
            2: fa_e1
        },
        159: {
            1: fa_d1,
            2: fa_e1
        },
        731: {
            1: fa_h1,
            2: fa_b10,
            3: fa_i1
        },
        765: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        766: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        415: {
            1: fa_l1,
            2: fa_m1
        },
        524: {
            1: fa_l1,
            2: fa_m1
        },
        418: {
            1: fa_l1,
            2: fa_m1
        },
        527: {
            1: fa_l1,
            2: fa_m1
        },
        743: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_r3
        },
        744: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_r3
        },
        710: {
            1: fa_q2,
            2: fa_r2,
            3: fa_s2
        },
        321: {
            1: fa_d1,
            2: fa_e1
        },
        326: {
            1: fa_l1,
            2: fa_m1
        },
        327: {
            1: fa_l1,
            2: fa_m1
        },
        724: {
            1: fa_h9,
            2: fa_c10,
            3: fa_g9
        },
        661: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        664: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        666: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        667: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        669: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        672: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        426: {
            1: fa_l1,
            2: fa_m1
        },
        535: {
            1: fa_l1,
            2: fa_m1
        },
        537: {
            1: fa_l1,
            2: fa_m1
        },
        541: {
            1: fa_l1,
            2: fa_m1
        },
        539: {
            1: fa_d1,
            2: fa_e1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        437: {
            1: fa_l1,
            2: fa_m1
        },
        436: {
            1: fa_l1,
            2: fa_m1
        },
        694: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        71: {
            1: fa_b1,
            2: fa_c1
        },
        271: {
            1: fa_d1,
            2: fa_e1
        },
        268: {
            1: fa_d1,
            2: fa_e1
        },
        265: {
            1: fa_d1,
            2: fa_e1
        },
        267: {
            1: fa_d1,
            2: fa_e1
        },
        270: {
            1: fa_d1,
            2: fa_e1
        },
        272: {
            1: fa_d1,
            2: fa_e1
        },
        269: {
            1: fa_d1,
            2: fa_e1
        },
        266: {
            1: fa_d1,
            2: fa_e1
        },
        264: {
            1: fa_d1,
            2: fa_e1
        },
        281: {
            1: fa_d1,
            2: fa_e1
        },
        137: {
            1: fa_d1,
            2: fa_e1
        },
        660: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        880: {
            1: fa_d10,
            2: fa_e10,
            3: fa_f10,
            4: fa_g10
        },
        879: {
            1: fa_h10,
            2: fa_i10,
            3: fa_j10,
            4: fa_k10
        },
        429: {
            1: fa_l1,
            2: fa_m1
        },
        433: {
            1: fa_l1,
            2: fa_m1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        881: {
            1: fa_l10,
            2: fa_m10,
            3: fa_n10,
            4: fa_o10,
            5: fa_p10,
            6: fa_q10
        },
        273: {
            1: fa_d1,
            2: fa_e1
        },
        274: {
            1: fa_d1,
            2: fa_e1
        },
        435: {
            1: fa_l1,
            2: fa_m1
        },
        704: {
            1: fa_g9,
            2: fa_r10,
            3: fa_h9
        },
        432: {
            1: fa_l1,
            2: fa_m1
        },
        428: {
            1: fa_l1,
            2: fa_m1
        },
        434: {
            1: fa_l1,
            2: fa_m1
        },
        439: {
            1: fa_l1,
            2: fa_m1
        },
        440: {
            1: fa_l1,
            2: fa_m1
        },
        441: {
            1: fa_l1,
            2: fa_m1
        },
        438: {
            1: fa_l1,
            2: fa_m1
        },
        623: {
            1: fa_h1,
            2: fa_i1
        },
        180: {
            1: fa_d1,
            2: fa_e1
        },
        146: {
            1: fa_d1,
            2: fa_e1
        },
        659: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        749: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_s10
        },
        69: {
            1: fa_b1,
            2: fa_c1
        },
        262: {
            1: fa_d1,
            2: fa_e1
        },
        692: {
            1: fa_x1,
            2: fa_p8,
            3: fa_y1
        },
        703: {
            1: fa_h1,
            2: fa_b10,
            3: fa_i1
        },
        70: {
            1: fa_b1,
            2: fa_c1
        },
        263: {
            1: fa_d1,
            2: fa_e1
        },
        693: {
            1: fa_t10,
            2: fa_z1,
            3: fa_u10
        },
        72: {
            1: fa_b1,
            2: fa_c1
        },
        277: {
            1: fa_d1,
            2: fa_e1
        },
        695: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        750: {
            1: fa_x2,
            2: fa_r1,
            3: fa_u1,
            4: fa_s1,
            5: fa_v1,
            6: fa_w1,
            7: fa_j3,
            8: fa_k3,
            9: fa_l3,
            10: fa_q3,
            11: fa_v10,
            12: fa_w10,
            13: fa_u2,
            14: fa_n1,
            15: fa_o1,
            16: fa_p1,
            17: fa_q1,
            18: fa_t1,
            19: fa_z2,
            20: fa_c3,
            21: fa_g3,
            22: fa_h3,
            23: fa_x10,
            24: fa_y10
        },
        181: {
            1: fa_d1,
            2: fa_e1
        },
        147: {
            1: fa_d1,
            2: fa_e1
        },
        276: {
            1: fa_d1,
            2: fa_e1
        },
        275: {
            1: fa_d1,
            2: fa_e1
        },
        735: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        736: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        737: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        738: {
            1: fa_h1,
            2: fa_b10,
            3: fa_i1
        },
        739: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        740: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        356: {
            1: fa_d1,
            2: fa_e1
        },
        357: {
            1: fa_d1,
            2: fa_e1
        },
        354: {
            1: fa_d1,
            2: fa_e1
        },
        355: {
            1: fa_d1,
            2: fa_e1
        },
        937: {
            1: fa_z10,
            2: fa_a11,
            3: fa_b11,
            4: fa_c11,
            5: fa_d11,
            6: fa_e11,
            7: fa_f11,
            8: fa_g11,
            9: fa_h11,
            10: fa_b10
        },
        657: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        658: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        412: {
            1: fa_l1,
            2: fa_m1
        }
    },
    14: {
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    34: {
        425: {
            1: fa_l1,
            2: fa_m1
        },
        534: {
            1: fa_l1,
            2: fa_m1
        },
        540: {
            1: fa_d1,
            2: fa_e1
        },
        343: {
            1: fa_d1,
            2: fa_e1
        },
        345: {
            1: fa_d1,
            2: fa_e1
        },
        260: {
            1: fa_l1,
            2: fa_m1
        },
        261: {
            1: fa_l1,
            2: fa_m1
        },
        83: {
            1: fa_f1,
            2: fa_g1
        },
        84: {
            1: fa_f1,
            2: fa_g1
        },
        803: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_i11
        },
        868: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_i11
        },
        869: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_i11
        },
        870: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_i11
        },
        346: {
            1: fa_d1,
            2: fa_e1
        },
        419: {
            1: fa_l1,
            2: fa_m1
        },
        528: {
            1: fa_l1,
            2: fa_m1
        },
        420: {
            1: fa_l1,
            2: fa_m1
        },
        529: {
            1: fa_l1,
            2: fa_m1
        },
        707: {
            1: fa_q2,
            2: fa_q8,
            3: fa_j11
        },
        708: {
            1: fa_q2,
            2: fa_q8,
            3: fa_j11
        },
        706: {
            1: fa_k11,
            2: fa_s8,
            3: fa_l5
        },
        538: {
            1: fa_d1,
            2: fa_e1
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        656: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        698: {
            1: fa_l11,
            2: fa_z1,
            3: fa_m11
        },
        322: {
            1: fa_d1,
            2: fa_e1
        },
        904: {
            1: fa_m9,
            2: fa_n9,
            3: fa_o9,
            4: fa_p9,
            5: fa_g6,
            6: fa_q9,
            7: fa_r9,
            8: fa_s9,
            9: fa_r9
        },
        1: {
            1: fa_b1,
            2: fa_c1
        },
        136: {
            1: fa_d1,
            2: fa_e1
        },
        747: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_v2,
            6: fa_w2,
            7: fa_u9,
            8: fa_x2,
            9: fa_y2,
            10: fa_p1,
            11: fa_q1,
            12: fa_z2,
            13: fa_a3,
            14: fa_v9,
            15: fa_r1,
            16: fa_s1,
            17: fa_b3,
            18: fa_t1,
            19: fa_c3,
            20: fa_u1,
            21: fa_v1,
            22: fa_w1,
            23: fa_f3,
            24: fa_i3,
            25: fa_j3,
            26: fa_k3,
            27: fa_n3,
            28: fa_o3,
            29: fa_w9,
            30: fa_x9,
            31: fa_r3
        },
        871: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        255: {
            1: fa_d1,
            2: fa_e1
        },
        705: {
            1: fa_y9,
            2: fa_z9,
            3: fa_a10
        },
        323: {
            1: fa_d1,
            2: fa_e1
        },
        324: {
            1: fa_d1,
            2: fa_e1
        },
        702: {
            1: fa_e9,
            2: fa_s2,
            3: fa_f9
        },
        278: {
            1: fa_d1,
            2: fa_e1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        282: {
            1: fa_d1,
            2: fa_e1
        },
        911: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2,
            4: fa_h2,
            5: fa_i2,
            6: fa_j2
        },
        353: {
            1: fa_d1,
            2: fa_e1
        },
        673: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        674: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        2: {
            1: fa_b1,
            2: fa_c1
        },
        5: {
            1: fa_b1,
            2: fa_c1
        },
        7: {
            1: fa_b1,
            2: fa_c1
        },
        939: {
            1: fa_b1,
            2: fa_c1
        },
        9: {
            1: fa_b1,
            2: fa_c1
        },
        12: {
            1: fa_b1,
            2: fa_c1
        },
        417: {
            1: fa_n11,
            2: fa_k9
        },
        526: {
            1: fa_n11,
            2: fa_k9
        },
        325: {
            1: fa_d1,
            2: fa_e1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        160: {
            1: fa_d1,
            2: fa_e1
        },
        163: {
            1: fa_d1,
            2: fa_e1
        },
        165: {
            1: fa_d1,
            2: fa_e1
        },
        166: {
            1: fa_d1,
            2: fa_e1
        },
        168: {
            1: fa_d1,
            2: fa_e1
        },
        171: {
            1: fa_d1,
            2: fa_e1
        },
        148: {
            1: fa_d1,
            2: fa_e1
        },
        149: {
            1: fa_d1,
            2: fa_e1
        },
        150: {
            1: fa_d1,
            2: fa_e1
        },
        151: {
            1: fa_d1,
            2: fa_e1
        },
        152: {
            1: fa_d1,
            2: fa_e1
        },
        153: {
            1: fa_d1,
            2: fa_e1
        },
        154: {
            1: fa_d1,
            2: fa_e1
        },
        155: {
            1: fa_d1,
            2: fa_e1
        },
        156: {
            1: fa_d1,
            2: fa_e1
        },
        157: {
            1: fa_d1,
            2: fa_e1
        },
        158: {
            1: fa_d1,
            2: fa_e1
        },
        159: {
            1: fa_d1,
            2: fa_e1
        },
        731: {
            1: fa_h1,
            2: fa_b10,
            3: fa_i1
        },
        765: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        766: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        415: {
            1: fa_l1,
            2: fa_m1
        },
        524: {
            1: fa_l1,
            2: fa_m1
        },
        418: {
            1: fa_l1,
            2: fa_m1
        },
        527: {
            1: fa_l1,
            2: fa_m1
        },
        743: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_r3
        },
        744: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_r3
        },
        710: {
            1: fa_q2,
            2: fa_r2,
            3: fa_l9
        },
        321: {
            1: fa_d1,
            2: fa_e1
        },
        326: {
            1: fa_l1,
            2: fa_m1
        },
        327: {
            1: fa_l1,
            2: fa_m1
        },
        724: {
            1: fa_o11,
            2: fa_p11,
            3: fa_q11
        },
        661: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        664: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        666: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        667: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        669: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        672: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        426: {
            1: fa_l1,
            2: fa_m1
        },
        535: {
            1: fa_l1,
            2: fa_m1
        },
        537: {
            1: fa_l1,
            2: fa_m1
        },
        541: {
            1: fa_l1,
            2: fa_m1
        },
        539: {
            1: fa_d1,
            2: fa_e1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    19: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        698: {
            1: fa_l11,
            2: fa_z1,
            3: fa_m11
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        615: {
            1: fa_h1,
            2: fa_i1
        },
        886: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_w3,
            6: fa_x3
        },
        887: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_w3,
            6: fa_x3
        },
        911: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2,
            4: fa_h2,
            5: fa_i2,
            6: fa_j2
        },
        884: {
            1: fa_r11,
            2: fa_s11,
            3: fa_t11,
            4: fa_u11,
            5: fa_a5
        },
        885: {
            1: fa_r11,
            2: fa_s11,
            3: fa_t11,
            4: fa_u11,
            5: fa_v11
        },
        882: {
            1: fa_r11,
            2: fa_s11,
            3: fa_t11,
            4: fa_u11,
            5: fa_e5
        },
        883: {
            1: fa_r11,
            2: fa_s11,
            3: fa_t11,
            4: fa_u11,
            5: fa_w11
        },
        723: {
            1: fa_h1,
            2: fa_x11,
            3: fa_i1
        },
        673: {
            1: fa_l11,
            2: fa_z1,
            3: fa_m11
        },
        674: {
            1: fa_l11,
            2: fa_z1,
            3: fa_m11
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    30: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        656: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        698: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        279: {
            1: fa_d1,
            2: fa_e1
        },
        610: {
            1: fa_x1,
            2: fa_y1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        673: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        674: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        675: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        350: {
            1: fa_d1,
            2: fa_e1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        415: {
            1: fa_l1,
            2: fa_m1
        },
        524: {
            1: fa_l1,
            2: fa_m1
        },
        743: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_r3
        },
        744: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_r3
        },
        745: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_r3
        },
        710: {
            1: fa_q2,
            2: fa_y11,
            3: fa_s2
        },
        403: {
            1: fa_x1,
            2: fa_y1
        },
        426: {
            1: fa_l1,
            2: fa_m1
        },
        535: {
            1: fa_l1,
            2: fa_m1
        },
        706: {
            1: fa_r8,
            2: fa_s8,
            3: fa_l5
        },
        343: {
            1: fa_d1,
            2: fa_e1
        },
        346: {
            1: fa_d1,
            2: fa_e1
        },
        83: {
            1: fa_f1,
            2: fa_g1
        },
        84: {
            1: fa_f1,
            2: fa_g1
        },
        85: {
            1: fa_f1,
            2: fa_g1
        },
        344: {
            1: fa_d1,
            2: fa_e1
        },
        347: {
            1: fa_d1,
            2: fa_e1
        },
        765: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_z11
        },
        766: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_z11
        },
        767: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_z11
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        140: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        184: {
            1: fa_d1,
            2: fa_e1
        },
        751: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_v2,
            6: fa_w2,
            7: fa_x2,
            8: fa_y2,
            9: fa_p1,
            10: fa_q1,
            11: fa_z2,
            12: fa_a3,
            13: fa_r1,
            14: fa_s1,
            15: fa_b3,
            16: fa_t1,
            17: fa_c3,
            18: fa_d3,
            19: fa_e3,
            20: fa_u1,
            21: fa_v1,
            22: fa_w1,
            23: fa_f3,
            24: fa_g3,
            25: fa_h3,
            26: fa_i3,
            27: fa_j3,
            28: fa_k3,
            29: fa_l3,
            30: fa_m3,
            31: fa_n3,
            32: fa_o3,
            33: fa_p3,
            34: fa_q3,
            35: fa_r3
        },
        911: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2,
            4: fa_h2,
            5: fa_i2,
            6: fa_j2
        },
        889: {
            1: fa_x5,
            2: fa_m2,
            3: fa_n2,
            4: fa_o2,
            5: fa_y5,
            6: fa_z5,
            7: fa_a6,
            8: fa_b6
        },
        637: {
            1: fa_l1,
            2: fa_m1
        },
        615: {
            1: fa_h1,
            2: fa_i1
        },
        412: {
            1: fa_l1,
            2: fa_m1
        },
        634: {
            1: fa_l1,
            2: fa_m1
        },
        626: {
            1: fa_l1,
            2: fa_m1
        },
        611: {
            1: fa_x1,
            2: fa_y1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        904: {
            1: fa_c6,
            2: fa_d6,
            3: fa_e6,
            4: fa_f6,
            5: fa_g6,
            6: fa_h6,
            7: fa_i6,
            8: fa_j6,
            9: fa_k6
        },
        449: {
            1: fa_l1,
            2: fa_m1
        },
        446: {
            1: fa_l1,
            2: fa_m1
        },
        451: {
            1: fa_l1,
            2: fa_m1
        },
        711: {
            1: fa_a12,
            2: fa_b12,
            3: fa_c12
        },
        712: {
            1: fa_d12,
            2: fa_e12,
            3: fa_f12
        },
        713: {
            1: fa_g12,
            2: fa_h12,
            3: fa_i12
        },
        450: {
            1: fa_l1,
            2: fa_m1
        },
        447: {
            1: fa_l1,
            2: fa_m1
        },
        448: {
            1: fa_l1,
            2: fa_m1
        },
        662: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        663: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        665: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        668: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        670: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        671: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        3: {
            1: fa_b1,
            2: fa_c1
        },
        4: {
            1: fa_b1,
            2: fa_c1
        },
        6: {
            1: fa_b1,
            2: fa_c1
        },
        8: {
            1: fa_b1,
            2: fa_c1
        },
        10: {
            1: fa_b1,
            2: fa_c1
        },
        11: {
            1: fa_b1,
            2: fa_c1
        },
        161: {
            1: fa_d1,
            2: fa_e1
        },
        162: {
            1: fa_d1,
            2: fa_e1
        },
        164: {
            1: fa_d1,
            2: fa_e1
        },
        167: {
            1: fa_d1,
            2: fa_e1
        },
        169: {
            1: fa_d1,
            2: fa_e1
        },
        170: {
            1: fa_d1,
            2: fa_e1
        },
        707: {
            1: fa_q2,
            2: fa_r2,
            3: fa_l5
        },
        708: {
            1: fa_q2,
            2: fa_r2,
            3: fa_l5
        },
        709: {
            1: fa_q2,
            2: fa_r2,
            3: fa_l5
        },
        946: {
            1: fa_l1,
            2: fa_m1
        },
        947: {
            1: fa_l1,
            2: fa_m1
        }
    },
    23: {
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    13: {
        468: {
            1: fa_f1,
            2: fa_g1
        },
        470: {
            1: fa_f1,
            2: fa_g1
        },
        467: {
            1: fa_f1,
            2: fa_g1
        },
        469: {
            1: fa_f1,
            2: fa_g1
        },
        464: {
            1: fa_l1,
            2: fa_m1
        },
        466: {
            1: fa_l1,
            2: fa_m1
        },
        465: {
            1: fa_l1,
            2: fa_m1
        },
        463: {
            1: fa_l1,
            2: fa_m1
        },
        289: {
            1: fa_d1,
            2: fa_e1
        },
        288: {
            1: fa_d1,
            2: fa_e1
        },
        292: {
            1: fa_d1,
            2: fa_e1
        },
        461: {
            1: fa_l1,
            2: fa_m1
        },
        283: {
            1: fa_d1,
            2: fa_e1
        },
        295: {
            1: fa_d1,
            2: fa_e1
        },
        293: {
            1: fa_d1,
            2: fa_e1
        },
        284: {
            1: fa_d1,
            2: fa_e1
        },
        285: {
            1: fa_d1,
            2: fa_e1
        },
        316: {
            1: fa_d1,
            2: fa_e1
        },
        286: {
            1: fa_d1,
            2: fa_e1
        },
        287: {
            1: fa_d1,
            2: fa_e1
        },
        290: {
            1: fa_d1,
            2: fa_e1
        },
        291: {
            1: fa_d1,
            2: fa_e1
        },
        462: {
            1: fa_l1,
            2: fa_m1
        },
        294: {
            1: fa_d1,
            2: fa_e1
        }
    },
    39: {
        403: {
            1: fa_x1,
            2: fa_y1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        698: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        950: {
            1: fa_n7,
            2: fa_o7,
            3: fa_p7,
            4: fa_q7,
            5: fa_r7,
            6: fa_j7,
            7: fa_k7,
            8: fa_z7,
            9: fa_a8,
            10: fa_b8,
            11: fa_c8,
            12: fa_d8,
            13: fa_m7
        },
        955: {
            1: fa_l1,
            2: fa_m1
        },
        951: {
            1: fa_j12,
            2: fa_k12
        },
        952: {
            1: fa_j12,
            2: fa_k12
        },
        953: {
            1: fa_j12,
            2: fa_k12
        },
        954: {
            1: fa_j12,
            2: fa_k12
        }
    },
    33: {
        348: {
            1: fa_d1,
            2: fa_e1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    24: {
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    9: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        656: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        698: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        673: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        674: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    21: {
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    29: {
        394: {
            1: fa_x1,
            2: fa_y1
        },
        395: {
            1: fa_x1,
            2: fa_y1
        },
        396: {
            1: fa_x1,
            2: fa_y1
        },
        397: {
            1: fa_x1,
            2: fa_y1
        },
        398: {
            1: fa_x1,
            2: fa_y1
        },
        399: {
            1: fa_x1,
            2: fa_y1
        },
        400: {
            1: fa_x1,
            2: fa_y1
        },
        401: {
            1: fa_x1,
            2: fa_y1
        },
        402: {
            1: fa_x1,
            2: fa_y1
        },
        100: {
            1: fa_f1,
            2: fa_g1
        },
        101: {
            1: fa_f1,
            2: fa_g1
        },
        104: {
            1: fa_f1,
            2: fa_g1
        },
        105: {
            1: fa_f1,
            2: fa_g1
        },
        106: {
            1: fa_f1,
            2: fa_g1
        },
        107: {
            1: fa_f1,
            2: fa_g1
        },
        108: {
            1: fa_f1,
            2: fa_g1
        },
        109: {
            1: fa_f1,
            2: fa_g1
        },
        110: {
            1: fa_f1,
            2: fa_g1
        },
        111: {
            1: fa_f1,
            2: fa_g1
        },
        112: {
            1: fa_f1,
            2: fa_g1
        },
        113: {
            1: fa_f1,
            2: fa_g1
        },
        114: {
            1: fa_f1,
            2: fa_g1
        },
        115: {
            1: fa_f1,
            2: fa_g1
        },
        116: {
            1: fa_f1,
            2: fa_g1
        },
        117: {
            1: fa_f1,
            2: fa_g1
        },
        118: {
            1: fa_f1,
            2: fa_g1
        },
        119: {
            1: fa_f1,
            2: fa_g1
        },
        120: {
            1: fa_f1,
            2: fa_g1
        },
        121: {
            1: fa_f1,
            2: fa_g1
        },
        808: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        809: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        810: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        811: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        812: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        813: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        814: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        815: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        816: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        817: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        818: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        819: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        820: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        821: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        822: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        823: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        824: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        825: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        826: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        827: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        828: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        829: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        830: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        831: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        832: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        833: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        834: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        835: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        836: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        837: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        838: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        839: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        840: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        841: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        842: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        843: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        844: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        366: {
            1: fa_x1,
            2: fa_y1
        },
        367: {
            1: fa_x1,
            2: fa_y1
        },
        368: {
            1: fa_x1,
            2: fa_y1
        },
        369: {
            1: fa_x1,
            2: fa_y1
        },
        370: {
            1: fa_x1,
            2: fa_y1
        },
        371: {
            1: fa_x1,
            2: fa_y1
        },
        372: {
            1: fa_x1,
            2: fa_y1
        },
        373: {
            1: fa_x1,
            2: fa_y1
        },
        374: {
            1: fa_x1,
            2: fa_y1
        },
        375: {
            1: fa_x1,
            2: fa_y1
        },
        376: {
            1: fa_x1,
            2: fa_y1
        },
        377: {
            1: fa_x1,
            2: fa_y1
        },
        378: {
            1: fa_x1,
            2: fa_y1
        },
        379: {
            1: fa_x1,
            2: fa_y1
        },
        380: {
            1: fa_x1,
            2: fa_y1
        },
        381: {
            1: fa_x1,
            2: fa_y1
        },
        382: {
            1: fa_x1,
            2: fa_y1
        },
        383: {
            1: fa_x1,
            2: fa_y1
        },
        384: {
            1: fa_x1,
            2: fa_y1
        },
        385: {
            1: fa_x1,
            2: fa_y1
        },
        386: {
            1: fa_x1,
            2: fa_y1
        },
        387: {
            1: fa_x1,
            2: fa_y1
        },
        388: {
            1: fa_x1,
            2: fa_y1
        },
        389: {
            1: fa_x1,
            2: fa_y1
        },
        390: {
            1: fa_x1,
            2: fa_y1
        },
        391: {
            1: fa_x1,
            2: fa_y1
        },
        392: {
            1: fa_x1,
            2: fa_y1
        },
        393: {
            1: fa_x1,
            2: fa_y1
        },
        481: {
            1: fa_h1,
            2: fa_i1
        },
        482: {
            1: fa_h1,
            2: fa_i1
        },
        483: {
            1: fa_h1,
            2: fa_i1
        },
        484: {
            1: fa_h1,
            2: fa_i1
        },
        485: {
            1: fa_h1,
            2: fa_i1
        },
        486: {
            1: fa_h1,
            2: fa_i1
        },
        487: {
            1: fa_h1,
            2: fa_i1
        },
        488: {
            1: fa_h1,
            2: fa_i1
        },
        489: {
            1: fa_h1,
            2: fa_i1
        },
        490: {
            1: fa_h1,
            2: fa_i1
        },
        491: {
            1: fa_h1,
            2: fa_i1
        },
        492: {
            1: fa_h1,
            2: fa_i1
        },
        493: {
            1: fa_h1,
            2: fa_i1
        },
        494: {
            1: fa_h1,
            2: fa_i1
        },
        495: {
            1: fa_h1,
            2: fa_i1
        },
        496: {
            1: fa_h1,
            2: fa_i1
        },
        497: {
            1: fa_h1,
            2: fa_i1
        },
        498: {
            1: fa_h1,
            2: fa_i1
        },
        499: {
            1: fa_h1,
            2: fa_i1
        },
        500: {
            1: fa_h1,
            2: fa_i1
        },
        501: {
            1: fa_h1,
            2: fa_i1
        },
        502: {
            1: fa_h1,
            2: fa_i1
        },
        503: {
            1: fa_h1,
            2: fa_i1
        },
        504: {
            1: fa_h1,
            2: fa_i1
        },
        505: {
            1: fa_h1,
            2: fa_i1
        },
        506: {
            1: fa_h1,
            2: fa_i1
        },
        507: {
            1: fa_h1,
            2: fa_i1
        },
        508: {
            1: fa_h1,
            2: fa_i1
        },
        509: {
            1: fa_h1,
            2: fa_i1
        },
        510: {
            1: fa_h1,
            2: fa_i1
        },
        511: {
            1: fa_h1,
            2: fa_i1
        },
        566: {
            1: fa_h1,
            2: fa_i1
        },
        567: {
            1: fa_h1,
            2: fa_i1
        },
        568: {
            1: fa_h1,
            2: fa_i1
        },
        569: {
            1: fa_h1,
            2: fa_i1
        },
        570: {
            1: fa_h1,
            2: fa_i1
        },
        571: {
            1: fa_h1,
            2: fa_i1
        },
        572: {
            1: fa_h1,
            2: fa_i1
        },
        573: {
            1: fa_h1,
            2: fa_i1
        },
        574: {
            1: fa_h1,
            2: fa_i1
        },
        575: {
            1: fa_h1,
            2: fa_i1
        },
        576: {
            1: fa_h1,
            2: fa_i1
        },
        577: {
            1: fa_h1,
            2: fa_i1
        },
        578: {
            1: fa_h1,
            2: fa_i1
        },
        579: {
            1: fa_h1,
            2: fa_i1
        },
        580: {
            1: fa_h1,
            2: fa_i1
        },
        581: {
            1: fa_h1,
            2: fa_i1
        },
        582: {
            1: fa_h1,
            2: fa_i1
        },
        583: {
            1: fa_h1,
            2: fa_i1
        },
        584: {
            1: fa_h1,
            2: fa_i1
        },
        585: {
            1: fa_h1,
            2: fa_i1
        },
        586: {
            1: fa_h1,
            2: fa_i1
        },
        587: {
            1: fa_h1,
            2: fa_i1
        },
        588: {
            1: fa_h1,
            2: fa_i1
        },
        589: {
            1: fa_h1,
            2: fa_i1
        },
        590: {
            1: fa_h1,
            2: fa_i1
        },
        591: {
            1: fa_h1,
            2: fa_i1
        },
        592: {
            1: fa_h1,
            2: fa_i1
        },
        593: {
            1: fa_h1,
            2: fa_i1
        },
        594: {
            1: fa_h1,
            2: fa_i1
        },
        595: {
            1: fa_h1,
            2: fa_i1
        },
        596: {
            1: fa_h1,
            2: fa_i1
        },
        597: {
            1: fa_h1,
            2: fa_i1
        },
        598: {
            1: fa_h1,
            2: fa_i1
        },
        599: {
            1: fa_h1,
            2: fa_i1
        },
        600: {
            1: fa_h1,
            2: fa_i1
        },
        601: {
            1: fa_h1,
            2: fa_i1
        },
        602: {
            1: fa_h1,
            2: fa_i1
        },
        83: {
            1: fa_f1,
            2: fa_g1
        },
        84: {
            1: fa_f1,
            2: fa_g1
        },
        85: {
            1: fa_f1,
            2: fa_g1
        },
        86: {
            1: fa_f1,
            2: fa_g1
        },
        87: {
            1: fa_f1,
            2: fa_g1
        },
        88: {
            1: fa_f1,
            2: fa_g1
        },
        89: {
            1: fa_f1,
            2: fa_g1
        },
        90: {
            1: fa_f1,
            2: fa_g1
        },
        91: {
            1: fa_f1,
            2: fa_g1
        },
        92: {
            1: fa_f1,
            2: fa_g1
        },
        93: {
            1: fa_f1,
            2: fa_g1
        },
        94: {
            1: fa_f1,
            2: fa_g1
        },
        95: {
            1: fa_f1,
            2: fa_g1
        },
        96: {
            1: fa_f1,
            2: fa_g1
        },
        97: {
            1: fa_f1,
            2: fa_g1
        },
        98: {
            1: fa_f1,
            2: fa_g1
        },
        99: {
            1: fa_f1,
            2: fa_g1
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        254: {
            1: fa_d1,
            2: fa_e1
        },
        403: {
            1: fa_x1,
            2: fa_y1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        24: {
            1: fa_b1,
            2: fa_c1
        },
        25: {
            1: fa_b1,
            2: fa_c1
        },
        26: {
            1: fa_b1,
            2: fa_c1
        },
        27: {
            1: fa_b1,
            2: fa_c1
        },
        28: {
            1: fa_b1,
            2: fa_c1
        },
        29: {
            1: fa_b1,
            2: fa_c1
        },
        30: {
            1: fa_b1,
            2: fa_c1
        },
        31: {
            1: fa_b1,
            2: fa_c1
        },
        32: {
            1: fa_b1,
            2: fa_c1
        },
        33: {
            1: fa_b1,
            2: fa_c1
        },
        34: {
            1: fa_b1,
            2: fa_c1
        },
        35: {
            1: fa_b1,
            2: fa_c1
        },
        36: {
            1: fa_b1,
            2: fa_c1
        },
        37: {
            1: fa_b1,
            2: fa_c1
        },
        38: {
            1: fa_b1,
            2: fa_c1
        },
        39: {
            1: fa_b1,
            2: fa_c1
        },
        40: {
            1: fa_b1,
            2: fa_c1
        },
        41: {
            1: fa_b1,
            2: fa_c1
        },
        42: {
            1: fa_b1,
            2: fa_c1
        },
        43: {
            1: fa_b1,
            2: fa_c1
        },
        44: {
            1: fa_b1,
            2: fa_c1
        },
        45: {
            1: fa_b1,
            2: fa_c1
        },
        46: {
            1: fa_b1,
            2: fa_c1
        },
        47: {
            1: fa_b1,
            2: fa_c1
        },
        48: {
            1: fa_b1,
            2: fa_c1
        },
        49: {
            1: fa_b1,
            2: fa_c1
        },
        50: {
            1: fa_b1,
            2: fa_c1
        },
        51: {
            1: fa_b1,
            2: fa_c1
        },
        52: {
            1: fa_b1,
            2: fa_c1
        },
        53: {
            1: fa_b1,
            2: fa_c1
        },
        54: {
            1: fa_b1,
            2: fa_c1
        },
        55: {
            1: fa_b1,
            2: fa_c1
        },
        56: {
            1: fa_b1,
            2: fa_c1
        },
        57: {
            1: fa_b1,
            2: fa_c1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        198: {
            1: fa_d1,
            2: fa_e1
        },
        199: {
            1: fa_d1,
            2: fa_e1
        },
        200: {
            1: fa_d1,
            2: fa_e1
        },
        201: {
            1: fa_d1,
            2: fa_e1
        },
        202: {
            1: fa_d1,
            2: fa_e1
        },
        203: {
            1: fa_d1,
            2: fa_e1
        },
        204: {
            1: fa_d1,
            2: fa_e1
        },
        205: {
            1: fa_d1,
            2: fa_e1
        },
        206: {
            1: fa_d1,
            2: fa_e1
        },
        207: {
            1: fa_d1,
            2: fa_e1
        },
        208: {
            1: fa_d1,
            2: fa_e1
        },
        209: {
            1: fa_d1,
            2: fa_e1
        },
        210: {
            1: fa_d1,
            2: fa_e1
        },
        211: {
            1: fa_d1,
            2: fa_e1
        },
        212: {
            1: fa_d1,
            2: fa_e1
        },
        213: {
            1: fa_d1,
            2: fa_e1
        },
        214: {
            1: fa_d1,
            2: fa_e1
        },
        215: {
            1: fa_d1,
            2: fa_e1
        },
        216: {
            1: fa_d1,
            2: fa_e1
        },
        217: {
            1: fa_d1,
            2: fa_e1
        },
        218: {
            1: fa_d1,
            2: fa_e1
        },
        219: {
            1: fa_d1,
            2: fa_e1
        },
        220: {
            1: fa_d1,
            2: fa_e1
        },
        221: {
            1: fa_d1,
            2: fa_e1
        },
        222: {
            1: fa_d1,
            2: fa_e1
        },
        223: {
            1: fa_d1,
            2: fa_e1
        },
        224: {
            1: fa_d1,
            2: fa_e1
        },
        225: {
            1: fa_d1,
            2: fa_e1
        },
        226: {
            1: fa_d1,
            2: fa_e1
        },
        227: {
            1: fa_d1,
            2: fa_e1
        },
        228: {
            1: fa_d1,
            2: fa_e1
        },
        229: {
            1: fa_d1,
            2: fa_e1
        },
        230: {
            1: fa_d1,
            2: fa_e1
        },
        231: {
            1: fa_d1,
            2: fa_e1
        },
        475: {
            1: fa_h1,
            2: fa_i1
        },
        476: {
            1: fa_h1,
            2: fa_i1
        },
        477: {
            1: fa_h1,
            2: fa_i1
        },
        478: {
            1: fa_h1,
            2: fa_i1
        },
        479: {
            1: fa_h1,
            2: fa_i1
        },
        480: {
            1: fa_h1,
            2: fa_i1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    15: {
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    2: {
        73: {
            1: fa_b1,
            2: fa_c1
        },
        318: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        24: {
            1: fa_b1,
            2: fa_c1
        },
        25: {
            1: fa_b1,
            2: fa_c1
        },
        26: {
            1: fa_b1,
            2: fa_c1
        },
        27: {
            1: fa_b1,
            2: fa_c1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        198: {
            1: fa_d1,
            2: fa_e1
        },
        199: {
            1: fa_d1,
            2: fa_e1
        },
        200: {
            1: fa_d1,
            2: fa_e1
        },
        201: {
            1: fa_d1,
            2: fa_e1
        },
        352: {
            1: fa_d1,
            2: fa_e1
        },
        102: {
            1: fa_f1,
            2: fa_g1
        },
        403: {
            1: fa_x1,
            2: fa_y1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        140: {
            1: fa_d1,
            2: fa_e1
        },
        141: {
            1: fa_d1,
            2: fa_e1
        },
        142: {
            1: fa_d1,
            2: fa_e1
        },
        143: {
            1: fa_d1,
            2: fa_e1
        },
        144: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        184: {
            1: fa_d1,
            2: fa_e1
        },
        185: {
            1: fa_d1,
            2: fa_e1
        },
        186: {
            1: fa_d1,
            2: fa_e1
        },
        187: {
            1: fa_d1,
            2: fa_e1
        },
        188: {
            1: fa_d1,
            2: fa_e1
        },
        566: {
            1: fa_h1,
            2: fa_i1
        },
        567: {
            1: fa_h1,
            2: fa_i1
        },
        568: {
            1: fa_h1,
            2: fa_i1
        },
        569: {
            1: fa_h1,
            2: fa_i1
        },
        570: {
            1: fa_h1,
            2: fa_i1
        },
        571: {
            1: fa_h1,
            2: fa_i1
        },
        572: {
            1: fa_h1,
            2: fa_i1
        },
        366: {
            1: fa_x1,
            2: fa_y1
        },
        367: {
            1: fa_x1,
            2: fa_y1
        },
        368: {
            1: fa_x1,
            2: fa_y1
        },
        369: {
            1: fa_x1,
            2: fa_y1
        },
        370: {
            1: fa_x1,
            2: fa_y1
        },
        371: {
            1: fa_x1,
            2: fa_y1
        },
        372: {
            1: fa_x1,
            2: fa_y1
        },
        122: {
            1: fa_l1,
            2: fa_m1
        },
        123: {
            1: fa_l1,
            2: fa_m1
        },
        124: {
            1: fa_l1,
            2: fa_m1
        },
        125: {
            1: fa_l1,
            2: fa_m1
        },
        126: {
            1: fa_l1,
            2: fa_m1
        },
        127: {
            1: fa_l1,
            2: fa_m1
        },
        128: {
            1: fa_l1,
            2: fa_m1
        },
        129: {
            1: fa_l1,
            2: fa_m1
        },
        130: {
            1: fa_l1,
            2: fa_m1
        },
        131: {
            1: fa_l1,
            2: fa_m1
        },
        132: {
            1: fa_l1,
            2: fa_m1
        },
        133: {
            1: fa_l1,
            2: fa_m1
        },
        134: {
            1: fa_l1,
            2: fa_m1
        },
        135: {
            1: fa_l1,
            2: fa_m1
        },
        872: {
            1: fa_s3,
            2: fa_l6,
            3: fa_m6,
            4: fa_n6,
            5: fa_o6,
            6: fa_r12
        },
        873: {
            1: fa_s3,
            2: fa_l6,
            3: fa_m6,
            4: fa_n6,
            5: fa_o6,
            6: fa_r12
        },
        874: {
            1: fa_s3,
            2: fa_l6,
            3: fa_m6,
            4: fa_n6,
            5: fa_o6,
            6: fa_r12
        },
        875: {
            1: fa_s3,
            2: fa_l6,
            3: fa_m6,
            4: fa_n6,
            5: fa_o6,
            6: fa_r12
        },
        876: {
            1: fa_s3,
            2: fa_l6,
            3: fa_m6,
            4: fa_n6,
            5: fa_o6,
            6: fa_r12
        },
        877: {
            1: fa_s3,
            2: fa_l6,
            3: fa_m6,
            4: fa_n6,
            5: fa_o6,
            6: fa_r12
        },
        878: {
            1: fa_s3,
            2: fa_l6,
            3: fa_m6,
            4: fa_n6,
            5: fa_o6,
            6: fa_r12
        },
        616: {
            1: fa_h1,
            2: fa_i1
        },
        617: {
            1: fa_h1,
            2: fa_i1
        },
        618: {
            1: fa_h1,
            2: fa_i1
        },
        619: {
            1: fa_h1,
            2: fa_i1
        },
        620: {
            1: fa_h1,
            2: fa_i1
        },
        621: {
            1: fa_h1,
            2: fa_i1
        },
        622: {
            1: fa_h1,
            2: fa_i1
        },
        894: {
            1: fa_s12,
            2: fa_t12,
            3: fa_u12,
            4: fa_v12
        },
        895: {
            1: fa_s12,
            2: fa_t12,
            3: fa_u12,
            4: fa_v12
        },
        896: {
            1: fa_s12,
            2: fa_t12,
            3: fa_u12,
            4: fa_v12
        },
        897: {
            1: fa_s12,
            2: fa_t12,
            3: fa_u12,
            4: fa_v12
        },
        898: {
            1: fa_s12,
            2: fa_t12,
            3: fa_u12,
            4: fa_v12
        },
        899: {
            1: fa_s12,
            2: fa_t12,
            3: fa_u12,
            4: fa_v12
        },
        900: {
            1: fa_s12,
            2: fa_t12,
            3: fa_u12,
            4: fa_v12
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        83: {
            1: fa_f1,
            2: fa_g1
        },
        84: {
            1: fa_f1,
            2: fa_g1
        },
        85: {
            1: fa_f1,
            2: fa_g1
        },
        86: {
            1: fa_f1,
            2: fa_g1
        },
        87: {
            1: fa_f1,
            2: fa_g1
        },
        88: {
            1: fa_f1,
            2: fa_g1
        },
        89: {
            1: fa_f1,
            2: fa_g1
        },
        257: {
            1: fa_d1,
            2: fa_e1
        },
        307: {
            1: fa_d1,
            2: fa_e1
        },
        752: {
            1: fa_u1,
            2: fa_v1,
            3: fa_w1,
            4: fa_t1,
            5: fa_q1,
            6: fa_o1
        },
        753: {
            1: fa_i3,
            2: fa_j3,
            3: fa_k3,
            4: fa_l3,
            5: fa_g3,
            6: fa_c3,
            7: fa_z2,
            8: fa_v2
        }
    },
    6: {
        553: {
            1: fa_l1,
            2: fa_m1
        },
        339: {
            1: fa_d1,
            2: fa_e1
        },
        547: {
            1: fa_l1,
            2: fa_m1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        140: {
            1: fa_d1,
            2: fa_e1
        },
        141: {
            1: fa_d1,
            2: fa_e1
        },
        142: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        184: {
            1: fa_d1,
            2: fa_e1
        },
        185: {
            1: fa_d1,
            2: fa_e1
        },
        186: {
            1: fa_d1,
            2: fa_e1
        },
        83: {
            1: fa_f1,
            2: fa_g1
        },
        84: {
            1: fa_f1,
            2: fa_g1
        },
        85: {
            1: fa_f1,
            2: fa_g1
        },
        86: {
            1: fa_f1,
            2: fa_g1
        },
        87: {
            1: fa_f1,
            2: fa_g1
        },
        807: {
            1: fa_c6,
            2: fa_e6,
            3: fa_i6,
            4: fa_k6
        },
        636: {
            1: fa_l1,
            2: fa_m1
        },
        334: {
            1: fa_d1,
            2: fa_e1
        },
        335: {
            1: fa_d1,
            2: fa_e1
        },
        336: {
            1: fa_d1,
            2: fa_e1
        },
        337: {
            1: fa_d1,
            2: fa_e1
        },
        906: {
            1: fa_w6,
            2: fa_x6,
            3: fa_y6,
            4: fa_z6
        },
        907: {
            1: fa_w6,
            2: fa_x6,
            3: fa_y6,
            4: fa_z6
        },
        908: {
            1: fa_w6,
            2: fa_x6,
            3: fa_y6,
            4: fa_z6
        },
        909: {
            1: fa_w6,
            2: fa_x6,
            3: fa_y6,
            4: fa_z6
        },
        300: {
            1: fa_d1,
            2: fa_e1
        },
        301: {
            1: fa_d1,
            2: fa_e1
        },
        302: {
            1: fa_d1,
            2: fa_e1
        },
        303: {
            1: fa_d1,
            2: fa_e1
        },
        304: {
            1: fa_d1,
            2: fa_e1
        },
        310: {
            1: fa_d1,
            2: fa_e1
        },
        311: {
            1: fa_d1,
            2: fa_e1
        },
        312: {
            1: fa_d1,
            2: fa_e1
        },
        313: {
            1: fa_d1,
            2: fa_e1
        },
        314: {
            1: fa_d1,
            2: fa_e1
        },
        554: {
            1: fa_l1,
            2: fa_m1
        },
        555: {
            1: fa_l1,
            2: fa_m1
        },
        556: {
            1: fa_l1,
            2: fa_m1
        },
        557: {
            1: fa_l1,
            2: fa_m1
        },
        558: {
            1: fa_l1,
            2: fa_m1
        },
        517: {
            1: fa_l1,
            2: fa_m1
        },
        518: {
            1: fa_l1,
            2: fa_m1
        },
        519: {
            1: fa_l1,
            2: fa_m1
        },
        520: {
            1: fa_l1,
            2: fa_m1
        },
        521: {
            1: fa_l1,
            2: fa_m1
        },
        561: {
            1: fa_l1,
            2: fa_m1
        },
        562: {
            1: fa_l1,
            2: fa_m1
        },
        563: {
            1: fa_l1,
            2: fa_m1
        },
        564: {
            1: fa_l1,
            2: fa_m1
        },
        565: {
            1: fa_l1,
            2: fa_m1
        },
        73: {
            1: fa_b1,
            2: fa_c1
        },
        318: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        24: {
            1: fa_b1,
            2: fa_c1
        },
        25: {
            1: fa_b1,
            2: fa_c1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        198: {
            1: fa_d1,
            2: fa_e1
        },
        199: {
            1: fa_d1,
            2: fa_e1
        },
        352: {
            1: fa_d1,
            2: fa_e1
        },
        748: {
            1: fa_n1,
            2: fa_o1,
            3: fa_p1,
            4: fa_q1,
            5: fa_r1,
            6: fa_s1,
            7: fa_t1,
            8: fa_u1,
            9: fa_v1,
            10: fa_w1
        },
        102: {
            1: fa_f1,
            2: fa_g1
        },
        403: {
            1: fa_x1,
            2: fa_y1
        },
        903: {
            1: fa_w12,
            2: fa_x12,
            3: fa_y12,
            4: fa_z12,
            5: fa_a13,
            6: fa_b13,
            7: fa_c13,
            8: fa_d13
        },
        445: {
            1: fa_h1,
            2: fa_i1
        },
        754: {
            1: fa_u9,
            2: fa_v9,
            3: fa_e3,
            4: fa_e13,
            5: fa_s6,
            6: fa_f13,
            7: fa_w9,
            8: fa_x9,
            9: fa_g13,
            10: fa_h13,
            11: fa_i13,
            12: fa_j13,
            13: fa_k13,
            14: fa_l13
        },
        755: {
            1: fa_u9,
            2: fa_v9,
            3: fa_e3,
            4: fa_e13,
            5: fa_s6,
            6: fa_f13,
            7: fa_w9,
            8: fa_x9,
            9: fa_g13,
            10: fa_h13,
            11: fa_i13,
            12: fa_j13,
            13: fa_k13,
            14: fa_l13
        },
        756: {
            1: fa_u9,
            2: fa_v9,
            3: fa_e3,
            4: fa_e13,
            5: fa_s6,
            6: fa_f13,
            7: fa_w9,
            8: fa_x9,
            9: fa_g13,
            10: fa_h13,
            11: fa_i13,
            12: fa_j13,
            13: fa_k13,
            14: fa_l13
        },
        757: {
            1: fa_u9,
            2: fa_v9,
            3: fa_e3,
            4: fa_e13,
            5: fa_s6,
            6: fa_f13,
            7: fa_w9,
            8: fa_x9,
            9: fa_g13,
            10: fa_h13,
            11: fa_i13,
            12: fa_j13,
            13: fa_k13,
            14: fa_l13
        },
        758: {
            1: fa_u9,
            2: fa_v9,
            3: fa_e3,
            4: fa_e13,
            5: fa_s6,
            6: fa_f13,
            7: fa_w9,
            8: fa_x9,
            9: fa_g13,
            10: fa_h13,
            11: fa_i13,
            12: fa_j13,
            13: fa_k13,
            14: fa_l13
        },
        452: {
            1: fa_l1,
            2: fa_m1
        },
        453: {
            1: fa_l1,
            2: fa_m1
        },
        454: {
            1: fa_l1,
            2: fa_m1
        },
        566: {
            1: fa_h1,
            2: fa_i1
        },
        567: {
            1: fa_h1,
            2: fa_i1
        },
        568: {
            1: fa_h1,
            2: fa_i1
        },
        569: {
            1: fa_h1,
            2: fa_i1
        },
        570: {
            1: fa_h1,
            2: fa_i1
        },
        366: {
            1: fa_x1,
            2: fa_y1
        },
        367: {
            1: fa_x1,
            2: fa_y1
        },
        368: {
            1: fa_x1,
            2: fa_y1
        },
        369: {
            1: fa_x1,
            2: fa_y1
        },
        370: {
            1: fa_x1,
            2: fa_y1
        },
        522: {
            1: fa_h1,
            2: fa_i1
        },
        627: {
            1: fa_l1,
            2: fa_m1
        },
        628: {
            1: fa_l1,
            2: fa_m1
        },
        629: {
            1: fa_l1,
            2: fa_m1
        },
        630: {
            1: fa_l1,
            2: fa_m1
        },
        631: {
            1: fa_l1,
            2: fa_m1
        },
        632: {
            1: fa_l1,
            2: fa_m1
        },
        190: {
            1: fa_d1,
            2: fa_e1
        },
        191: {
            1: fa_d1,
            2: fa_e1
        },
        192: {
            1: fa_d1,
            2: fa_e1
        },
        193: {
            1: fa_d1,
            2: fa_e1
        },
        194: {
            1: fa_d1,
            2: fa_e1
        },
        759: {
            1: fa_m13,
            2: fa_n13,
            3: fa_o13,
            4: fa_p13,
            5: fa_q13,
            6: fa_k13,
            7: fa_r13,
            8: fa_s13,
            9: fa_t13,
            10: fa_u13,
            11: fa_v13,
            12: fa_w13,
            13: fa_f13,
            14: fa_x13
        },
        760: {
            1: fa_m13,
            2: fa_n13,
            3: fa_o13,
            4: fa_p13,
            5: fa_q13,
            6: fa_k13,
            7: fa_r13,
            8: fa_s13,
            9: fa_t13,
            10: fa_u13,
            11: fa_v13,
            12: fa_w13,
            13: fa_f13,
            14: fa_x13
        },
        761: {
            1: fa_m13,
            2: fa_n13,
            3: fa_o13,
            4: fa_p13,
            5: fa_q13,
            6: fa_k13,
            7: fa_r13,
            8: fa_s13,
            9: fa_t13,
            10: fa_u13,
            11: fa_v13,
            12: fa_w13,
            13: fa_f13,
            14: fa_x13
        },
        762: {
            1: fa_m13,
            2: fa_n13,
            3: fa_o13,
            4: fa_p13,
            5: fa_q13,
            6: fa_k13,
            7: fa_r13,
            8: fa_s13,
            9: fa_t13,
            10: fa_u13,
            11: fa_v13,
            12: fa_w13,
            13: fa_f13,
            14: fa_x13
        },
        763: {
            1: fa_m13,
            2: fa_n13,
            3: fa_o13,
            4: fa_p13,
            5: fa_q13,
            6: fa_k13,
            7: fa_r13,
            8: fa_s13,
            9: fa_t13,
            10: fa_u13,
            11: fa_v13,
            12: fa_w13,
            13: fa_f13,
            14: fa_x13
        },
        768: {
            1: fa_a6,
            2: fa_y13,
            3: fa_z13,
            4: fa_a14,
            5: fa_b14,
            6: fa_c2,
            7: fa_c14
        },
        769: {
            1: fa_a6,
            2: fa_y13,
            3: fa_z13,
            4: fa_a14,
            5: fa_b14,
            6: fa_c2,
            7: fa_c14
        },
        770: {
            1: fa_a6,
            2: fa_y13,
            3: fa_z13,
            4: fa_a14,
            5: fa_b14,
            6: fa_c2,
            7: fa_c14
        },
        771: {
            1: fa_a6,
            2: fa_y13,
            3: fa_z13,
            4: fa_a14,
            5: fa_b14,
            6: fa_c2,
            7: fa_c14
        },
        772: {
            1: fa_a6,
            2: fa_y13,
            3: fa_z13,
            4: fa_a14,
            5: fa_b14,
            6: fa_c2,
            7: fa_c14
        },
        603: {
            1: fa_h1,
            2: fa_i1
        },
        604: {
            1: fa_h1,
            2: fa_i1
        },
        605: {
            1: fa_h1,
            2: fa_i1
        },
        606: {
            1: fa_h1,
            2: fa_i1
        },
        607: {
            1: fa_h1,
            2: fa_i1
        },
        257: {
            1: fa_d1,
            2: fa_e1
        },
        307: {
            1: fa_d1,
            2: fa_e1
        },
        696: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        333: {
            1: fa_d1,
            2: fa_e1
        },
        341: {
            1: fa_d1,
            2: fa_e1
        },
        427: {
            1: fa_l1,
            2: fa_m1
        },
        536: {
            1: fa_l1,
            2: fa_m1
        },
        905: {
            1: fa_w6,
            2: fa_x6,
            3: fa_y6,
            4: fa_z6
        },
        320: {
            1: fa_d1,
            2: fa_e1
        },
        514: {
            1: fa_h1,
            2: fa_i1
        },
        516: {
            1: fa_h1,
            2: fa_i1
        },
        305: {
            1: fa_d1,
            2: fa_e1
        },
        315: {
            1: fa_d1,
            2: fa_e1
        },
        523: {
            1: fa_l1,
            2: fa_m1
        },
        299: {
            1: fa_d1,
            2: fa_e1
        },
        309: {
            1: fa_d1,
            2: fa_e1
        },
        697: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        298: {
            1: fa_d1,
            2: fa_e1
        },
        308: {
            1: fa_d1,
            2: fa_e1
        },
        515: {
            1: fa_h1,
            2: fa_i1
        },
        549: {
            1: fa_l1,
            2: fa_m1
        },
        548: {
            1: fa_l1,
            2: fa_m1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        550: {
            1: fa_d14,
            2: fa_i1
        },
        551: {
            1: fa_h1,
            2: fa_e14
        },
        455: {
            1: fa_l1,
            2: fa_m1
        },
        456: {
            1: fa_l1,
            2: fa_m1
        },
        457: {
            1: fa_l1,
            2: fa_m1
        },
        458: {
            1: fa_l1,
            2: fa_m1
        },
        459: {
            1: fa_l1,
            2: fa_m1
        },
        460: {
            1: fa_l1,
            2: fa_m1
        },
        512: {
            1: fa_d14,
            2: fa_i1
        },
        513: {
            1: fa_h1,
            2: fa_e14
        },
        901: {
            1: fa_f14,
            2: fa_x12,
            3: fa_y12,
            4: fa_z12,
            5: fa_g14,
            6: fa_b13,
            7: fa_c13,
            8: fa_d13
        },
        902: {
            1: fa_f14,
            2: fa_x12,
            3: fa_y12,
            4: fa_z12,
            5: fa_g14,
            6: fa_b13,
            7: fa_c13,
            8: fa_d13
        },
        340: {
            1: fa_d1,
            2: fa_e1
        },
        328: {
            1: fa_d1,
            2: fa_e1
        },
        329: {
            1: fa_d1,
            2: fa_e1
        },
        342: {
            1: fa_d1,
            2: fa_e1
        },
        330: {
            1: fa_d1,
            2: fa_e1
        },
        331: {
            1: fa_d1,
            2: fa_e1
        },
        722: {
            1: fa_h14,
            2: fa_p11,
            3: fa_i14
        },
        560: {
            1: fa_l1,
            2: fa_m1
        },
        543: {
            1: fa_l1,
            2: fa_m1
        },
        544: {
            1: fa_l1,
            2: fa_m1
        },
        545: {
            1: fa_j14,
            2: fa_k14
        },
        546: {
            1: fa_l1,
            2: fa_m1
        },
        332: {
            1: fa_d1,
            2: fa_e1
        },
        559: {
            1: fa_l1,
            2: fa_m1
        },
        296: {
            1: fa_d1,
            2: fa_e1
        },
        297: {
            1: fa_d1,
            2: fa_e1
        },
        717: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        718: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        719: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        720: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        721: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        552: {
            1: fa_b1,
            2: fa_c1
        },
        76: {
            1: fa_b1,
            2: fa_c1
        },
        77: {
            1: fa_b1,
            2: fa_c1
        },
        78: {
            1: fa_b1,
            2: fa_c1
        },
        79: {
            1: fa_b1,
            2: fa_c1
        },
        80: {
            1: fa_b1,
            2: fa_c1
        },
        647: {
            1: fa_h1,
            2: fa_i1
        },
        741: {
            1: fa_l14,
            2: fa_k7,
            3: fa_m14
        },
        82: {
            1: fa_b1,
            2: fa_c1
        },
        338: {
            1: fa_d1,
            2: fa_e1
        }
    },
    17: {
        348: {
            1: fa_d1,
            2: fa_e1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    4: {
        73: {
            1: fa_b1,
            2: fa_c1
        },
        318: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        24: {
            1: fa_b1,
            2: fa_c1
        },
        25: {
            1: fa_b1,
            2: fa_c1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        198: {
            1: fa_d1,
            2: fa_e1
        },
        199: {
            1: fa_d1,
            2: fa_e1
        },
        352: {
            1: fa_d1,
            2: fa_e1
        },
        764: {
            1: fa_o1,
            2: fa_q1,
            3: fa_t1,
            4: fa_u1,
            5: fa_v1,
            6: fa_w1
        },
        102: {
            1: fa_f1,
            2: fa_g1
        },
        403: {
            1: fa_x1,
            2: fa_y1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        140: {
            1: fa_d1,
            2: fa_e1
        },
        141: {
            1: fa_d1,
            2: fa_e1
        },
        142: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        184: {
            1: fa_d1,
            2: fa_e1
        },
        185: {
            1: fa_d1,
            2: fa_e1
        },
        186: {
            1: fa_d1,
            2: fa_e1
        },
        366: {
            1: fa_x1,
            2: fa_y1
        },
        367: {
            1: fa_x1,
            2: fa_y1
        },
        368: {
            1: fa_x1,
            2: fa_y1
        },
        369: {
            1: fa_x1,
            2: fa_y1
        },
        370: {
            1: fa_x1,
            2: fa_y1
        },
        566: {
            1: fa_h1,
            2: fa_i1
        },
        567: {
            1: fa_h1,
            2: fa_i1
        },
        568: {
            1: fa_h1,
            2: fa_i1
        },
        569: {
            1: fa_h1,
            2: fa_i1
        },
        570: {
            1: fa_h1,
            2: fa_i1
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        923: {
            1: fa_s3,
            2: fa_l6,
            3: fa_m6,
            4: fa_n6,
            5: fa_o6,
            6: fa_p6,
            7: fa_q6,
            8: fa_r6
        },
        924: {
            1: fa_s3,
            2: fa_l6,
            3: fa_m6,
            4: fa_n6,
            5: fa_o6,
            6: fa_p6,
            7: fa_q6,
            8: fa_r6
        },
        925: {
            1: fa_s3,
            2: fa_l6,
            3: fa_m6,
            4: fa_n6,
            5: fa_o6,
            6: fa_p6,
            7: fa_q6,
            8: fa_r6
        },
        926: {
            1: fa_s3,
            2: fa_l6,
            3: fa_m6,
            4: fa_n6,
            5: fa_o6,
            6: fa_p6,
            7: fa_q6,
            8: fa_r6
        },
        927: {
            1: fa_s3,
            2: fa_l6,
            3: fa_m6,
            4: fa_n6,
            5: fa_o6,
            6: fa_p6,
            7: fa_q6,
            8: fa_r6
        },
        929: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_r6
        },
        930: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_r6
        },
        931: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_r6
        },
        932: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_r6
        },
        933: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_r6
        },
        845: {
            1: fa_t1,
            2: fa_s6,
            3: fa_t6,
            4: fa_y1
        },
        846: {
            1: fa_t1,
            2: fa_s6,
            3: fa_t6,
            4: fa_y1
        },
        847: {
            1: fa_t1,
            2: fa_s6,
            3: fa_t6,
            4: fa_y1
        },
        848: {
            1: fa_t1,
            2: fa_s6,
            3: fa_t6,
            4: fa_y1
        },
        849: {
            1: fa_t1,
            2: fa_s6,
            3: fa_t6,
            4: fa_y1
        },
        918: {
            1: fa_t1,
            2: fa_s6,
            3: fa_t6,
            4: fa_y1
        },
        919: {
            1: fa_t1,
            2: fa_s6,
            3: fa_t6,
            4: fa_y1
        },
        920: {
            1: fa_t1,
            2: fa_s6,
            3: fa_t6,
            4: fa_y1
        },
        921: {
            1: fa_t1,
            2: fa_s6,
            3: fa_t6,
            4: fa_y1
        },
        922: {
            1: fa_t1,
            2: fa_s6,
            3: fa_t6,
            4: fa_y1
        },
        83: {
            1: fa_f1,
            2: fa_g1
        },
        84: {
            1: fa_f1,
            2: fa_g1
        },
        85: {
            1: fa_f1,
            2: fa_g1
        },
        86: {
            1: fa_f1,
            2: fa_g1
        },
        87: {
            1: fa_f1,
            2: fa_g1
        },
        905: {
            1: fa_w6,
            2: fa_x6,
            3: fa_y6,
            4: fa_z6
        },
        906: {
            1: fa_w6,
            2: fa_x6,
            3: fa_y6,
            4: fa_z6
        },
        907: {
            1: fa_w6,
            2: fa_x6,
            3: fa_y6,
            4: fa_z6
        },
        908: {
            1: fa_w6,
            2: fa_x6,
            3: fa_y6,
            4: fa_z6
        },
        909: {
            1: fa_w6,
            2: fa_x6,
            3: fa_y6,
            4: fa_z6
        },
        807: {
            1: fa_c6,
            2: fa_e6,
            3: fa_i6,
            4: fa_k6
        },
        319: {
            1: fa_d1,
            2: fa_e1
        },
        320: {
            1: fa_d1,
            2: fa_e1
        },
        912: {
            1: fa_a7,
            2: fa_b7,
            3: fa_c7,
            4: fa_d7,
            5: fa_e7,
            6: fa_f7
        },
        913: {
            1: fa_a7,
            2: fa_b7,
            3: fa_c7,
            4: fa_d7,
            5: fa_e7,
            6: fa_f7
        },
        914: {
            1: fa_a7,
            2: fa_b7,
            3: fa_c7,
            4: fa_d7,
            5: fa_e7,
            6: fa_f7
        },
        915: {
            1: fa_a7,
            2: fa_b7,
            3: fa_c7,
            4: fa_d7,
            5: fa_e7,
            6: fa_f7
        },
        916: {
            1: fa_a7,
            2: fa_b7,
            3: fa_c7,
            4: fa_d7,
            5: fa_e7,
            6: fa_f7
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        257: {
            1: fa_d1,
            2: fa_e1
        },
        307: {
            1: fa_d1,
            2: fa_e1
        },
        362: {
            1: fa_x1,
            2: fa_y1
        },
        363: {
            1: fa_x1,
            2: fa_y1
        },
        364: {
            1: fa_x1,
            2: fa_y1
        },
        365: {
            1: fa_x1,
            2: fa_y1
        },
        17: {
            1: fa_b1,
            2: fa_c1
        },
        18: {
            1: fa_b1,
            2: fa_c1
        },
        19: {
            1: fa_b1,
            2: fa_c1
        },
        20: {
            1: fa_b1,
            2: fa_c1
        },
        176: {
            1: fa_d1,
            2: fa_e1
        },
        177: {
            1: fa_d1,
            2: fa_e1
        },
        178: {
            1: fa_d1,
            2: fa_e1
        },
        179: {
            1: fa_d1,
            2: fa_e1
        },
        358: {
            1: fa_x1,
            2: fa_y1
        },
        359: {
            1: fa_x1,
            2: fa_y1
        },
        360: {
            1: fa_x1,
            2: fa_y1
        },
        361: {
            1: fa_x1,
            2: fa_y1
        },
        13: {
            1: fa_b1,
            2: fa_c1
        },
        14: {
            1: fa_b1,
            2: fa_c1
        },
        15: {
            1: fa_b1,
            2: fa_c1
        },
        16: {
            1: fa_b1,
            2: fa_c1
        },
        172: {
            1: fa_d1,
            2: fa_e1
        },
        173: {
            1: fa_d1,
            2: fa_e1
        },
        174: {
            1: fa_d1,
            2: fa_e1
        },
        175: {
            1: fa_d1,
            2: fa_e1
        },
        281: {
            1: fa_d1,
            2: fa_e1
        },
        137: {
            1: fa_d1,
            2: fa_e1
        },
        616: {
            1: fa_h1,
            2: fa_i1
        },
        617: {
            1: fa_h1,
            2: fa_i1
        },
        618: {
            1: fa_h1,
            2: fa_i1
        },
        619: {
            1: fa_h1,
            2: fa_i1
        },
        620: {
            1: fa_h1,
            2: fa_i1
        },
        891: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2,
            4: fa_h2
        },
        26: {
            1: fa_n14,
            2: fa_o14
        },
        200: {
            1: fa_d1,
            2: fa_e1
        },
        143: {
            1: fa_d1,
            2: fa_e1
        },
        187: {
            1: fa_d1,
            2: fa_e1
        },
        371: {
            1: fa_x1,
            2: fa_y1
        },
        571: {
            1: fa_h1,
            2: fa_i1
        },
        928: {
            1: fa_s3,
            2: fa_l6,
            3: fa_m6,
            4: fa_n6,
            5: fa_o6,
            6: fa_p6,
            7: fa_q6,
            8: fa_r6
        },
        934: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_r6
        },
        88: {
            1: fa_f1,
            2: fa_g1
        },
        910: {
            1: fa_w6,
            2: fa_x6,
            3: fa_y6,
            4: fa_z6
        },
        917: {
            1: fa_a7,
            2: fa_b7,
            3: fa_p14,
            4: fa_d7,
            5: fa_e7,
            6: fa_q14
        },
        936: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_y5
        }
    },
    8: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        656: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        698: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        198: {
            1: fa_d1,
            2: fa_e1
        },
        673: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        674: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        675: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        676: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    27: {
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    28: {
        403: {
            1: fa_x1,
            2: fa_y1
        },
        615: {
            1: fa_h1,
            2: fa_i1
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        935: {
            1: fa_w9,
            2: fa_x9,
            3: fa_g13,
            4: fa_h13,
            5: fa_i13,
            6: fa_r14,
            7: fa_u9,
            8: fa_v9,
            9: fa_e3,
            10: fa_e13,
            11: fa_s6,
            12: fa_s14
        },
        612: {
            1: fa_l1,
            2: fa_m1
        },
        613: {
            1: fa_l1,
            2: fa_m1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    }
};

let periodConfig = {
    2: {
        200: 'Not Started',
        201: 'First Game',
        208: 'End',
        207: 'Seventh Game',
        206: 'Sixth Game',
        205: 'Fifth Game',
        204: 'Fourth Game',
        203: 'Third Game',
        202: 'Second Game'
    },
    3: {
        300: 'Not Started',
        301: 'First Set',
        302: 'Second Set',
        303: 'Third Set',
        304: 'End'
    },
    4: {
        401: 'First Set',
        400: 'Not Started',
        407: 'Golden Set',
        402: 'Second Set',
        406: 'End',
        405: 'Fifth Set',
        404: 'Fourth Set',
        403: 'Third Set'
    },
    5: {
        501: 'First round',
        500: 'Not Started',
        502: 'Second round',
        513: 'Match finished',
        512: 'Twelfth round',
        511: 'Eleventh round',
        510: 'Tenth round',
        509: 'Ninth round',
        508: 'Eighth round',
        507: 'Seventh round',
        506: 'Sixth round',
        505: 'Fifth round',
        504: 'Fourth round',
        503: 'Third round'
    },
    6: {
        602: 'Second Set',
        601: 'First Set',
        600: 'Not Started',
        603: 'Third Set',
        606: 'End',
        605: 'Fifth Set',
        604: 'Fourth Set'
    },
    7: {
        709: 'Shootout',
        708: 'End of Second Extra Time',
        707: 'Second Extra Time',
        706: 'End of First Extra Time',
        705: 'First Extra Time',
        704: 'Full Time',
        703: 'Second Half',
        702: 'Half Time',
        701: 'First Half',
        700: 'Not Started',
        710: 'Match Ended'
    },
    8: {
        800: 'Not Started',
        801: 'First Quarter',
        802: 'Pause',
        803: 'Second Quater',
        804: 'Intermission',
        810: 'End',
        806: 'Pause',
        807: 'Fourth Quater',
        808: 'Pause',
        809: 'Overtime',
        805: 'Third Quarter'
    },
    9: {
        900: 'Not Started',
        901: 'First Half',
        902: 'Half Time',
        903: 'Second Half',
        904: 'End'
    },
    12: {
        1200: 'Not Started',
        1201: 'First Half',
        1202: 'Half Time',
        1203: 'Second Half',
        1204: 'End'
    },
    18: {
        1800: 'Not Started',
        1801: 'First Period',
        1802: 'First Intermission',
        1803: 'Second Period',
        1804: 'Second Intermission',
        1810: 'End',
        1806: 'End of Regulation Time',
        1807: 'Overtime',
        1808: 'End of Overtime',
        1809: 'Shootout',
        1805: 'Third Period'
    },
    19: {
        1900: 'Not Started',
        1901: 'First Half',
        1902: 'Half Time',
        1903: 'Second Half',
        1904: 'Full Time',
        1905: 'End'
    },
    20: {
        2000: 'Not Started',
        2001: 'First',
        2002: 'First Fire Line',
        2003: 'Second Lap',
        2004: 'Second Fire Line',
        2005: 'Third Lap',
        2006: 'Third Fire Line',
        2007: 'Fourth Lap',
        2008: 'Fourth Fire Line',
        2009: 'Fifth Lap',
        2010: 'Fifth Fire Line',
        2011: 'Sixth Lap',
        2012: 'Sixth Fire Line',
        2013: 'Seventh Lap',
        2014: 'Seventh Fire Line',
        2015: 'Eighth Lap',
        2016: 'Eighth Fire Line',
        2017: 'End'
    },
    28: {
        2800: 'Not Started',
        2801: 'Regular Time',
        2802: 'End'
    },
    29: {
        2953: '27th Frame',
        2954: 'Intermission',
        2955: '28th Frame',
        2956: 'Intermission',
        2957: '29th Frame',
        2958: 'Intermission',
        2959: '30th Frame',
        2960: 'Intermission',
        2961: '31st Frame',
        2962: 'Intermission',
        2963: '32nd Frame',
        2964: 'Intermission',
        2965: '33rd Frame',
        2966: 'Intermission',
        2967: '34th Frame',
        2968: 'Intermission',
        2969: '35th Frame',
        2970: 'Intermission',
        2971: '36th Frame',
        2972: 'Intermission',
        2973: '37th Frame',
        2974: 'End',
        2900: 'Not Started',
        2901: '1st Frame',
        2902: 'Intermission',
        2903: '2nd Frame',
        2904: 'Intermission',
        2905: '3rd Frame',
        2906: 'Intermission',
        2907: '4th Frame',
        2908: 'Intermission',
        2909: '5th Frame',
        2910: 'Intermission',
        2911: '6th Frame',
        2912: 'Intermission',
        2913: '7th Frame',
        2914: 'Intermission',
        2915: '8th Frame',
        2916: 'Intermission',
        2917: '9th Frame',
        2918: 'Intermission',
        2919: '10th Frame',
        2920: 'Intermission',
        2921: '11th Frame',
        2922: 'Intermission',
        2923: '12th Frame',
        2924: 'Intermission',
        2925: '13th Frame',
        2926: 'Intermission',
        2927: '14th Frame',
        2928: 'Intermission',
        2929: '15th Frame',
        2930: 'Intermission',
        2931: '16th Frame',
        2932: 'Intermission',
        2933: '17th Frame',
        2934: 'Intermission',
        2935: '18th Frame',
        2936: 'Intermission',
        2937: '19th Frame',
        2938: 'Intermission',
        2939: '20th Frame',
        2940: 'Intermission',
        2941: '21st Frame',
        2942: 'Intermission',
        2943: '22nd Frame',
        2944: 'Intermission',
        2945: '23rd Frame',
        2946: 'Intermission',
        2947: '24th Frame',
        2948: 'Intermission',
        2949: '25th Frame',
        2950: 'Intermission',
        2951: '26th Frame',
        2952: 'Intermission'
    },
    30: {
        3000: 'Not Started',
        3001: 'First Period',
        3002: 'First Intermission',
        3003: 'Second Period',
        3004: 'Second Intermission',
        3010: 'End',
        3006: 'End of Regulation Time',
        3007: 'Overtime',
        3008: 'End of Overtime',
        3009: 'Shootout',
        3005: 'Third Period'
    },
    31: {
        3100: 'Not Started',
        3101: 'First Quarter',
        3102: 'Pause',
        3103: 'Second Quarter',
        3104: 'Intermission',
        3110: 'End',
        3106: 'Pause',
        3107: 'Fourth Quarter',
        3108: 'Pause',
        3109: 'Overtime',
        3105: 'Third Quarter'
    },
    32: {
        3200: 'Not Started',
        3201: 'First Game',
        3202: 'Second Game',
        3203: 'Third Game',
        3204: 'End'
    },
    34: {
        3400: 'Not started',
        3401: 'First Half',
        3402: 'Half Time',
        3403: 'Second Half',
        3404: 'Full Time',
        3409: 'Shootout',
        3405: 'First Extra Time',
        3406: 'End of First Extra Time',
        3407: 'Second Extra Time',
        3408: 'End of Second Extra Time',
        3410: 'Match Ended'
    },
    35: {
        3500: 'Not Started',
        3501: 'First Half',
        3502: 'Half Time',
        3503: 'Second Half',
        3504: 'Full Time'
    },
    36: {
        3609: 'Shootout',
        3608: 'End of Overtime',
        3607: 'Overtime',
        3606: 'End of Regulation Time',
        3605: 'Third Period',
        3604: 'Second Intermission',
        3603: 'Second Period',
        3602: 'First Intermission',
        3601: 'First Period',
        3600: 'Not Started',
        3610: 'End'
    },
    37: {
        3700: 'Not Started',
        3701: 'End'
    },
    38: {
        3800: 'Not Started',
        3801: 'End'
    },
    39: {
        3900: 'Not Started',
        3901: 'End',
        3902: 'First round',
        3903: 'Second round',
        3904: 'Third round',
        3905: 'Fourth round',
        3906: 'Fifth round',
    },
    40: {
        4000: 'Not Started',
        4001: 'End'
    },
    41: {
        4105: 'Overtime',
        4104: 'Second intermission',
        4103: 'Second half',
        4102: 'First intermission',
        4100: 'Not Started',
        4101: 'First half',
        4106: 'End'
    },
    42: {
        4205: 'Fifth map',
        4204: 'Fourth map',
        4203: 'Third map',
        4202: 'Second map',
        4200: 'Not Started',
        4201: 'First map',
        4206: 'End'
    }
};

export function getGroupName(sportId, groupType) {
    if (groupConfig !== undefined &&
        groupConfig[sportId] !== undefined) {
        return groupConfig[sportId][groupType];
    }

    return undefined;
}

export function getSlotName(sportId, match, slot) {
    let func;

    if (slotConfig !== undefined &&
       slotConfig[sportId] !== undefined) {
        func = slotConfig[sportId][slot.type];
    }

    if (func === undefined) {
        return undefined; 
    }

    return func(match, slot);
}

export function getOutcomeName(sportId, outcome, match) {
    let func;

    if (baseOutcomeConfig !== undefined &&
        baseOutcomeConfig[sportId] !== undefined &&
        baseOutcomeConfig[sportId]) {
        func = baseOutcomeConfig[sportId][outcome.type];
    }

    if (outcomeConfig !== undefined &&
        outcomeConfig[sportId] !== undefined &&
        outcomeConfig[sportId][outcome.type] !== undefined) {
        func = outcomeConfig[sportId][outcome.type];
    }

    if (func === undefined) {
        return undefined;
    }

    return func(match, outcome);
}

export function getRateName(sportId, outcome, factorType, match) {
    let func;

    if (baseFactorNameConfig !== undefined &&
        baseFactorNameConfig[sportId] !== undefined &&
        baseFactorNameConfig[sportId][outcome.type] !== undefined) {
        func = baseFactorNameConfig[sportId][outcome.type][factorType];
    }

    if (func === undefined) {
        return undefined;
    }

    return func(match, outcome);
}

export function getMatchInfoText(matchInfoType) {
    switch(matchInfoType) {
        case 1:
            return "Match not started";
        case 2:
            return "Match finished";
        case 3:
            return "Intermission";
        case 4:
            return "Full time";
        case 5:
            return "First extra time finished";
        case 6:
            return "Penalty series";
    }

    return "";
}

export function getPeriodName(sportId, periodId) {
    if (periodConfig !== undefined && periodConfig[sportId] !== undefined) {
        return  periodConfig[sportId][periodId];
    }

    return undefined;
}

export function getFoulsText() {
    return "Fouls";
}

export function getTimeoutText() {
    return "Timeout";
}


// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/localization/en.js